import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Airline = {
  __typename?: 'Airline';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  terminal?: Maybe<AirlineTerminal>;
};

export type AirlineTerminal = {
  __typename?: 'AirlineTerminal';
  domesticArrival?: Maybe<Scalars['String']['output']>;
  domesticDeparture?: Maybe<Scalars['String']['output']>;
  internationalArrival?: Maybe<Scalars['String']['output']>;
  internationalDeparture?: Maybe<Scalars['String']['output']>;
};

export type AttachCharterProfileResponse = MutationResponse & {
  __typename?: 'AttachCharterProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AttachCouponResponse = MutationResponse & {
  __typename?: 'AttachCouponResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AttachGroupProfileResponse = MutationResponse & {
  __typename?: 'AttachGroupProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AttachSalesProfileResponse = MutationResponse & {
  __typename?: 'AttachSalesProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Auth = {
  __typename?: 'Auth';
  token?: Maybe<Scalars['String']['output']>;
};

/** Main input type for book mutation */
export type BookBookingType = {
  /** Contact information for the booking */
  contact?: InputMaybe<BookContactType>;
  /** Epic Pass ID */
  epicPassId?: InputMaybe<Scalars['String']['input']>;
  /** ID number */
  idNumber?: InputMaybe<Scalars['String']['input']>;
  /** Itinerary ID (if provided, will be used; otherwise omitted from Bridge request) */
  itineraryId?: InputMaybe<Scalars['String']['input']>;
  /** Array of reservation legs */
  legs: Array<InputMaybe<ResType>>;
  /** Who made the booking */
  madeBy?: InputMaybe<MadeByType>;
  /** Payment information */
  payment?: InputMaybe<PaymentType>;
};

/** Input type for booking contact information */
export type BookContactType = {
  altPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for credit card information */
export type BookCreditCardType = {
  /** Billing address */
  address?: InputMaybe<Scalars['String']['input']>;
  /** CVV (for temporary tokens) */
  cvv?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted card number */
  encryptedCardNumber?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted expiry month */
  encryptedExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted expiry year */
  encryptedExpiryYear?: InputMaybe<Scalars['String']['input']>;
  /** Encrypted security code */
  encryptedSecurityCode?: InputMaybe<Scalars['String']['input']>;
  /** Expiration date */
  expiration?: InputMaybe<Scalars['String']['input']>;
  /** Cardholder name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of card number */
  numberLast4?: InputMaybe<Scalars['String']['input']>;
  /** Billing postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Processor ID */
  processorId?: InputMaybe<Scalars['Int']['input']>;
  /** Reference ID */
  refId?: InputMaybe<Scalars['String']['input']>;
  /** Credit card token */
  token?: InputMaybe<Scalars['String']['input']>;
  /** Token type (e.g., "temp" for temporary tokens) */
  tokenType?: InputMaybe<Scalars['String']['input']>;
  /** Card type code */
  typeCode?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for flight information */
export type BookFlightType = {
  airline?: InputMaybe<Scalars['String']['input']>;
  flightCity?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  flightTime?: InputMaybe<Scalars['String']['input']>;
  flightType?: InputMaybe<Scalars['String']['input']>;
  terminal?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for payment items on a leg */
export type BookLegPaymentItemType = {
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for leg payments (points/frequent rider) */
export type BookLegPaymentsType = {
  amountDue?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<InputMaybe<BookLegPaymentItemType>>>;
  totalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** Input type for location details */
export type BookLocType = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  crossStreet?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<LatLngInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for passenger details */
export type BookPassengerDetailsType = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Response type for book mutation */
export type BookPayload = MutationResponse & {
  __typename?: 'BookPayload';
  /** General error message */
  error?: Maybe<Scalars['String']['output']>;
  /** Type of error if any */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Itinerary ID for the booking */
  itineraryId?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Errors for each reservation */
  resErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** IDs of created reservations */
  resIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input type for booking stops */
export type BookStopType = {
  comments?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<BookLocType>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Bridge = {
  __typename?: 'Bridge';
  address: Scalars['String']['output'];
  bridgeType?: Maybe<Scalars['Int']['output']>;
  exiRestartTOD?: Maybe<Scalars['String']['output']>;
  exiVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastCheckTime?: Maybe<Scalars['String']['output']>;
  log: Array<BridgeLog>;
  parentId?: Maybe<Scalars['Int']['output']>;
  portNumber: Scalars['Int']['output'];
  server: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  siteIds?: Maybe<Array<Scalars['String']['output']>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BridgeLog = {
  __typename?: 'BridgeLog';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type CancelResPayload = MutationResponse & {
  __typename?: 'CancelResPayload';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum CardType {
  Amex = 'amex',
  Cup = 'cup',
  Diners = 'diners',
  Discover = 'discover',
  Enroute = 'enroute',
  Jcb = 'jcb',
  Mcard = 'mcard',
  Visa = 'visa'
}

/** A single check-in option returned by verifyRes for apps that support check-in */
export type CheckInOption = {
  __typename?: 'CheckInOption';
  /** The button label text */
  buttonCaption: Scalars['String']['output'];
  /** The command identifier (e.g., 'ReadyToGo', 'SoonToGo') - optional info */
  command?: Maybe<Scalars['String']['output']>;
  /** The hotkey ID to send to processHotkey */
  hotkeyId: Scalars['Int']['output'];
  /** The descriptive label explaining this option */
  label: Scalars['String']['output'];
};

/** Check-in options container returned when appName supports check-in */
export type CheckInOptions = {
  __typename?: 'CheckInOptions';
  /** Available check-in options for the user to select from */
  options: Array<CheckInOption>;
  /** Human-readable reservation summary */
  resSummary?: Maybe<Scalars['String']['output']>;
};

export enum CheckoutPickupTimeMode {
  /** Manual - Allow user to manually enter pickup time */
  Manual = 'manual',
  /** Normal - Show list of available pickup times */
  Normal = 'normal'
}

export type ClearBridgeCacheInput = {
  command?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['String']['input'];
};

export type ClearBridgeCacheResponse = MutationResponse & {
  __typename?: 'ClearBridgeCacheResponse';
  command: Scalars['String']['output'];
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Colors = {
  __typename?: 'Colors';
  id: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  primaryHover: Scalars['String']['output'];
  primaryText: Scalars['String']['output'];
};

export enum ConfigMode {
  Clientcenter = 'CLIENTCENTER'
}

export type Configuration = {
  __typename?: 'Configuration';
  allowRouteLevelLocations: Scalars['Boolean']['output'];
  cashEnabled: Scalars['Boolean']['output'];
  creditCardCardsNotAccepted: Array<CardType>;
  creditCardEnabled: Scalars['Boolean']['output'];
  creditCardExternalUrl: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** @deprecated Use customerRequestMode instead */
  customerRequestEnabled: Scalars['Boolean']['output'];
  customerRequestMode: Scalars['Int']['output'];
  dateFormat: Scalars['String']['output'];
  dateOnlyBookingMode: Scalars['Boolean']['output'];
  defaultCcProcessorId: Scalars['Int']['output'];
  defaultPaymentType: Scalars['String']['output'];
  defaultRoundTrip: Scalars['Boolean']['output'];
  defaultSearchCenter: MapPoint;
  defaultServiceArea: Scalars['Int']['output'];
  directBillEnabled: Scalars['Boolean']['output'];
  disableProfileCreditCards: Scalars['Boolean']['output'];
  disableProfileLocations: Scalars['Boolean']['output'];
  enableFrequentRiderPurchase: Scalars['Boolean']['output'];
  enablePassengerDetails: Scalars['Boolean']['output'];
  enableProfileLinkedGroups: Scalars['Boolean']['output'];
  enableWebIdForLogin: Scalars['Boolean']['output'];
  epicPassEnabled: Scalars['Boolean']['output'];
  googleAnalyticsId: Scalars['String']['output'];
  googleApiKey: Scalars['String']['output'];
  googleMapsDisabled?: Maybe<Scalars['Boolean']['output']>;
  gratuityPercentages: Array<GratuityPercentage>;
  groupLoginEnabled: Scalars['Boolean']['output'];
  gtmId?: Maybe<Scalars['String']['output']>;
  hideCreateProfileSuggestion: Scalars['Boolean']['output'];
  hideDropoffTime: Scalars['Boolean']['output'];
  hideExtraStopsLocation: Scalars['Boolean']['output'];
  hideFlightNumber: Scalars['Boolean']['output'];
  hideFlightType: Scalars['Boolean']['output'];
  hideGroupProfileActions: Scalars['Boolean']['output'];
  hideLoginSuggestion: Scalars['Boolean']['output'];
  hidePickupTimeFlight: Scalars['Boolean']['output'];
  hideTerminal: Scalars['Boolean']['output'];
  hideUserProfileActions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageBaseUrl: Scalars['String']['output'];
  initialDisplayedPickupTimes: Scalars['Int']['output'];
  jobType: Scalars['Int']['output'];
  linkedGroupFields: Array<Scalars['String']['output']>;
  locationBiasRadius: Scalars['Int']['output'];
  locationBiasStrictBounds: Scalars['Boolean']['output'];
  locationMode: LocationMode;
  locationTypeOptions: Array<LocationTypeOption>;
  lockGroupProfile: Scalars['Boolean']['output'];
  logoUrl: Scalars['String']['output'];
  marketingCodes: Array<FieldValue>;
  marketingCodes2: Array<FieldValue>;
  marketingCodes3: Array<FieldValue>;
  openReservationMode: OpenResMode;
  passengerDetailsRequired: Scalars['Boolean']['output'];
  pickupTimesDisplayOrder: Scalars['Int']['output'];
  profileLocationTypesList: Array<ProfileLocationTypeOption>;
  pudsAsPeople: Scalars['Boolean']['output'];
  requireCardOnFileCvv: Scalars['Boolean']['output'];
  requireLoginForBooking: Scalars['Boolean']['output'];
  resVerifyValidationModes: Array<FieldValue>;
  shopperReference?: Maybe<Scalars['String']['output']>;
  showCcaddress: Scalars['Boolean']['output'];
  showCcvv: Scalars['Boolean']['output'];
  showCczip: Scalars['Boolean']['output'];
  showCheckoutPointsSection: Scalars['Boolean']['output'];
  showCreditCardOnDirectBill: Scalars['Boolean']['output'];
  showExtraStopsComments: Scalars['Boolean']['output'];
  showExtraStopsName: Scalars['Boolean']['output'];
  showExtraStopsPudDirections: Scalars['Boolean']['output'];
  showGratuity: Scalars['Boolean']['output'];
  showMarketingCode: Scalars['Boolean']['output'];
  showMarketingCode2: Scalars['Boolean']['output'];
  showMarketingCode3: Scalars['Boolean']['output'];
  showMarketingCode3InCc: Scalars['Boolean']['output'];
  showProfileFrequentRiderPoints: Scalars['Boolean']['output'];
  singleServiceAutoSelect: Scalars['Boolean']['output'];
  specialInfoPassengerAlias?: Maybe<Scalars['String']['output']>;
  timeFormat: TimeFormat;
  topLocationsMode: TopLocationsMode;
  universalLocationsMode: Scalars['Boolean']['output'];
  useJsonCart: Scalars['Boolean']['output'];
};

export type ContactUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  telephone2?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type ConvertResPayload = MutationResponse & {
  __typename?: 'ConvertResPayload';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateDriverShiftInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  comments2?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['Int']['input'];
  endMilage?: InputMaybe<Scalars['Float']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  scheduledEndTime: Scalars['String']['input'];
  scheduledStartTime: Scalars['String']['input'];
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startMilage?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  vehicleId: Scalars['Int']['input'];
};

export type CreateDriverShiftPayload = MutationResponse & {
  __typename?: 'CreateDriverShiftPayload';
  driverShift?: Maybe<DriverShift>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Defaults = {
  __typename?: 'Defaults';
  creditCards?: Maybe<Array<TokenizedCreditCard>>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  gratuityPercents?: Maybe<Array<Scalars['Float']['output']>>;
  id: Scalars['ID']['output'];
  marketingCode?: Maybe<Scalars['String']['output']>;
  marketingCode2?: Maybe<Scalars['String']['output']>;
  marketingCode3?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  telephone2?: Maybe<Scalars['String']['output']>;
};

export type Desktop = {
  __typename?: 'Desktop';
  fileName?: Maybe<Scalars['String']['output']>;
  hotkeyAlias?: Maybe<Scalars['String']['output']>;
  hotkeyColumnAlias?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  remoteKey?: Maybe<Scalars['String']['output']>;
  rowDetailTemplate?: Maybe<Scalars['String']['output']>;
  rowsPerPage?: Maybe<Scalars['Int']['output']>;
  showRefresh?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DesktopsReply = {
  __typename?: 'DesktopsReply';
  desktops?: Maybe<Array<Desktop>>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type DetachAllProfilesResponse = MutationResponse & {
  __typename?: 'DetachAllProfilesResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachCharterProfileResponse = MutationResponse & {
  __typename?: 'DetachCharterProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachCouponResponse = MutationResponse & {
  __typename?: 'DetachCouponResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachGroupProfileResponse = MutationResponse & {
  __typename?: 'DetachGroupProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DetachSalesProfileResponse = MutationResponse & {
  __typename?: 'DetachSalesProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Driver information */
export type Driver = {
  __typename?: 'Driver';
  displayName: Scalars['String']['output'];
  employeeId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type DriverShift = {
  __typename?: 'DriverShift';
  comments?: Maybe<Scalars['String']['output']>;
  comments2?: Maybe<Scalars['String']['output']>;
  confirmed?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['Int']['output'];
  endMilage?: Maybe<Scalars['Float']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastConfirmedTod?: Maybe<Scalars['String']['output']>;
  reportTod?: Maybe<Scalars['String']['output']>;
  scheduledEndTime: Scalars['String']['output'];
  scheduledStartTime: Scalars['String']['output'];
  startLocation?: Maybe<Scalars['String']['output']>;
  startMilage?: Maybe<Scalars['Float']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
  vehicleName?: Maybe<Scalars['String']['output']>;
};

export type EpicPassReturn = {
  __typename?: 'EpicPassReturn';
  valid: Scalars['Boolean']['output'];
};

/** Return type for fare key lookup query */
export type FareKeyLookupReturn = {
  __typename?: 'FareKeyLookupReturn';
  /** Error indicator */
  error?: Maybe<Scalars['Boolean']['output']>;
  /** Detailed error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** JSON string of the request sent to backend (for debugging) */
  fklRequest?: Maybe<Scalars['String']['output']>;
  /** JSON string of the response from backend (for debugging) */
  fklResponse?: Maybe<Scalars['String']['output']>;
  /** Primary location match */
  location?: Maybe<Location>;
  /** Type of lookup performed */
  lookupType?: Maybe<Scalars['Int']['output']>;
  /** Array of nearby location matches */
  nearbyLocations?: Maybe<Array<Location>>;
};

export type FieldValue = {
  __typename?: 'FieldValue';
  field: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FixedLocationType = {
  __typename?: 'FixedLocationType';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  locationCount: Scalars['Int']['output'];
  locations: Array<Location>;
  type: Scalars['String']['output'];
  typeString: Scalars['String']['output'];
};

export type FrequentRiderPoints = {
  __typename?: 'FrequentRiderPoints';
  availablePoints?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  programId?: Maybe<Scalars['Int']['output']>;
  totalCredits?: Maybe<Scalars['Float']['output']>;
  totalDebits?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<Array<FrequentRiderPointsTransaction>>;
};

export type FrequentRiderPointsTransaction = {
  __typename?: 'FrequentRiderPointsTransaction';
  comments?: Maybe<Scalars['String']['output']>;
  debitCredit?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  expirationTod?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  redemptionType?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['String']['output']>;
};

export type FrequentRiderProgram = {
  __typename?: 'FrequentRiderProgram';
  cost: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentPointsPerFareUnit?: Maybe<Scalars['Int']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  redemptionDefaultDate?: Maybe<Scalars['String']['output']>;
  redemptionDuration?: Maybe<Scalars['String']['output']>;
  redemptionMaxUsage?: Maybe<Scalars['Int']['output']>;
  redemptionThreshold?: Maybe<Scalars['Int']['output']>;
  redemptionType: Scalars['String']['output'];
  sellFarePer?: Maybe<Scalars['Float']['output']>;
  sellMaxQuantity?: Maybe<Scalars['Int']['output']>;
  sellMinQuantity?: Maybe<Scalars['Int']['output']>;
  sellType?: Maybe<ProgramSellType>;
};

/** Response type for frequent rider program purchase mutation */
export type FrequentRiderProgramPurchasePayload = MutationResponse & {
  __typename?: 'FrequentRiderProgramPurchasePayload';
  /** Error type for categorizing the error */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** The reservation ID if the purchase was successful */
  resId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Reservation details for frequent rider program purchase */
export type FrequentRiderProgramPurchaseResType = {
  /** Marketing codes for tracking */
  marketingCodes?: InputMaybe<MarketingCodesType>;
};

/**
 * Input type for frequent rider program purchase booking details
 * Matches Rails Types::FrequentRiderProgramPurchaseType
 */
export type FrequentRiderProgramPurchaseType = {
  /** Contact information for the purchase */
  contact?: InputMaybe<BookContactType>;
  /** Payment information for the purchase */
  payment: PaymentType;
  /** Marketing codes for tracking */
  res?: InputMaybe<FrequentRiderProgramPurchaseResType>;
};

export type Gdf = {
  __typename?: 'GDF';
  columnDefinitions?: Maybe<Array<GdfColumnDefinition>>;
  data?: Maybe<Array<GdfDataRow>>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  properties?: Maybe<GdfProperties>;
};

export type GdfCellStyleEntry = {
  __typename?: 'GDFCellStyleEntry';
  field: Scalars['String']['output'];
  style: GdfStyle;
};

export type GdfColumnDefinition = {
  __typename?: 'GDFColumnDefinition';
  dataFormat?: Maybe<Scalars['String']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  dynaFilterType?: Maybe<Scalars['Int']['output']>;
  field: Scalars['String']['output'];
  hidden?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type GdfDataRow = {
  __typename?: 'GDFDataRow';
  cellStyles?: Maybe<Array<GdfCellStyleEntry>>;
  rowStyle?: Maybe<GdfStyle>;
  values: Array<Scalars['String']['output']>;
};

export type GdfProperties = {
  __typename?: 'GDFProperties';
  fileName: Scalars['String']['output'];
  gridType: Scalars['String']['output'];
  quickFilters?: Maybe<Array<GdfQuickFilter>>;
};

export type GdfQuickFilter = {
  __typename?: 'GDFQuickFilter';
  caption: Scalars['String']['output'];
  filterIndex: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type GdfStyle = {
  __typename?: 'GDFStyle';
  backColor: Scalars['String']['output'];
  bold: Scalars['Boolean']['output'];
  foreColor: Scalars['String']['output'];
  italic: Scalars['Boolean']['output'];
};

export type GratuityPercentage = {
  __typename?: 'GratuityPercentage';
  label?: Maybe<Scalars['String']['output']>;
  percent: Scalars['Float']['output'];
};

export type Hotkey = {
  __typename?: 'Hotkey';
  bgColor?: Maybe<Scalars['String']['output']>;
  caption: Scalars['String']['output'];
  functionCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  params?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
  viewAlias: Scalars['String']['output'];
};

/**
 * One open field sent with a processHotkey call. Sent as a first-class JSON
 * field on the wire alongside the core fields.
 */
export type HotkeyFieldInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 * Message-context fields sent with a processHotkey call (e.g. from the
 * messages grid composer). Each field is sent as a first-class JSON field on
 * the wire instead of being encoded into additionalParamString.
 */
export type HotkeyMessageInput = {
  /** The text of the message being sent */
  messageText?: InputMaybe<Scalars['String']['input']>;
  /** Identifier for the sender (e.g. the driver display name) */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type HotkeysReply = {
  __typename?: 'HotkeysReply';
  error?: Maybe<Scalars['String']['output']>;
  hotkeys: Array<Hotkey>;
  id: Scalars['String']['output'];
};

/** Input type for field-value pairs used in fare components, passengers, and service extras */
export type InputFieldValueType = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type KioskBookingsConfig = {
  __typename?: 'KioskBookingsConfig';
  defaultStandardTemplateId?: Maybe<Scalars['Int']['output']>;
  dropoffLocations?: Maybe<KioskDropoffLocationsConfig>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  pickupTime?: Maybe<KioskPickupTimeConfig>;
  requireStandardTemplates?: Maybe<Scalars['Boolean']['output']>;
  standardTemplateFilter?: Maybe<Scalars['String']['output']>;
};

export type KioskCheckInConfig = {
  __typename?: 'KioskCheckInConfig';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type KioskConfig = {
  __typename?: 'KioskConfig';
  bookings?: Maybe<KioskBookingsConfig>;
  checkIn?: Maybe<KioskCheckInConfig>;
  id: Scalars['ID']['output'];
  webAppConfig?: Maybe<KioskWebAppConfig>;
};

/** Content type for kiosk application containing all available token fields */
export type KioskContent = {
  __typename?: 'KioskContent';
  id: Scalars['String']['output'];
  kioskBookBackButton?: Maybe<Scalars['String']['output']>;
  kioskBookButton?: Maybe<Scalars['String']['output']>;
  kioskBookContinueButton?: Maybe<Scalars['String']['output']>;
  kioskBookDropoffLabel?: Maybe<Scalars['String']['output']>;
  kioskBookDropoffPlaceholder?: Maybe<Scalars['String']['output']>;
  kioskBookEmailLabel?: Maybe<Scalars['String']['output']>;
  kioskBookNameLabel?: Maybe<Scalars['String']['output']>;
  kioskBookPassengerSection?: Maybe<Scalars['String']['output']>;
  kioskBookPhoneLabel?: Maybe<Scalars['String']['output']>;
  kioskBookSelectTemplate?: Maybe<Scalars['String']['output']>;
  kioskBookServiceSection?: Maybe<Scalars['String']['output']>;
  kioskBookSmsConsentLabel?: Maybe<Scalars['String']['output']>;
  kioskBookSubmitButton?: Maybe<Scalars['String']['output']>;
  kioskBookSuccessTitle?: Maybe<Scalars['String']['output']>;
  kioskBookTimeLabel?: Maybe<Scalars['String']['output']>;
  kioskBookTitle?: Maybe<Scalars['String']['output']>;
  kioskBookWarning?: Maybe<Scalars['String']['output']>;
  kioskCheckinButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinConfirmButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinEmailLabel?: Maybe<Scalars['String']['output']>;
  kioskCheckinFoundSubtitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinFoundTitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinResidLabel?: Maybe<Scalars['String']['output']>;
  kioskCheckinSearchAgainButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinSubmitButton?: Maybe<Scalars['String']['output']>;
  kioskCheckinSubtitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinSuccessTitle?: Maybe<Scalars['String']['output']>;
  kioskCheckinTitle?: Maybe<Scalars['String']['output']>;
  kioskErrCheckinFailed?: Maybe<Scalars['String']['output']>;
  kioskErrDropoffRequired?: Maybe<Scalars['String']['output']>;
  kioskErrEmailFormat?: Maybe<Scalars['String']['output']>;
  kioskErrEmailRequired?: Maybe<Scalars['String']['output']>;
  kioskErrNameRequired?: Maybe<Scalars['String']['output']>;
  kioskErrNoTemplates?: Maybe<Scalars['String']['output']>;
  kioskErrPhoneFormat?: Maybe<Scalars['String']['output']>;
  kioskErrPhoneRequired?: Maybe<Scalars['String']['output']>;
  kioskErrPickupTimeRequired?: Maybe<Scalars['String']['output']>;
  kioskErrResNotFound?: Maybe<Scalars['String']['output']>;
  kioskErrResidRequired?: Maybe<Scalars['String']['output']>;
  kioskErrSmsConsentRequired?: Maybe<Scalars['String']['output']>;
  kioskErrTemplatesLoad?: Maybe<Scalars['String']['output']>;
  kioskHeaderTitle?: Maybe<Scalars['String']['output']>;
  kioskLandingTitle?: Maybe<Scalars['String']['output']>;
  kioskNoFeaturesEnabled?: Maybe<Scalars['String']['output']>;
  kioskStartOverButton?: Maybe<Scalars['String']['output']>;
  kioskTimeoutContinueButton?: Maybe<Scalars['String']['output']>;
  kioskTimeoutWarningMessage?: Maybe<Scalars['String']['output']>;
  kioskTimeoutWarningTitle?: Maybe<Scalars['String']['output']>;
};

export type KioskDropoffLocation = {
  __typename?: 'KioskDropoffLocation';
  code: Scalars['String']['output'];
  fareType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type KioskDropoffLocationsConfig = {
  __typename?: 'KioskDropoffLocationsConfig';
  defaultDropoffLocationCode?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  locations?: Maybe<Array<KioskDropoffLocation>>;
};

export type KioskPickupTimeConfig = {
  __typename?: 'KioskPickupTimeConfig';
  requestedPickupTimeInterval?: Maybe<Scalars['Int']['output']>;
  requestedPickupTimeMaxMinutes?: Maybe<Scalars['Int']['output']>;
  requestedPickupTimeOffset?: Maybe<Scalars['Int']['output']>;
};

export type KioskWebAppConfig = {
  __typename?: 'KioskWebAppConfig';
  requireEmailAddress?: Maybe<Scalars['Boolean']['output']>;
  requirePhoneNumber?: Maybe<Scalars['Boolean']['output']>;
};

/** Latitude and longitude coordinates */
export type LatLng = {
  __typename?: 'LatLng';
  /** Latitude coordinate */
  lat: Scalars['Float']['output'];
  /** Longitude coordinate */
  lng: Scalars['Float']['output'];
};

/** Input type for latitude/longitude coordinates */
export type LatLngInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

/** Represents a location in the system */
export type Location = {
  __typename?: 'Location';
  /** Street address */
  address?: Maybe<Scalars['String']['output']>;
  /** Additional address details */
  addressDetails?: Maybe<Scalars['String']['output']>;
  /** City name */
  city?: Maybe<Scalars['String']['output']>;
  /** Location code */
  code: Scalars['String']['output'];
  /** Country code */
  country?: Maybe<Scalars['String']['output']>;
  /** County name */
  county?: Maybe<Scalars['String']['output']>;
  /** Cross street information */
  crossStreet?: Maybe<Scalars['String']['output']>;
  /** Location description */
  description?: Maybe<Scalars['String']['output']>;
  /** Directions to the location */
  directions?: Maybe<Scalars['String']['output']>;
  /** Display address generated from location fields */
  displayAddress?: Maybe<Scalars['String']['output']>;
  /** Display name for the location */
  displayName: Scalars['String']['output'];
  /** Distance from a reference point */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Fare key lookup request */
  fklRequest?: Maybe<Scalars['String']['output']>;
  /** Fare key lookup response */
  fklResponse?: Maybe<Scalars['String']['output']>;
  /** Full state name */
  fullState?: Maybe<Scalars['String']['output']>;
  /** Google Place ID for this location */
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  /** Location icons */
  icons?: Maybe<Array<Scalars['String']['output']>>;
  /** Unique identifier for the location */
  id: Scalars['String']['output'];
  /** Latitude and longitude coordinates */
  latLng?: Maybe<LatLng>;
  /** Location metadata */
  metadata: Scalars['String']['output'];
  /** Name of the location */
  name: Scalars['String']['output'];
  /** Raw JSON data from Bridge API (for debugging) */
  raw?: Maybe<Scalars['String']['output']>;
  /** Whether cross street is required */
  requireCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  /** Dispatching zone/sector */
  sector?: Maybe<Scalars['String']['output']>;
  /** Service areas this location belongs to */
  serviceAreas: Array<Scalars['Int']['output']>;
  /** Whether to show address details */
  showAddressDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show cross street for this location */
  showCrossStreet?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show flight date */
  showFlightDate: Scalars['Boolean']['output'];
  /** Whether to show flight number for this location */
  showFlightNumber: Scalars['Boolean']['output'];
  /** Whether to show flight type */
  showFlightType: Scalars['Boolean']['output'];
  /** State or province code */
  state?: Maybe<Scalars['String']['output']>;
  /** String representation (purpose unclear - from Rails) */
  string?: Maybe<Scalars['String']['output']>;
  /** Contact telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** Whether this is a transportation hub */
  transportationHub: Scalars['Boolean']['output'];
  /** Type of location (A=Airport, H=Hotel, P=Locality, etc.) */
  type: Scalars['String']['output'];
  /** Human-readable type string (airport, hotel, locality, etc.) */
  typeString: Scalars['String']['output'];
  /** Postal code */
  zip?: Maybe<Scalars['String']['output']>;
};

/** Paginated list of locations */
export type LocationList = {
  __typename?: 'LocationList';
  /** Array of locations */
  locations: Array<Location>;
  /** Total number of pages */
  pages: Scalars['Int']['output'];
  /** Total number of items */
  totalItems: Scalars['Int']['output'];
};

export enum LocationMode {
  All = 'all',
  AllLocations = 'all_locations',
  None = 'none',
  UseConfig = 'use_config'
}

export type LocationTypeOption = {
  __typename?: 'LocationTypeOption';
  image?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type LoginUserPayload = MutationResponse & {
  __typename?: 'LoginUserPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LoginUserProfileResponse = MutationResponse & {
  __typename?: 'LoginUserProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutUserProfileResponse = MutationResponse & {
  __typename?: 'LogoutUserProfileResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LogoutUserResponse = MutationResponse & {
  __typename?: 'LogoutUserResponse';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input type for who made the booking */
export type MadeByType = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type MapPoint = {
  __typename?: 'MapPoint';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

/** Input type for marketing codes */
export type MarketingCodesType = {
  marketingCode?: InputMaybe<Scalars['String']['input']>;
  marketingCode2?: InputMaybe<Scalars['String']['input']>;
  marketingCode3?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  attachCharterProfile?: Maybe<AttachCharterProfileResponse>;
  attachCoupon?: Maybe<AttachCouponResponse>;
  attachGroupProfile?: Maybe<AttachGroupProfileResponse>;
  attachSalesProfile?: Maybe<AttachSalesProfileResponse>;
  /** Create a new booking with one or more reservation legs */
  book: BookPayload;
  cancelRes: CancelResPayload;
  clearBridgeCache: ClearBridgeCacheResponse;
  convertRes: ConvertResPayload;
  createDriverShift?: Maybe<CreateDriverShiftPayload>;
  detachAllProfiles?: Maybe<DetachAllProfilesResponse>;
  detachCharterProfile?: Maybe<DetachCharterProfileResponse>;
  detachCoupon?: Maybe<DetachCouponResponse>;
  detachGroupProfile?: Maybe<DetachGroupProfileResponse>;
  detachSalesProfile?: Maybe<DetachSalesProfileResponse>;
  /**
   * Purchase a frequent rider program with points or passes
   * Matches Rails Mutations::FrequentRiderProgramPurchase
   */
  frequentRiderProgramPurchase?: Maybe<FrequentRiderProgramPurchasePayload>;
  loginUser?: Maybe<LoginUserPayload>;
  loginUserProfile?: Maybe<LoginUserProfileResponse>;
  logoutUser?: Maybe<LogoutUserResponse>;
  logoutUserProfile?: Maybe<LogoutUserProfileResponse>;
  /** Process a hotkey action */
  processHotkey: ProcessHotkeyPayload;
  /**
   * Process a PID (encrypted parameter string) from client center.
   * - pid: The encrypted PID string
   * - forceGroup: When true, treats group codes as groups even if they have a couponType
   */
  processPid: ProcessPidPayload;
  profileAdd?: Maybe<ProfileAddPayload>;
  /**
   * Create a quote booking for kiosk (no payment required)
   * Uses NEWQUOTE operation - customer pays later via SMS/QuickPay
   */
  quote: QuotePayload;
  rateMyRideSubmit?: Maybe<RateMyRideSubmitPayload>;
  refreshToken?: Maybe<RefreshTokenPayload>;
  repriceService?: Maybe<RepriceServicePayload>;
  savePassword?: Maybe<SavePasswordPayload>;
  savePasswordWithPid?: Maybe<SavePasswordWithPidPayload>;
  /**
   * Sends a password reset email to the specified user
   *
   * This mutation initiates the password reset process by sending an email
   * with a reset link to the user's registered email address.
   */
  sendPasswordReset: SendPasswordResetPayload;
  setPasswordForProfile?: Maybe<SetPasswordForProfilePayload>;
  /** Tokenize credit card information for secure temporary storage */
  tokenize: TokenizePayload;
  updateDriverShift?: Maybe<UpdateDriverShiftPayload>;
  updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  userProfileAddCc: UserProfileAddCcPayload;
  userProfileAddPud?: Maybe<UserProfileAddPudResponse>;
  userProfileAddValpayCc: UserProfileAddValpayCcPayload;
  userProfileDeleteCc: UserProfileDeleteCcPayload;
  /**
   * Delete a PUD (Preferred User Destination) from the user's profile.
   *
   * This mutation removes a saved pickup/dropoff location from the user's
   * list of preferred locations. The user profile is automatically determined
   * from the JWT authentication context.
   *
   * Note: This operation requires user authentication. The mutation will fail
   * if no valid user profile exists in the JWT context.
   */
  userProfileDeletePud: UserProfileDeletePudPayload;
  /**
   * Delete a credit card from a PUD (Preferred User Destination) in the user's profile.
   *
   * This mutation removes a saved credit card from a specific pickup/dropoff location
   * in the user's list of preferred locations. The user profile is automatically
   * determined from the JWT authentication context.
   *
   * Note: This operation requires user authentication. The mutation will fail
   * if no valid user profile exists in the JWT context.
   */
  userProfileDeletePudCc: UserProfileDeletePudCcPayload;
  /**
   * Link a user profile to a group with optional metadata.
   *
   * This mutation associates the authenticated user's profile with a group
   * and can store additional identifiers and custom data fields.
   * The user profile is automatically determined from the JWT authentication context.
   *
   * Note: This operation requires user authentication. The mutation will fail
   * if no valid user profile exists in the JWT context.
   */
  userProfileLinkGroup: UserProfileLinkGroupPayload;
  userProfileUpdatePud?: Maybe<UserProfileUpdatePudResponse>;
  validateUser?: Maybe<ValidateUserPayload>;
  verifyRes?: Maybe<VerifyResPayload>;
  /**
   * Verifies a reservation by email and returns check-in options.
   * Use this mutation when the user needs to select a check-in action.
   * After selection, call processHotkey with the chosen option's value.
   */
  verifyResForCheckIn?: Maybe<VerifyResForCheckInPayload>;
};


export type MutationAttachCharterProfileArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAttachCouponArgs = {
  couponCode: Scalars['String']['input'];
  legs?: InputMaybe<Array<ServicesInput>>;
};


export type MutationAttachGroupProfileArgs = {
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAttachSalesProfileArgs = {
  id: Scalars['Int']['input'];
};


export type MutationBookArgs = {
  booking: BookBookingType;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCancelResArgs = {
  resId: Scalars['Int']['input'];
};


export type MutationClearBridgeCacheArgs = {
  input?: InputMaybe<ClearBridgeCacheInput>;
};


export type MutationConvertResArgs = {
  resId: Scalars['Int']['input'];
};


export type MutationCreateDriverShiftArgs = {
  input: CreateDriverShiftInput;
};


export type MutationFrequentRiderProgramPurchaseArgs = {
  booking: FrequentRiderProgramPurchaseType;
  frpProgramCost?: InputMaybe<Scalars['Float']['input']>;
  frpProgramEndDate?: InputMaybe<Scalars['String']['input']>;
  frpProgramId: Scalars['Int']['input'];
  frpProgramQuantity?: InputMaybe<Scalars['Int']['input']>;
  frpProgramStartDate?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationLoginUserArgs = {
  appType: UserApp;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationLoginUserProfileArgs = {
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationProcessHotkeyArgs = {
  input: ProcessHotkeyInput;
};


export type MutationProcessPidArgs = {
  forceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProfileAddArgs = {
  input: ProfileAddInput;
};


export type MutationQuoteArgs = {
  alias: Scalars['String']['input'];
  booking: QuoteBookingType;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRateMyRideSubmitArgs = {
  submission: RateMyRideSubmitInput;
};


export type MutationRepriceServiceArgs = {
  recalcEntireFare?: InputMaybe<Scalars['Boolean']['input']>;
  res: ServicesInput;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSavePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationSavePasswordWithPidArgs = {
  password: Scalars['String']['input'];
  pid: Scalars['String']['input'];
};


export type MutationSendPasswordResetArgs = {
  resetPasswordUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationSetPasswordForProfileArgs = {
  email: Scalars['String']['input'];
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  profileId: Scalars['Int']['input'];
  telephone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTokenizeArgs = {
  ccAddress?: InputMaybe<Scalars['String']['input']>;
  ccExpiration: Scalars['String']['input'];
  ccName?: InputMaybe<Scalars['String']['input']>;
  ccNumber: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDriverShiftArgs = {
  input: UpdateDriverShiftInput;
};


export type MutationUpdateUserProfileArgs = {
  contact?: InputMaybe<ContactUpdateInput>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUserProfileAddCcArgs = {
  ccAddress?: InputMaybe<Scalars['String']['input']>;
  ccExpiration: Scalars['String']['input'];
  ccName: Scalars['String']['input'];
  ccNumber: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserProfileAddPudArgs = {
  location: ProfilePudInput;
};


export type MutationUserProfileAddValpayCcArgs = {
  ccCardHolderName?: InputMaybe<Scalars['String']['input']>;
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber: Scalars['String']['input'];
  encryptedExpiryMonth: Scalars['String']['input'];
  encryptedExpiryYear: Scalars['String']['input'];
  encryptedSecurityCode: Scalars['String']['input'];
};


export type MutationUserProfileDeleteCcArgs = {
  ccId?: InputMaybe<Scalars['Int']['input']>;
  ccLast4?: InputMaybe<Scalars['String']['input']>;
  ccRefId?: InputMaybe<Scalars['String']['input']>;
  ccToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserProfileDeletePudArgs = {
  locationId: Scalars['Int']['input'];
};


export type MutationUserProfileDeletePudCcArgs = {
  ccId: Scalars['Int']['input'];
  pudId: Scalars['Int']['input'];
};


export type MutationUserProfileLinkGroupArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  data1?: InputMaybe<Scalars['String']['input']>;
  data2?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  webId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserProfileUpdatePudArgs = {
  location: ProfilePudInput;
  pudId: Scalars['Int']['input'];
};


export type MutationValidateUserArgs = {
  appType: Scalars['String']['input'];
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationVerifyResArgs = {
  resId: Scalars['String']['input'];
  validationMode: Scalars['String']['input'];
  validationValue: Scalars['String']['input'];
};


export type MutationVerifyResForCheckInArgs = {
  email: Scalars['String']['input'];
  resId: Scalars['String']['input'];
};

export type MutationResponse = {
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum OpenResMode {
  Disabled = 'disabled',
  Enabled = 'enabled',
  EnabledCollectDate = 'enabled_collect_date'
}

/** Represents a passenger type with its configuration */
export type PassengerType = {
  __typename?: 'PassengerType';
  /** Field name identifier for the passenger type */
  fieldName: Scalars['String']['output'];
  /** Unique identifier for the passenger type (matches fieldName for Rails compatibility) */
  id: Scalars['ID']['output'];
  /** Human-readable label for the passenger type */
  label: Scalars['String']['output'];
  /** Maximum number of passengers allowed for this type */
  maxPassengers: Scalars['Int']['output'];
  /** Optional popup text for additional information */
  popup?: Maybe<Scalars['String']['output']>;
  /** Raw JSON response from the backend (for debugging/compatibility) */
  raw?: Maybe<Scalars['String']['output']>;
};

/** Input type for booking payment information */
export type PaymentType = {
  /** Optional charge to value for direct bill */
  chargeTo?: InputMaybe<Scalars['String']['input']>;
  /** Credit card information */
  creditCard?: InputMaybe<BookCreditCardType>;
  /** Shopper reference for tokenization */
  shopperReference?: InputMaybe<Scalars['String']['input']>;
  /** Payment type */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Payment type ID (e.g., "3" for DirectBill, "F" for FrequentRider) */
  typeId?: InputMaybe<Scalars['String']['input']>;
  /** Variance amount for edited reservations */
  variance?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents a pickup extra option with its charge and configuration */
export type PickupExtra = {
  __typename?: 'PickupExtra';
  /** Additional charge amount for this pickup extra */
  charge?: Maybe<Scalars['Float']['output']>;
  /** Whether this pickup extra is selected by default */
  default?: Maybe<Scalars['Boolean']['output']>;
  /** Display name of the pickup extra */
  name?: Maybe<Scalars['String']['output']>;
  /** Value identifier for the pickup extra */
  value?: Maybe<Scalars['String']['output']>;
};

/** Input type for processHotkey mutation */
export type ProcessHotkeyInput = {
  /**
   * Open key/value fields spread flat into the Bridge requestData (e.g.
   * template input values keyed by section id). Keys colliding with core wire
   * fields are dropped server-side.
   */
  additionalFields?: InputMaybe<Array<HotkeyFieldInput>>;
  /** Optional additional parameter string */
  additionalParamString?: InputMaybe<Scalars['String']['input']>;
  /** Optional grid type the hotkey was triggered from (omitted for non-grid contexts like the sidebar) */
  gridType?: InputMaybe<Scalars['Int']['input']>;
  /** The ID of the hotkey to process */
  hotkeyId: Scalars['Int']['input'];
  /** Optional message-context fields sent when the hotkey originates from a messages grid */
  message?: InputMaybe<HotkeyMessageInput>;
  /** Optional reference ID */
  referenceId?: InputMaybe<Scalars['Int']['input']>;
};

/** Response type for processHotkey mutation */
export type ProcessHotkeyPayload = MutationResponse & {
  __typename?: 'ProcessHotkeyPayload';
  /** Error type if the operation failed */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type ProcessPidPayload = MutationResponse & {
  __typename?: 'ProcessPidPayload';
  auth?: Maybe<Auth>;
  decryptedParams?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  contactInfo?: Maybe<ProfileContact>;
  creditCards?: Maybe<Array<Maybe<TokenizedCreditCard>>>;
  id: Scalars['ID']['output'];
  linkedGroupName?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<ProfileLocation>>>;
};

export type ProfileAddInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  webId?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileAddPayload = MutationResponse & {
  __typename?: 'ProfileAddPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProfileContact = {
  __typename?: 'ProfileContact';
  altPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ProfileLocation = {
  __typename?: 'ProfileLocation';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  creditCard?: Maybe<TokenizedCreditCard>;
  crossStreet?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latLng?: Maybe<LatLng>;
  locationType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pudName?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  telephone?: Maybe<Scalars['String']['output']>;
  telephone2?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type ProfileLocationTypeOption = {
  __typename?: 'ProfileLocationTypeOption';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProfilePudCreditCardInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  expiration: Scalars['String']['input'];
  name: Scalars['String']['input'];
  number: Scalars['String']['input'];
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ProfilePudInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<ProfilePudCreditCardInput>;
  crossStreet?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<LatLngInput>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pudName?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  telephone2?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for profile IDs */
export type ProfilesType = {
  charter?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  sales?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProgramSellType {
  Disabled = 'disabled',
  FixedViaTemplate = 'fixed_via_template',
  PerPoint = 'per_point',
  Unknown = 'unknown'
}

/** A person associated with a pickup/dropoff location (PUD) */
export type PudPerson = {
  __typename?: 'PudPerson';
  /** Address of the PUD location */
  address?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the PUD person */
  id: Scalars['ID']['output'];
  /** Name associated with the PUD location */
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  airlines: Array<Maybe<Airline>>;
  bridges: Array<Bridge>;
  colors?: Maybe<Colors>;
  config: Configuration;
  /** Get content tokens for a specific group */
  content?: Maybe<TokenContent>;
  defaults: Defaults;
  desktops: DesktopsReply;
  driverShift?: Maybe<DriverShift>;
  epicPassValidate: EpicPassReturn;
  epicPassValidateDate: EpicPassReturn;
  /**
   * Returns a Location object based on the incoming params and fare key lookup results.
   * If displayName/displayAddress are passed in they will be integrated into the Location.
   * Group profile is automatically taken from JWT context - do not pass as parameter.
   */
  fareKeyLookup: FareKeyLookupReturn;
  /**
   * Returns a list of location types with their associated locations.
   * Location types are filtered based on configuration settings and can include PUDs (Pick-Up/Drop-off locations).
   */
  fixedLocationTypes: Array<FixedLocationType>;
  frequentRiderPoints: Array<FrequentRiderPoints>;
  frequentRiderPrograms: Array<FrequentRiderProgram>;
  /** Fetch Grid Data Format (GDF) for driver desktop interfaces */
  gdf?: Maybe<Gdf>;
  hotkeys: HotkeysReply;
  /** Retrieve kiosk configuration for the given alias */
  kioskConfig?: Maybe<KioskConfig>;
  /** Retrieve content tokens for the kiosk application */
  kioskContent?: Maybe<KioskContent>;
  /**
   * Retrieves a single location by its fare code.
   * Service area can be provided to filter the location availability.
   * Group profile is automatically extracted from the JWT context.
   */
  location?: Maybe<Location>;
  /**
   * Get a filtered and paginated list of locations
   * Note: Profile parameters (charter, group, user) are taken from the JWT context
   */
  locationList: LocationList;
  /**
   * Locations especially filtered for autocomplete results.
   * Profiles (group, charter, user) are automatically extracted from JWT context.
   */
  locationsForAutocomplete: Array<Location>;
  /**
   * Returns a list of available passenger types.
   * Optionally filtered by service area or passenger type alias.
   */
  passengerTypes: Array<PassengerType>;
  /**
   * Get preferred locations (PUDs) for the authenticated user's profiles.
   * Returns locations from user, group, and charter profiles combined.
   * Locations without valid type configuration are filtered out.
   */
  profilePreferredLocations: Array<Maybe<Location>>;
  /**
   * Get reservations for the authenticated user profile.
   * Date range can be 'future', 'past', 'open', or omitted for all reservations.
   * Profile is automatically determined from the JWT context.
   */
  profileReservations: Array<Maybe<Reservation>>;
  /** People extracted from PUDs (pickup/dropoff locations) for the authenticated user */
  pudPeople: Array<PudPerson>;
  /** Fetch the Rate My Ride template by decrypting an encrypted PID. */
  rateMyRideTemplate?: Maybe<RateMyRideTemplate>;
  referralLinks: Array<ReferralLink>;
  /** Fetch a reservation template by decrypting an encrypted PID */
  resTemplate?: Maybe<ResTemplate>;
  /**
   * Retrieves a single reservation by its ID or PID.
   * Profile is automatically determined from the JWT context.
   * Returns null if the reservation is not found or does not belong to the authenticated profile.
   * When using a PID, the reservation is automatically trusted and accessible.
   */
  reservation?: Maybe<Reservation>;
  serviceAreas: Array<Maybe<ServiceArea>>;
  /**
   * Returns the site's configured service catalog as a flat list of
   * serviceType → name entries. Use this to translate the numeric
   * `ServiceType` codes that appear on trips and reservations into
   * human-readable labels. Sourced from the Bridge serviceConfig
   * command (cacheable).
   */
  serviceConfig: Array<ServiceConfigEntry>;
  serviceExtras: Array<ServiceExtra>;
  services: Array<Service>;
  /**
   * Get special information fields for the current site
   * Uses user and group profiles from JWT context
   */
  specialInfo: Array<SpecialInfoField>;
  /** Retrieve standard templates for the given alias */
  standardTemplates?: Maybe<Array<StandardTemplate>>;
  /** Retrieve all tokens for the booking engine */
  tokens: Array<Token>;
  /**
   * Returns the site's reference-data translation lists from the Bridge
   * `translations` command. Covers drivers, vehicles, payment types,
   * rider statuses, trip statuses, and other enum-like lists used across
   * reservations and trips grids. Header-only Bridge call — scoped per
   * site and language by context.
   */
  translations: Array<TranslationList>;
  userProfile?: Maybe<Profile>;
  /** Check if a user profile exists for the given email address */
  userProfileExists: UserProfileExists;
  /** Get Valpay configuration for Adyen payment processing */
  valpayConfig: ValpayConfig;
  /** List of GPS waypoints */
  waypoints: Array<Maybe<Waypoint>>;
};


export type QueryAirlinesArgs = {
  airportCode: Scalars['String']['input'];
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfigArgs = {
  mode?: InputMaybe<ConfigMode>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContentArgs = {
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenGroup: Scalars['String']['input'];
};


export type QueryDefaultsArgs = {
  pudId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDriverShiftArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEpicPassValidateArgs = {
  passId: Scalars['String']['input'];
};


export type QueryEpicPassValidateDateArgs = {
  passId: Scalars['String']['input'];
  pickupDate: Scalars['String']['input'];
};


export type QueryFareKeyLookupArgs = {
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fareCode?: InputMaybe<Scalars['String']['input']>;
  googleObject?: InputMaybe<Scalars['String']['input']>;
  serviceAreaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
  typeString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFixedLocationTypesArgs = {
  hidePuds?: InputMaybe<Scalars['Boolean']['input']>;
  pudId?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFrequentRiderProgramsArgs = {
  redeemableForDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGdfArgs = {
  desktopId: Scalars['String']['input'];
  quickFilterId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHotkeysArgs = {
  viewAlias: Scalars['String']['input'];
};


export type QueryKioskConfigArgs = {
  alias: Scalars['String']['input'];
};


export type QueryKioskContentArgs = {
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationArgs = {
  fareCode: Scalars['String']['input'];
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationListArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  locationType: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationsForAutocompleteArgs = {
  returnAll?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPassengerTypesArgs = {
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProfileReservationsArgs = {
  dateRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRateMyRideTemplateArgs = {
  pid: Scalars['String']['input'];
};


export type QueryReferralLinksArgs = {
  flightCity?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResTemplateArgs = {
  pid: Scalars['String']['input'];
};


export type QueryReservationArgs = {
  pid?: InputMaybe<Scalars['String']['input']>;
  reservationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryServiceExtrasArgs = {
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServicesArgs = {
  res: ServicesInput;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpecialInfoArgs = {
  siAlias?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStandardTemplatesArgs = {
  alias: Scalars['String']['input'];
};


export type QueryUserProfileExistsArgs = {
  email: Scalars['String']['input'];
};


export type QueryValpayConfigArgs = {
  processorId?: InputMaybe<Scalars['Int']['input']>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWaypointsArgs = {
  filters?: InputMaybe<Array<InputMaybe<WaypointFilterInput>>>;
};

/** Main input type for quote mutation */
export type QuoteBookingType = {
  /** Contact information for the booking */
  contact: QuoteContactType;
  /** Array of reservation legs */
  legs: Array<QuoteResType>;
};

/** Input type for quote booking contact information */
export type QuoteContactType = {
  altPhone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Input type for quote location (simplified for kiosk) */
export type QuoteLocType = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for quote passenger counts */
export type QuotePassengerType = {
  field: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 * Response type for quote mutation
 * Note: NEWQUOTE operations don't return reservation IDs or itinerary IDs
 */
export type QuotePayload = MutationResponse & {
  __typename?: 'QuotePayload';
  /** General error message */
  error?: Maybe<Scalars['String']['output']>;
  /** Type of error if any */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Input type for quote reservation leg (simplified for kiosk) */
export type QuoteResType = {
  /** Dropoff location */
  dropoff: QuoteLocType;
  /** Passenger counts */
  passengers?: InputMaybe<Array<InputMaybe<QuotePassengerType>>>;
  /** Pickup location (may be determined by standard template) */
  pickup?: InputMaybe<QuoteLocType>;
  /** Pickup time (ISO format) */
  pickupTime: Scalars['String']['input'];
  /** Standard template ID */
  standardTemplateId?: InputMaybe<Scalars['Int']['input']>;
};

export type RateMyRideSubmitInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  creditCard?: InputMaybe<RmrCreditCardInput>;
  gratuity?: InputMaybe<Scalars['Float']['input']>;
  /** Encrypted PID; the resolver re-derives the reservation id from it. */
  pid: Scalars['String']['input'];
  ratings?: InputMaybe<Array<RatingInput>>;
};

export type RateMyRideSubmitPayload = {
  __typename?: 'RateMyRideSubmitPayload';
  error?: Maybe<Scalars['String']['output']>;
  externalURL?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  successMessage?: Maybe<Scalars['String']['output']>;
};

export type RateMyRideTemplate = {
  __typename?: 'RateMyRideTemplate';
  /** Per-reservation banner message (not a content token). */
  displayedMessage?: Maybe<Scalars['String']['output']>;
  gratuityPercentages?: Maybe<Array<RmrGratuityPercentage>>;
  options?: Maybe<RmrOptions>;
  ratingCategories?: Maybe<Array<RatingCategory>>;
  reservation?: Maybe<RmrReservation>;
};

/** A dynamic rating category. `name` is the submit key (e.g. "resIndicator"). */
export type RatingCategory = {
  __typename?: 'RatingCategory';
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** A single rating category submission (e.g. { name: "resIndicator", value: 5 }). */
export type RatingInput = {
  name: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type ReferralLink = {
  __typename?: 'ReferralLink';
  alias: Scalars['String']['output'];
  boldText?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  linkUrl?: Maybe<Scalars['String']['output']>;
  popup?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  webItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type RefreshTokenPayload = MutationResponse & {
  __typename?: 'RefreshTokenPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Reprice = {
  __typename?: 'Reprice';
  bagCountMax?: Maybe<Scalars['Int']['output']>;
  fareComponents?: Maybe<Array<FieldValue>>;
  fareDisplay?: Maybe<Scalars['Float']['output']>;
  gratuityFare?: Maybe<Scalars['Float']['output']>;
  originalFare?: Maybe<Scalars['Float']['output']>;
  payments?: Maybe<RepricePayment>;
  times?: Maybe<Array<ServiceTime>>;
  webSubfares?: Maybe<Array<FieldValue>>;
};

export type RepricePayment = {
  __typename?: 'RepricePayment';
  amountDue?: Maybe<Scalars['Float']['output']>;
  items?: Maybe<Array<RepricePaymentItem>>;
  totalPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

export type RepricePaymentItem = {
  __typename?: 'RepricePaymentItem';
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  programId?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RepriceServicePayload = MutationResponse & {
  __typename?: 'RepriceServicePayload';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reprice?: Maybe<Reprice>;
  success: Scalars['Boolean']['output'];
};

export type ResContact = {
  __typename?: 'ResContact';
  altPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ResCreditCard = {
  __typename?: 'ResCreditCard';
  expiration?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberLast4?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
};

export type ResFieldValue = {
  __typename?: 'ResFieldValue';
  field: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ResFlight = {
  __typename?: 'ResFlight';
  airline?: Maybe<Scalars['String']['output']>;
  flightCity?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  flightTime?: Maybe<Scalars['String']['output']>;
  flightType?: Maybe<Scalars['String']['output']>;
  terminal?: Maybe<Scalars['String']['output']>;
};

export type ResMadeBy = {
  __typename?: 'ResMadeBy';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ResOptions = {
  __typename?: 'ResOptions';
  allowOpenResConversion: Scalars['Boolean']['output'];
};

export type ResOther = {
  __typename?: 'ResOther';
  idNumber?: Maybe<Scalars['String']['output']>;
  madeBy?: Maybe<ResMadeBy>;
  marketingCode?: Maybe<Scalars['String']['output']>;
  marketingCode2?: Maybe<Scalars['String']['output']>;
  marketingCode3?: Maybe<Scalars['String']['output']>;
  specialInstructions?: Maybe<Scalars['String']['output']>;
  specialInstructions2?: Maybe<Scalars['String']['output']>;
};

export type ResPayment = {
  __typename?: 'ResPayment';
  chargeTo?: Maybe<Scalars['String']['output']>;
  creditCard?: Maybe<ResCreditCard>;
  shopperReference?: Maybe<Scalars['String']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  variance?: Maybe<Scalars['Float']['output']>;
};

export type ResProfiles = {
  __typename?: 'ResProfiles';
  charter?: Maybe<Scalars['Int']['output']>;
  coupon?: Maybe<Scalars['Int']['output']>;
  group?: Maybe<Scalars['Int']['output']>;
  sales?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<Scalars['Int']['output']>;
};

export type ResStop = {
  __typename?: 'ResStop';
  comments?: Maybe<Scalars['String']['output']>;
  directions?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ResTemplate = {
  __typename?: 'ResTemplate';
  body?: Maybe<ResTemplateBody>;
  metadata?: Maybe<ResTemplateMetadata>;
  resId?: Maybe<Scalars['Int']['output']>;
};

export type ResTemplateBody = {
  __typename?: 'ResTemplateBody';
  content?: Maybe<ResTemplateContent>;
  header?: Maybe<ResTemplateHeader>;
  options?: Maybe<Array<ResTemplateOption>>;
};

export type ResTemplateContent = {
  __typename?: 'ResTemplateContent';
  sections?: Maybe<Array<ResTemplateSection>>;
};

export type ResTemplateHeader = {
  __typename?: 'ResTemplateHeader';
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ResTemplateMetadata = {
  __typename?: 'ResTemplateMetadata';
  author?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ResTemplateOption = {
  __typename?: 'ResTemplateOption';
  /**
   * Default param values for this option. Keys match input section ids;
   * user-entered values override these at submit time.
   */
  additionalParams?: Maybe<Array<ResTemplateOptionParam>>;
  buttonCaption?: Maybe<Scalars['String']['output']>;
  functionCode?: Maybe<Scalars['Int']['output']>;
  /** Grid type forwarded verbatim onto the processHotkey mutation. */
  gridType?: Maybe<Scalars['Int']['output']>;
  hotkeyId?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** A default param value submitted with an option's hotkey press. */
export type ResTemplateOptionParam = {
  __typename?: 'ResTemplateOptionParam';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ResTemplateSection = {
  __typename?: 'ResTemplateSection';
  description?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /**
   * Renders the section as an input control: "select" (populated from the
   * translations list named by translationType) or "text". Absent or
   * unrecognized values render a display-only section. The section id is the
   * param key the collected value is submitted under.
   */
  inputType?: Maybe<Scalars['String']['output']>;
  /**
   * Validation pragma tokens for input sections, e.g. ["required", "numeric"].
   * Unrecognized tokens are ignored by clients (forward-compatible).
   */
  inputValidation?: Maybe<Array<Scalars['String']['output']>>;
  /** Translations list name (e.g. "vehicles") backing a select section. */
  translationType?: Maybe<Scalars['String']['output']>;
};

/** Input type for each reservation leg */
export type ResType = {
  /** Number of bags */
  bagCount?: InputMaybe<Scalars['Int']['input']>;
  /** Connection line run ID */
  connLineRun?: InputMaybe<Scalars['Int']['input']>;
  /** Dropoff location details */
  dropoff: BookLocType;
  /** Dropoff time (format: YYYY-MM-DD HH:MM:SS) */
  dropoffTime?: InputMaybe<Scalars['String']['input']>;
  /** Epic Pass validation status */
  epicPassValidated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fare components */
  fareComponents?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  flags?: InputMaybe<Scalars['String']['input']>;
  /** Flight information */
  flight?: InputMaybe<BookFlightType>;
  /** Job type (e.g., "pickup", "transfer") */
  jobType?: InputMaybe<Scalars['Int']['input']>;
  /** Marketing codes for this leg */
  marketingCodes?: InputMaybe<MarketingCodesType>;
  /** Mileage for this leg */
  mileage?: InputMaybe<Scalars['Float']['input']>;
  /** Passenger details */
  passengerDetails?: InputMaybe<Array<InputMaybe<BookPassengerDetailsType>>>;
  /** Passenger types alias */
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  /** Passenger counts by type */
  passengers?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  /** Payment information for this leg (points/frequent rider) */
  payments?: InputMaybe<BookLegPaymentsType>;
  /** Per passenger rates for pricing */
  perPassengerRates?: InputMaybe<Scalars['String']['input']>;
  /** Pickup location details */
  pickup: BookLocType;
  /** Pickup extra time */
  pickupExtra?: InputMaybe<Scalars['String']['input']>;
  /** Pickup time (format: YYYY-MM-DD HH:MM:SS) */
  pickupTime?: InputMaybe<Scalars['String']['input']>;
  /** Profile associations for this leg */
  profiles?: InputMaybe<ProfilesType>;
  /** Existing reservation ID for updates */
  resId?: InputMaybe<Scalars['String']['input']>;
  /** Internal reservation ID for updates */
  resIdInternal?: InputMaybe<Scalars['Int']['input']>;
  /** Return trip status */
  returnTripStatus?: InputMaybe<Scalars['String']['input']>;
  /** Service area ID */
  serviceArea?: InputMaybe<Scalars['Int']['input']>;
  /** Service extras */
  serviceExtras?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  /** Service extras alias */
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
  /** Service type ID */
  serviceType?: InputMaybe<Scalars['Int']['input']>;
  /** Scheduled run ID */
  skedRun?: InputMaybe<Scalars['Int']['input']>;
  /** Special info field-value pairs */
  specialInfo?: InputMaybe<Array<InputMaybe<InputFieldValueType>>>;
  /** Special instructions for driver */
  specialInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Additional special instructions */
  specialInstructions2?: InputMaybe<Scalars['String']['input']>;
  /** Stops for this leg */
  stops?: InputMaybe<Array<InputMaybe<BookStopType>>>;
  /** Travel time in minutes */
  travelTime?: InputMaybe<Scalars['Int']['input']>;
  /** User gratuity override flag */
  userGratuityOverride?: InputMaybe<Scalars['Boolean']['input']>;
  /** User gratuity percentage */
  userGratuityPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type Reservation = {
  __typename?: 'Reservation';
  auth?: Maybe<Auth>;
  bagCount: Scalars['Int']['output'];
  cancellable: Scalars['Boolean']['output'];
  cancelled: Scalars['Boolean']['output'];
  compId: Scalars['Int']['output'];
  contactInfo: ResContact;
  dropoff: Location;
  editable: Scalars['Boolean']['output'];
  epicPassId?: Maybe<Scalars['String']['output']>;
  epicPassValidated?: Maybe<Scalars['Boolean']['output']>;
  flags: Scalars['String']['output'];
  flight?: Maybe<ResFlight>;
  id: Scalars['ID']['output'];
  itineraryId?: Maybe<Scalars['String']['output']>;
  jobNumber?: Maybe<Scalars['String']['output']>;
  jobType: Scalars['Int']['output'];
  open: Scalars['Boolean']['output'];
  operation: Scalars['String']['output'];
  options?: Maybe<ResOptions>;
  other?: Maybe<ResOther>;
  passengers: Array<ResFieldValue>;
  payment?: Maybe<ResPayment>;
  pickup: Location;
  profiles?: Maybe<ResProfiles>;
  purchaseMethod?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['String']['output']>;
  resIdInternal: Scalars['Int']['output'];
  returnTripStatus: Scalars['String']['output'];
  service?: Maybe<Service>;
  serviceArea: Scalars['Int']['output'];
  serviceExtras: Array<ResFieldValue>;
  sourceType: Scalars['Int']['output'];
  stops?: Maybe<Array<ResStop>>;
  totalOriginal?: Maybe<Scalars['Float']['output']>;
  userDefined?: Maybe<Array<FieldValue>>;
  userGratuityOverride?: Maybe<Scalars['Boolean']['output']>;
  userGratuityPercentage?: Maybe<Scalars['Float']['output']>;
};

/** Card data for the rating submit. cardOnFile is derived server-side, not sent. */
export type RmrCreditCardInput = {
  /** Raw Adyen card brand (e.g. "mc", "visa"); mapped to a Bridge type code server-side. */
  cardBrand?: InputMaybe<Scalars['String']['input']>;
  encryptedCardNumber?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryMonth?: InputMaybe<Scalars['String']['input']>;
  encryptedExpiryYear?: InputMaybe<Scalars['String']['input']>;
  encryptedSecurityCode?: InputMaybe<Scalars['String']['input']>;
  expiration?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  numberLast4?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** A gratuity preset for the tip buttons (e.g. { label: "Add 20%", percent: 20 }). */
export type RmrGratuityPercentage = {
  __typename?: 'RmrGratuityPercentage';
  label?: Maybe<Scalars['String']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
};

/** Feature flags and tip config that drive the Rate My Ride form. */
export type RmrOptions = {
  __typename?: 'RmrOptions';
  allowCreditCardEntry?: Maybe<Scalars['Boolean']['output']>;
  /** Derived from the template status: true when the form must not be submitted. */
  formLocked?: Maybe<Scalars['Boolean']['output']>;
  maxGratuityPercent?: Maybe<Scalars['Float']['output']>;
  requireCvvForCardOnFile?: Maybe<Scalars['Boolean']['output']>;
  sectionOrder?: Maybe<Array<Scalars['String']['output']>>;
  showComments?: Maybe<Scalars['Boolean']['output']>;
  showCreditCard?: Maybe<Scalars['Boolean']['output']>;
  showGratuitySection?: Maybe<Scalars['Boolean']['output']>;
  showRatings?: Maybe<Scalars['Boolean']['output']>;
};

/** Per-reservation snapshot shown on the Rate My Ride form. */
export type RmrReservation = {
  __typename?: 'RmrReservation';
  ccNumberLast4?: Maybe<Scalars['String']['output']>;
  ccToken?: Maybe<Scalars['String']['output']>;
  ccType?: Maybe<Scalars['String']['output']>;
  dropoff?: Maybe<Scalars['String']['output']>;
  fare?: Maybe<Scalars['Float']['output']>;
  gratuitySubFare?: Maybe<Scalars['Float']['output']>;
  includedGratuity?: Maybe<Scalars['Float']['output']>;
  pickup?: Maybe<Scalars['String']['output']>;
  resDate?: Maybe<Scalars['String']['output']>;
  /** Extracted from ccToken (everything before the last dash). */
  shopperReference?: Maybe<Scalars['String']['output']>;
};

export type SavePasswordPayload = MutationResponse & {
  __typename?: 'SavePasswordPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SavePasswordWithPidPayload = MutationResponse & {
  __typename?: 'SavePasswordWithPidPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SelectedTime = {
  __typename?: 'SelectedTime';
  connLineRun?: Maybe<Scalars['Int']['output']>;
  dropoffTime?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  pickupTime?: Maybe<Scalars['String']['output']>;
  skedRun?: Maybe<Scalars['String']['output']>;
};

/** Response from password reset request */
export type SendPasswordResetPayload = MutationResponse & {
  __typename?: 'SendPasswordResetPayload';
  /**
   * Type of error if the operation failed:
   * - BAD_USERNAME: Invalid email format or profile not found
   * - GENERAL: Other errors
   */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the password reset email was sent successfully */
  success: Scalars['Boolean']['output'];
};

export type Service = {
  __typename?: 'Service';
  bagCountMax?: Maybe<Scalars['Int']['output']>;
  checkoutPickuptimeMode?: Maybe<CheckoutPickupTimeMode>;
  defaultBaggage: Scalars['Int']['output'];
  defaultGratuityPercent?: Maybe<Scalars['Float']['output']>;
  discountDisplayMode?: Maybe<Scalars['Int']['output']>;
  fare?: Maybe<Scalars['Float']['output']>;
  fareCalculationMode?: Maybe<Scalars['String']['output']>;
  fareComponents: Array<FieldValue>;
  fareDisplay?: Maybe<Scalars['Float']['output']>;
  fareDisplayMode: Scalars['String']['output'];
  gratuityFare?: Maybe<Scalars['Float']['output']>;
  hideBaggage: Scalars['Boolean']['output'];
  hideFareMode: Scalars['String']['output'];
  hideFlightInfo: Scalars['Boolean']['output'];
  hideMaximumPassengers: Scalars['Boolean']['output'];
  hideRoundtrip?: Maybe<Scalars['Boolean']['output']>;
  hideSubfareMode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  includedGratuity: Scalars['Float']['output'];
  items: Array<Scalars['String']['output']>;
  madeByMode: Scalars['String']['output'];
  maxPassengers: Scalars['Int']['output'];
  mileage?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originalFare?: Maybe<Scalars['Float']['output']>;
  originalIncludedGratuityPercent?: Maybe<Scalars['Float']['output']>;
  passengerTypesAlias?: Maybe<Scalars['String']['output']>;
  perPassengerRates?: Maybe<Scalars['String']['output']>;
  pickupExtras: Array<PickupExtra>;
  processorId?: Maybe<Scalars['Int']['output']>;
  raw: Scalars['String']['output'];
  roundtripPricingMode: Scalars['String']['output'];
  selectedPickupExtra?: Maybe<PickupExtra>;
  selectedTime?: Maybe<SelectedTime>;
  serviceExtrasAlias?: Maybe<Scalars['String']['output']>;
  serviceTimeNotes: Scalars['String']['output'];
  serviceType: Scalars['Int']['output'];
  showExtraStops?: Maybe<Scalars['Boolean']['output']>;
  showGratuity?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the per-time travel time should be shown in the pickup time selection */
  showTravelTime?: Maybe<Scalars['Boolean']['output']>;
  times: Array<ServiceTime>;
  totalGratuity: Scalars['Float']['output'];
  travelTime?: Maybe<Scalars['Float']['output']>;
  webSubfares: Array<FieldValue>;
};

export type ServiceArea = {
  __typename?: 'ServiceArea';
  addressType: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  fareGroup: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  jobType: Scalars['Int']['output'];
  localWeb: Scalars['Int']['output'];
  mapInfo?: Maybe<MapPoint>;
  mappingEnabled: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  openReservationMode: Scalars['Int']['output'];
  passengerTypesAlias: Scalars['String']['output'];
  rateAlias: Scalars['String']['output'];
  residentialAddressMode: Scalars['Int']['output'];
  serviceExtrasAlias: Scalars['String']['output'];
  telephone: Scalars['String']['output'];
  telephone2: Scalars['String']['output'];
  type: Scalars['String']['output'];
  webDescription: Scalars['String']['output'];
  webOverride: Scalars['String']['output'];
  webSiteUrl: Scalars['String']['output'];
};

/** A configured service available at the site (e.g. shuttle, private car). */
export type ServiceConfigEntry = {
  __typename?: 'ServiceConfigEntry';
  /** Whether the service is currently enabled for booking. */
  enabled: Scalars['Boolean']['output'];
  /** Human-readable service name (defaults to webName; site-overridable). */
  name: Scalars['String']['output'];
  /** Numeric service-type code stored on reservations and trips. */
  serviceType: Scalars['Int']['output'];
};

export type ServiceExtra = {
  __typename?: 'ServiceExtra';
  defaultToBlank?: Maybe<Scalars['Boolean']['output']>;
  defaultValue?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fieldName: Scalars['String']['output'];
  fixedAmount: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  maximum?: Maybe<Scalars['Int']['output']>;
  popup?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  returnDefaultToBlank?: Maybe<Scalars['Boolean']['output']>;
  returnDefaultToFirstLeg?: Maybe<Scalars['Boolean']['output']>;
  returnDefaultValue?: Maybe<Scalars['Int']['output']>;
  surcharge?: Maybe<Scalars['Float']['output']>;
};

export type ServiceTime = {
  __typename?: 'ServiceTime';
  availableSeats?: Maybe<Scalars['Int']['output']>;
  connLineRun?: Maybe<Scalars['Int']['output']>;
  dropoffTime?: Maybe<Scalars['String']['output']>;
  fareComponents: Array<FieldValue>;
  hasAdditionalCharges: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  offPeakCharge?: Maybe<Scalars['Float']['output']>;
  offpeak: Scalars['Boolean']['output'];
  pickupTime?: Maybe<Scalars['String']['output']>;
  raw?: Maybe<Scalars['String']['output']>;
  shortNoticeCharge?: Maybe<Scalars['Float']['output']>;
  showAvailablePassengers: Scalars['Boolean']['output'];
  skedRun?: Maybe<Scalars['Int']['output']>;
  suggested: Scalars['Boolean']['output'];
  /** Minutes from this pickup to its dropoff, when the Bridge provides it */
  travelTime?: Maybe<Scalars['Float']['output']>;
  unavailable: Scalars['Boolean']['output'];
  userGratuityPercentage?: Maybe<Scalars['Float']['output']>;
  yieldAdjustment?: Maybe<Scalars['Float']['output']>;
};

export type ServicesFieldValueInput = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesFlightInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  flightTime?: InputMaybe<Scalars['String']['input']>;
  flightType?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesInput = {
  bagCount?: InputMaybe<Scalars['Int']['input']>;
  compPickupTime?: InputMaybe<Scalars['String']['input']>;
  dropoff: ServicesLocationInput;
  epicPassValidated?: InputMaybe<Scalars['Boolean']['input']>;
  fareComponents?: InputMaybe<Array<ServicesFieldValueInput>>;
  flight?: InputMaybe<ServicesFlightInput>;
  internalId?: InputMaybe<Scalars['Int']['input']>;
  mileage?: InputMaybe<Scalars['Float']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  passengers?: InputMaybe<Array<ServicesFieldValueInput>>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<ServicesPaymentInput>;
  perPassengerRates?: InputMaybe<Scalars['String']['input']>;
  pickup: ServicesLocationInput;
  pickupExtra?: InputMaybe<Scalars['String']['input']>;
  requestedPickupTime?: InputMaybe<Scalars['String']['input']>;
  reservationFlags?: InputMaybe<Scalars['String']['input']>;
  returnTripStatus?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  serviceExtras?: InputMaybe<Array<ServicesFieldValueInput>>;
  serviceType?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Array<ServicesStopInput>>;
  travelTime?: InputMaybe<Scalars['Float']['input']>;
  userGratuity?: InputMaybe<Scalars['Float']['input']>;
  userGratuityOverride?: InputMaybe<Scalars['Boolean']['input']>;
  userGratuityPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type ServicesLatLngInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type ServicesLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latLng?: InputMaybe<ServicesLatLngInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesPaymentInput = {
  amountDue?: InputMaybe<Scalars['Float']['input']>;
  items?: InputMaybe<Array<ServicesPaymentItemInput>>;
  totalPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ServicesPaymentItemInput = {
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  programId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ServicesStopInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  directions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ServicesLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SetPasswordForProfilePayload = MutationResponse & {
  __typename?: 'SetPasswordForProfilePayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  profileId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Special information field definition */
export type SpecialInfoField = {
  __typename?: 'SpecialInfoField';
  /** Default value for the field */
  defaultValue: Scalars['String']['output'];
  /** Description or help text for the field */
  description: Scalars['String']['output'];
  /** Name of the field (used for form submission) */
  fieldName: Scalars['String']['output'];
  /** Type of the field for rendering */
  fieldType: SpecialInfoFieldType;
  /** Unique identifier for the field */
  id: Scalars['Int']['output'];
  /** Display label for the field */
  label: Scalars['String']['output'];
  /** Maximum length for text fields */
  maxLength: Scalars['Int']['output'];
  /** Minimum length for text fields */
  minLength: Scalars['Int']['output'];
  /** Raw JSON representation of the field */
  raw: Scalars['String']['output'];
  /** Whether the field is required */
  required: Scalars['Boolean']['output'];
  /** Value list for select fields (comma-separated values) */
  valueList?: Maybe<Scalars['String']['output']>;
};

/** Enum representing the type of special info field */
export enum SpecialInfoFieldType {
  /** Boolean checkbox field */
  Boolean = 'boolean',
  /** Date input field */
  Date = 'date',
  /** Field to ignore */
  Ignore = 'ignore',
  /** Numeric input field */
  Numeric = 'numeric',
  /** Select dropdown field */
  Select = 'select',
  /** Text input field */
  Text = 'text',
  /** Title text (display only) */
  Title = 'title'
}

export type StandardTemplate = {
  __typename?: 'StandardTemplate';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  specialInstr?: Maybe<Scalars['String']['output']>;
  specialInstr2?: Maybe<Scalars['String']['output']>;
};

export enum TimeFormat {
  /** 12-hour time format (e.g., 3:00 PM) */
  Twelve = 'twelve',
  /** 24-hour time format (e.g., 15:00) */
  Twentyfour = 'twentyfour'
}

export type Token = {
  __typename?: 'Token';
  defaultToken: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Response type for content query containing all available token fields */
export type TokenContent = {
  __typename?: 'TokenContent';
  beAddressDetailsLabel?: Maybe<Scalars['String']['output']>;
  beAirlineLabel?: Maybe<Scalars['String']['output']>;
  beAltphoneLabel?: Maybe<Scalars['String']['output']>;
  beApplyCouponButton?: Maybe<Scalars['String']['output']>;
  beApplyCouponLabel?: Maybe<Scalars['String']['output']>;
  beAutocompleteMoreOptionsButton?: Maybe<Scalars['String']['output']>;
  beBagsDescription?: Maybe<Scalars['String']['output']>;
  beBagsHeader?: Maybe<Scalars['String']['output']>;
  beBagsLabel?: Maybe<Scalars['String']['output']>;
  beBagsUrl?: Maybe<Scalars['String']['output']>;
  beBagsUrlLabel?: Maybe<Scalars['String']['output']>;
  beBookAnotherButton?: Maybe<Scalars['String']['output']>;
  beBookButton?: Maybe<Scalars['String']['output']>;
  beBookHeaderButton?: Maybe<Scalars['String']['output']>;
  beBookLoadingMsg?: Maybe<Scalars['String']['output']>;
  beBookReturnTripDescription?: Maybe<Scalars['String']['output']>;
  beBookReturnTripLabel?: Maybe<Scalars['String']['output']>;
  beBookingInfoSectionHeader?: Maybe<Scalars['String']['output']>;
  beCancelButton?: Maybe<Scalars['String']['output']>;
  beCancelConfirmationCancelButton?: Maybe<Scalars['String']['output']>;
  beCancelConfirmationMsg?: Maybe<Scalars['String']['output']>;
  beCancelResSuccess?: Maybe<Scalars['String']['output']>;
  beCanceledMsg?: Maybe<Scalars['String']['output']>;
  beCcAddressLabel?: Maybe<Scalars['String']['output']>;
  beCcCvvLabel?: Maybe<Scalars['String']['output']>;
  beCcExpLabel?: Maybe<Scalars['String']['output']>;
  beCcNameLabel?: Maybe<Scalars['String']['output']>;
  beCcNumberLabel?: Maybe<Scalars['String']['output']>;
  beCcPostalcodeLabel?: Maybe<Scalars['String']['output']>;
  beChangepwNewPasswordLabel?: Maybe<Scalars['String']['output']>;
  beChangepwPasswordLabel?: Maybe<Scalars['String']['output']>;
  beChangepwSubmitButton?: Maybe<Scalars['String']['output']>;
  beChangepwSuccessMsg?: Maybe<Scalars['String']['output']>;
  beCheckoutTitle?: Maybe<Scalars['String']['output']>;
  beConfirmDialogDefaultCancelButton?: Maybe<Scalars['String']['output']>;
  beConfirmDialogDefaultTitle?: Maybe<Scalars['String']['output']>;
  beConfirmationHead?: Maybe<Scalars['String']['output']>;
  beConfirmationTitle?: Maybe<Scalars['String']['output']>;
  beContactGuestCheckout?: Maybe<Scalars['String']['output']>;
  beContactPassengersHeader?: Maybe<Scalars['String']['output']>;
  beContactPassengersNameLabel?: Maybe<Scalars['String']['output']>;
  beContactPassengersText?: Maybe<Scalars['String']['output']>;
  beContactSectionTitle?: Maybe<Scalars['String']['output']>;
  beContinueButton?: Maybe<Scalars['String']['output']>;
  beContinueToCcPageButton?: Maybe<Scalars['String']['output']>;
  beConvertOpenButton?: Maybe<Scalars['String']['output']>;
  beConvertOpenCancelButton?: Maybe<Scalars['String']['output']>;
  beConvertOpenCancelConfirmation?: Maybe<Scalars['String']['output']>;
  beConvertOpenMessage?: Maybe<Scalars['String']['output']>;
  beConvertOpenSuccessMessage?: Maybe<Scalars['String']['output']>;
  beCouponAppliedMsg?: Maybe<Scalars['String']['output']>;
  beCreateNewAccountButton?: Maybe<Scalars['String']['output']>;
  beCreateNewAccountTitle?: Maybe<Scalars['String']['output']>;
  beCrossStreetLabel?: Maybe<Scalars['String']['output']>;
  beCustRequestFlightTime?: Maybe<Scalars['String']['output']>;
  beCustRequestPickupTime?: Maybe<Scalars['String']['output']>;
  beDropoffDirectionsLabel?: Maybe<Scalars['String']['output']>;
  beDropoffLocLabel?: Maybe<Scalars['String']['output']>;
  beEditBackButton?: Maybe<Scalars['String']['output']>;
  beEditLegButton?: Maybe<Scalars['String']['output']>;
  beEditOpenResButton?: Maybe<Scalars['String']['output']>;
  beEditResButton?: Maybe<Scalars['String']['output']>;
  beEditResidPrefix?: Maybe<Scalars['String']['output']>;
  beEditStopDialogConfirmButton?: Maybe<Scalars['String']['output']>;
  beEditStopDialogConfirmMessage?: Maybe<Scalars['String']['output']>;
  beEmailLabel?: Maybe<Scalars['String']['output']>;
  beEmailProfileCheckLoginButton?: Maybe<Scalars['String']['output']>;
  beEmailProfileCheckMsg?: Maybe<Scalars['String']['output']>;
  beEpicPassAppliedMsg?: Maybe<Scalars['String']['output']>;
  beEpicPassIdLabel?: Maybe<Scalars['String']['output']>;
  beEpicPassSubmitBtn?: Maybe<Scalars['String']['output']>;
  beErrAddressDetails?: Maybe<Scalars['String']['output']>;
  beErrAirline?: Maybe<Scalars['String']['output']>;
  beErrAltphone?: Maybe<Scalars['String']['output']>;
  beErrAltphoneFormat?: Maybe<Scalars['String']['output']>;
  beErrBadCoupon?: Maybe<Scalars['String']['output']>;
  beErrBagCountMax?: Maybe<Scalars['String']['output']>;
  beErrCantVerify?: Maybe<Scalars['String']['output']>;
  beErrCcAddress?: Maybe<Scalars['String']['output']>;
  beErrCcCvv?: Maybe<Scalars['String']['output']>;
  beErrCcExp?: Maybe<Scalars['String']['output']>;
  beErrCcName?: Maybe<Scalars['String']['output']>;
  beErrCcNumber?: Maybe<Scalars['String']['output']>;
  beErrCcNumberInvalid?: Maybe<Scalars['String']['output']>;
  beErrCcNumberType?: Maybe<Scalars['String']['output']>;
  beErrCcPostalcode?: Maybe<Scalars['String']['output']>;
  beErrEmail?: Maybe<Scalars['String']['output']>;
  beErrEmailFormat?: Maybe<Scalars['String']['output']>;
  beErrEpicLogin?: Maybe<Scalars['String']['output']>;
  beErrFaxNumberFormat?: Maybe<Scalars['String']['output']>;
  beErrFieldRequired?: Maybe<Scalars['String']['output']>;
  beErrFlightCityArrivals?: Maybe<Scalars['String']['output']>;
  beErrFlightCityDepartures?: Maybe<Scalars['String']['output']>;
  beErrFlightNumArrivals?: Maybe<Scalars['String']['output']>;
  beErrFlightNumDepartures?: Maybe<Scalars['String']['output']>;
  beErrGroupLogin?: Maybe<Scalars['String']['output']>;
  beErrGroupPasswordLogin?: Maybe<Scalars['String']['output']>;
  beErrLinkedGroups?: Maybe<Scalars['String']['output']>;
  beErrLocTooGeneral?: Maybe<Scalars['String']['output']>;
  beErrLookupEmailFormat?: Maybe<Scalars['String']['output']>;
  beErrMarketingCode?: Maybe<Scalars['String']['output']>;
  beErrMarketingCode2?: Maybe<Scalars['String']['output']>;
  beErrMarketingCode3?: Maybe<Scalars['String']['output']>;
  beErrMaxPassengers?: Maybe<Scalars['String']['output']>;
  beErrName?: Maybe<Scalars['String']['output']>;
  beErrNoFareKey?: Maybe<Scalars['String']['output']>;
  beErrNoLocsFound?: Maybe<Scalars['String']['output']>;
  beErrNoLocsFoundFixed?: Maybe<Scalars['String']['output']>;
  beErrNoPickuptimes?: Maybe<Scalars['String']['output']>;
  beErrNoService?: Maybe<Scalars['String']['output']>;
  beErrNoServiceTitle?: Maybe<Scalars['String']['output']>;
  beErrPassengers?: Maybe<Scalars['String']['output']>;
  beErrPasswordMinLength?: Maybe<Scalars['String']['output']>;
  beErrPasswordUpdate?: Maybe<Scalars['String']['output']>;
  beErrPhone?: Maybe<Scalars['String']['output']>;
  beErrPhoneFormat?: Maybe<Scalars['String']['output']>;
  beErrPickupTimeArrival?: Maybe<Scalars['String']['output']>;
  beErrPickupTimeDeparture?: Maybe<Scalars['String']['output']>;
  beErrProfileCcAdd?: Maybe<Scalars['String']['output']>;
  beErrProfileCcRemove?: Maybe<Scalars['String']['output']>;
  beErrProfileLocationsAdd?: Maybe<Scalars['String']['output']>;
  beErrProfileLocationsDelete?: Maybe<Scalars['String']['output']>;
  beErrProfileLocationsUpdate?: Maybe<Scalars['String']['output']>;
  beErrProfileUpdate?: Maybe<Scalars['String']['output']>;
  beErrPudPersonCcRemove?: Maybe<Scalars['String']['output']>;
  beErrResNotCanceled?: Maybe<Scalars['String']['output']>;
  beErrResNotConverted?: Maybe<Scalars['String']['output']>;
  beErrResetpwGeneral?: Maybe<Scalars['String']['output']>;
  beErrSessionExpired?: Maybe<Scalars['String']['output']>;
  beErrSpecialInfoMin?: Maybe<Scalars['String']['output']>;
  beErrSpecialInstr?: Maybe<Scalars['String']['output']>;
  beErrSpecialInstr2?: Maybe<Scalars['String']['output']>;
  beErrStopsComments?: Maybe<Scalars['String']['output']>;
  beErrStopsName?: Maybe<Scalars['String']['output']>;
  beErrStopsReprice?: Maybe<Scalars['String']['output']>;
  beErrSystemError?: Maybe<Scalars['String']['output']>;
  beErrTerms?: Maybe<Scalars['String']['output']>;
  beErrUserLogin?: Maybe<Scalars['String']['output']>;
  beErrUsernameBad?: Maybe<Scalars['String']['output']>;
  beExternalCcMessage?: Maybe<Scalars['String']['output']>;
  beExtraStopLabel?: Maybe<Scalars['String']['output']>;
  beFaxNumberLabel?: Maybe<Scalars['String']['output']>;
  beFirstLegHeader?: Maybe<Scalars['String']['output']>;
  beFlightCityArrivalsLabel?: Maybe<Scalars['String']['output']>;
  beFlightCityDeparturesLabel?: Maybe<Scalars['String']['output']>;
  beFlightDateArrLabel?: Maybe<Scalars['String']['output']>;
  beFlightDateDepLabel?: Maybe<Scalars['String']['output']>;
  beFlightDateLabel?: Maybe<Scalars['String']['output']>;
  beFlightNumberLabel?: Maybe<Scalars['String']['output']>;
  beFlightSectionExtrasSubtitle?: Maybe<Scalars['String']['output']>;
  beFlightSectionFlightSubtitle?: Maybe<Scalars['String']['output']>;
  beFlightSectionTitle?: Maybe<Scalars['String']['output']>;
  beFlightTimeArrLabel?: Maybe<Scalars['String']['output']>;
  beFlightTimeDepLabel?: Maybe<Scalars['String']['output']>;
  beFlightTimeLabel?: Maybe<Scalars['String']['output']>;
  beFlightTypeInternationalLabel?: Maybe<Scalars['String']['output']>;
  beForgotPwButton?: Maybe<Scalars['String']['output']>;
  beFrpBookAnotherButton?: Maybe<Scalars['String']['output']>;
  beFrpBookButton?: Maybe<Scalars['String']['output']>;
  beFrpBookLoadingMsg?: Maybe<Scalars['String']['output']>;
  beFrpButton?: Maybe<Scalars['String']['output']>;
  beFrpConfirmationHead?: Maybe<Scalars['String']['output']>;
  beFrpConfirmationTitle?: Maybe<Scalars['String']['output']>;
  beFrpFreeRides?: Maybe<Scalars['String']['output']>;
  beFrpGoodThru?: Maybe<Scalars['String']['output']>;
  beFrpNoPrograms?: Maybe<Scalars['String']['output']>;
  beFrpQuantityLabel?: Maybe<Scalars['String']['output']>;
  beFrpStartDateLabel?: Maybe<Scalars['String']['output']>;
  beFrpSubmitBtn?: Maybe<Scalars['String']['output']>;
  beGratuityIncludedMsg?: Maybe<Scalars['String']['output']>;
  beGratuityRtGratuityIsLabel?: Maybe<Scalars['String']['output']>;
  beGratuitySectionGrpSvcContent?: Maybe<Scalars['String']['output']>;
  beGratuitySectionTitle?: Maybe<Scalars['String']['output']>;
  beGratuityZeroDefaultLabel?: Maybe<Scalars['String']['output']>;
  beGroupLoginCodeLabel?: Maybe<Scalars['String']['output']>;
  beGroupLoginPrompt?: Maybe<Scalars['String']['output']>;
  beGroupLoginSubmitBtn?: Maybe<Scalars['String']['output']>;
  beGroupLoginSubmitButton?: Maybe<Scalars['String']['output']>;
  beGroupLogoutLabel?: Maybe<Scalars['String']['output']>;
  beGroupPasswordLabel?: Maybe<Scalars['String']['output']>;
  beGroupPwBackButton?: Maybe<Scalars['String']['output']>;
  beHeaderProfileButton?: Maybe<Scalars['String']['output']>;
  beLocAmenIconH?: Maybe<Scalars['String']['output']>;
  beLocAmenIconNP?: Maybe<Scalars['String']['output']>;
  beLocAmenIconP?: Maybe<Scalars['String']['output']>;
  beLocAmenIconR?: Maybe<Scalars['String']['output']>;
  beLocAmenIconV?: Maybe<Scalars['String']['output']>;
  beLocationDialogCommonCatsHeader?: Maybe<Scalars['String']['output']>;
  beLocationDialogTopLocHeader?: Maybe<Scalars['String']['output']>;
  beLocationSectionTitle?: Maybe<Scalars['String']['output']>;
  beLocationStringLabel?: Maybe<Scalars['String']['output']>;
  beLocationtypeNamePuds?: Maybe<Scalars['String']['output']>;
  beLoginSubmitButton?: Maybe<Scalars['String']['output']>;
  beLoginTitle?: Maybe<Scalars['String']['output']>;
  beLogoutButton?: Maybe<Scalars['String']['output']>;
  beLogoutConfirmationButton?: Maybe<Scalars['String']['output']>;
  beLogoutConfirmationMsg?: Maybe<Scalars['String']['output']>;
  beLogoutConfirmationTitle?: Maybe<Scalars['String']['output']>;
  beMadeByLabel?: Maybe<Scalars['String']['output']>;
  beMakeOneWayResButton?: Maybe<Scalars['String']['output']>;
  beManageTripsButton?: Maybe<Scalars['String']['output']>;
  beMapPopupLinkLabel?: Maybe<Scalars['String']['output']>;
  beMarketingCode2Label?: Maybe<Scalars['String']['output']>;
  beMarketingCode3Label?: Maybe<Scalars['String']['output']>;
  beMarketingCodeLabel?: Maybe<Scalars['String']['output']>;
  beNameLabel?: Maybe<Scalars['String']['output']>;
  beNearbyLocsAway?: Maybe<Scalars['String']['output']>;
  beNearbyLocsFeet?: Maybe<Scalars['String']['output']>;
  beNearbyLocsHeaderMsgLocAvailable?: Maybe<Scalars['String']['output']>;
  beNearbyLocsHeaderMsgLocNotAvailable?: Maybe<Scalars['String']['output']>;
  beNearbyLocsHeaderPrefix?: Maybe<Scalars['String']['output']>;
  beNearbyLocsMiles?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectHeaderNearbyLocs?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectHeaderReqLoc?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectSubheadNearbyLocs?: Maybe<Scalars['String']['output']>;
  beNearbyLocsSectSubheadReqLoc?: Maybe<Scalars['String']['output']>;
  beNewProfileBackButton?: Maybe<Scalars['String']['output']>;
  beNewProfileSubmitButton?: Maybe<Scalars['String']['output']>;
  beNewProfileTitle?: Maybe<Scalars['String']['output']>;
  beNewTotalLabel?: Maybe<Scalars['String']['output']>;
  bePaginationOf?: Maybe<Scalars['String']['output']>;
  bePassengersHeader?: Maybe<Scalars['String']['output']>;
  bePasswordAriaHide?: Maybe<Scalars['String']['output']>;
  bePasswordAriaShow?: Maybe<Scalars['String']['output']>;
  bePasswordLabel?: Maybe<Scalars['String']['output']>;
  bePaymentCashPayment?: Maybe<Scalars['String']['output']>;
  bePaymentCashSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentCcDialogSaveButton?: Maybe<Scalars['String']['output']>;
  bePaymentCcDialogTitle?: Maybe<Scalars['String']['output']>;
  bePaymentCcDifferentCardLabel?: Maybe<Scalars['String']['output']>;
  bePaymentCcSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentCcTokenizedEndingIn?: Maybe<Scalars['String']['output']>;
  bePaymentCcTokenizedExpires?: Maybe<Scalars['String']['output']>;
  bePaymentDbSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentDirectbillPayment?: Maybe<Scalars['String']['output']>;
  bePaymentPaidWithPoints?: Maybe<Scalars['String']['output']>;
  bePaymentRemoveButton?: Maybe<Scalars['String']['output']>;
  bePaymentSectionTitle?: Maybe<Scalars['String']['output']>;
  bePaymentnotesCc?: Maybe<Scalars['String']['output']>;
  bePaymentnotesCc2?: Maybe<Scalars['String']['output']>;
  bePaymentnotesDb?: Maybe<Scalars['String']['output']>;
  bePaymentnotesFr?: Maybe<Scalars['String']['output']>;
  bePhoneLabel?: Maybe<Scalars['String']['output']>;
  bePickupDateLabel?: Maybe<Scalars['String']['output']>;
  bePickupDirectionsLabel?: Maybe<Scalars['String']['output']>;
  bePickupLocLabel?: Maybe<Scalars['String']['output']>;
  bePickupTimeArrive?: Maybe<Scalars['String']['output']>;
  bePickupTimeAvailableSeats?: Maybe<Scalars['String']['output']>;
  bePickupTimeFilterLabel?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightHours?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightMinutes?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightPreArr?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightPreDep?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightSufArr?: Maybe<Scalars['String']['output']>;
  bePickupTimeFlightSufDep?: Maybe<Scalars['String']['output']>;
  bePickupTimeHeaderArr?: Maybe<Scalars['String']['output']>;
  bePickupTimeHeaderDep?: Maybe<Scalars['String']['output']>;
  bePickupTimeHeaderPtp?: Maybe<Scalars['String']['output']>;
  bePickupTimeLabel?: Maybe<Scalars['String']['output']>;
  bePickupTimeOffPeak?: Maybe<Scalars['String']['output']>;
  bePickupTimeShortNotice?: Maybe<Scalars['String']['output']>;
  bePickupTimeShowAdtlTimes?: Maybe<Scalars['String']['output']>;
  bePickupTimeShowButton?: Maybe<Scalars['String']['output']>;
  bePickupTimeTravelTime?: Maybe<Scalars['String']['output']>;
  bePickupTimeUserSelectDiffAfter?: Maybe<Scalars['String']['output']>;
  bePickupTimeUserSelectDiffBefore?: Maybe<Scalars['String']['output']>;
  bePickupTimeUserSelectDiffSame?: Maybe<Scalars['String']['output']>;
  bePickuptimeSectionTitle?: Maybe<Scalars['String']['output']>;
  bePointsDontUsePtsLabel?: Maybe<Scalars['String']['output']>;
  bePointsMinPointsLabel?: Maybe<Scalars['String']['output']>;
  bePointsNewTotalLabel?: Maybe<Scalars['String']['output']>;
  bePointsNumPointsLabel?: Maybe<Scalars['String']['output']>;
  bePointsPointsAvailSfx?: Maybe<Scalars['String']['output']>;
  bePointsSectionTitle?: Maybe<Scalars['String']['output']>;
  beProfileAccountButton?: Maybe<Scalars['String']['output']>;
  beProfileAltphoneLabel?: Maybe<Scalars['String']['output']>;
  beProfileCcAddSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileCcAddSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileCcAddTitle?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveDialogMessage?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveDialogSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveDialogTitle?: Maybe<Scalars['String']['output']>;
  beProfileCcRemoveSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileCcSavedCardsTitle?: Maybe<Scalars['String']['output']>;
  beProfileContactSectionTitle?: Maybe<Scalars['String']['output']>;
  beProfileContactTab?: Maybe<Scalars['String']['output']>;
  beProfileEmailLabel?: Maybe<Scalars['String']['output']>;
  beProfileHomeTitle?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelClientid?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelData1?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelData2?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelGroupid?: Maybe<Scalars['String']['output']>;
  beProfileLgLabelWebid?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsCancelButton?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsChangeButton?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsTab?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsTitle?: Maybe<Scalars['String']['output']>;
  beProfileLinkedGroupsValidatedLabel?: Maybe<Scalars['String']['output']>;
  beProfileLocationTypeLabel?: Maybe<Scalars['String']['output']>;
  beProfileLocationsAddButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsAddSuccess?: Maybe<Scalars['String']['output']>;
  beProfileLocationsDeleteSuccess?: Maybe<Scalars['String']['output']>;
  beProfileLocationsEditButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsFieldLabel?: Maybe<Scalars['String']['output']>;
  beProfileLocationsNewLocSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsNewLocTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsNewUpdateLocCancelButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogCancelButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogConfirmButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogConfirmMessage?: Maybe<Scalars['String']['output']>;
  beProfileLocationsRemoveDialogTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsTab?: Maybe<Scalars['String']['output']>;
  beProfileLocationsTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsUpdateLocSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileLocationsUpdateLocTitle?: Maybe<Scalars['String']['output']>;
  beProfileLocationsUpdateSuccess?: Maybe<Scalars['String']['output']>;
  beProfileNameLabel?: Maybe<Scalars['String']['output']>;
  beProfilePasswordLabel?: Maybe<Scalars['String']['output']>;
  beProfilePasswordTab?: Maybe<Scalars['String']['output']>;
  beProfilePasswordTitle?: Maybe<Scalars['String']['output']>;
  beProfilePaymentTab?: Maybe<Scalars['String']['output']>;
  beProfilePhoneLabel?: Maybe<Scalars['String']['output']>;
  beProfilePointsTab?: Maybe<Scalars['String']['output']>;
  beProfilePointsTableExpiresPrefix?: Maybe<Scalars['String']['output']>;
  beProfilePointsTableResidPrefix?: Maybe<Scalars['String']['output']>;
  beProfilePointsTitle?: Maybe<Scalars['String']['output']>;
  beProfilePointsTransactionsTitle?: Maybe<Scalars['String']['output']>;
  beProfileResNoResMessage?: Maybe<Scalars['String']['output']>;
  beProfileResNoResMessageTitle?: Maybe<Scalars['String']['output']>;
  beProfileResOpenTab?: Maybe<Scalars['String']['output']>;
  beProfileResPastTab?: Maybe<Scalars['String']['output']>;
  beProfileResUpcomingTab?: Maybe<Scalars['String']['output']>;
  beProfileResViewDetailsButton?: Maybe<Scalars['String']['output']>;
  beProfileResViewDetailsOpenButton?: Maybe<Scalars['String']['output']>;
  beProfileReservationsTab?: Maybe<Scalars['String']['output']>;
  beProfileUpdateSubmitButton?: Maybe<Scalars['String']['output']>;
  beProfileUpdateSuccessMsg?: Maybe<Scalars['String']['output']>;
  beProfileUsernameLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonAltphoneLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveDialogMessage?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveDialogSubmitButton?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveDialogTitle?: Maybe<Scalars['String']['output']>;
  bePudPersonCcRemoveSuccessMsg?: Maybe<Scalars['String']['output']>;
  bePudPersonCcSectionTitle?: Maybe<Scalars['String']['output']>;
  bePudPersonContactSectionTitle?: Maybe<Scalars['String']['output']>;
  bePudPersonEmailLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonFaxLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonNameLabel?: Maybe<Scalars['String']['output']>;
  bePudPersonPhoneLabel?: Maybe<Scalars['String']['output']>;
  beReferralsHead?: Maybe<Scalars['String']['output']>;
  beRemoveCouponLabel?: Maybe<Scalars['String']['output']>;
  beRemoveLegButton?: Maybe<Scalars['String']['output']>;
  beRequiredPlaceholder?: Maybe<Scalars['String']['output']>;
  beResetpwContent?: Maybe<Scalars['String']['output']>;
  beResetpwNewPasswordLabel?: Maybe<Scalars['String']['output']>;
  beResetpwSubmitButton?: Maybe<Scalars['String']['output']>;
  beResetpwSuccessMsg?: Maybe<Scalars['String']['output']>;
  beResetpwTitle?: Maybe<Scalars['String']['output']>;
  beReslookupHead?: Maybe<Scalars['String']['output']>;
  beReslookupResnumLabel?: Maybe<Scalars['String']['output']>;
  beReslookupValidationTypeLabel?: Maybe<Scalars['String']['output']>;
  beReslookupValidationValueLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryAmountPaidLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryBackButton?: Maybe<Scalars['String']['output']>;
  beRessummaryCancelledLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryCashPayment?: Maybe<Scalars['String']['output']>;
  beRessummaryDirectbillPayment?: Maybe<Scalars['String']['output']>;
  beRessummaryFlightSectionTitle?: Maybe<Scalars['String']['output']>;
  beRessummaryHead?: Maybe<Scalars['String']['output']>;
  beRessummaryPickupAtLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryPointsUsedLabel?: Maybe<Scalars['String']['output']>;
  beRessummaryTotalLabel?: Maybe<Scalars['String']['output']>;
  beReturnTripHeader?: Maybe<Scalars['String']['output']>;
  beSelectNoOptions?: Maybe<Scalars['String']['output']>;
  beSendResetpwBackButton?: Maybe<Scalars['String']['output']>;
  beSendResetpwContent?: Maybe<Scalars['String']['output']>;
  beSendResetpwSubmitButton?: Maybe<Scalars['String']['output']>;
  beSendResetpwSuccessMsg?: Maybe<Scalars['String']['output']>;
  beSendResetpwTitle?: Maybe<Scalars['String']['output']>;
  beServiceExtraEachLabel?: Maybe<Scalars['String']['output']>;
  beServiceExtrasHeader?: Maybe<Scalars['String']['output']>;
  beServicePsgrsMaximum?: Maybe<Scalars['String']['output']>;
  beServiceSelectButton?: Maybe<Scalars['String']['output']>;
  beServiceStartingAt?: Maybe<Scalars['String']['output']>;
  beSidebarHeader?: Maybe<Scalars['String']['output']>;
  beSidebarPointsUsedLabel?: Maybe<Scalars['String']['output']>;
  beSidebarResidLabel?: Maybe<Scalars['String']['output']>;
  beSidebarTotalLabel?: Maybe<Scalars['String']['output']>;
  beSpecialInstr2Label?: Maybe<Scalars['String']['output']>;
  beSpecialInstrLabel?: Maybe<Scalars['String']['output']>;
  beSrvextraSelectBlank?: Maybe<Scalars['String']['output']>;
  beStopsAddButton?: Maybe<Scalars['String']['output']>;
  beStopsCommentsLabel?: Maybe<Scalars['String']['output']>;
  beStopsDirectionsLabel?: Maybe<Scalars['String']['output']>;
  beStopsHeader?: Maybe<Scalars['String']['output']>;
  beStopsNameLabel?: Maybe<Scalars['String']['output']>;
  beStopsNotAllowed?: Maybe<Scalars['String']['output']>;
  beStopsRemoveButton?: Maybe<Scalars['String']['output']>;
  beStopsSectionTitle?: Maybe<Scalars['String']['output']>;
  beStopsStopPrefix?: Maybe<Scalars['String']['output']>;
  beSuggestcreateConfirm?: Maybe<Scalars['String']['output']>;
  beSuggestcreateContent?: Maybe<Scalars['String']['output']>;
  beSuggestcreateSaveButton?: Maybe<Scalars['String']['output']>;
  beSuggestcreateTitle?: Maybe<Scalars['String']['output']>;
  beSuggestloginContent?: Maybe<Scalars['String']['output']>;
  beSuggestloginLoginButton?: Maybe<Scalars['String']['output']>;
  beSuggestloginTitle?: Maybe<Scalars['String']['output']>;
  beTermsConditionsLabel?: Maybe<Scalars['String']['output']>;
  beTermsConditionsUrl?: Maybe<Scalars['String']['output']>;
  beTermsConditionsUrlLabel?: Maybe<Scalars['String']['output']>;
  beUsernameLabel?: Maybe<Scalars['String']['output']>;
  beVarianceNegativeLabel?: Maybe<Scalars['String']['output']>;
  beVariancePositiveLabel?: Maybe<Scalars['String']['output']>;
  beVarianceZero?: Maybe<Scalars['String']['output']>;
  beWebSubfareACaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareBCaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareCCaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareDCaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareECaption?: Maybe<Scalars['String']['output']>;
  beWebSubfareSummary?: Maybe<Scalars['String']['output']>;
  beWebSubfaresContent?: Maybe<Scalars['String']['output']>;
  beWebSubfaresHeader?: Maybe<Scalars['String']['output']>;
  ccVLabel?: Maybe<Scalars['String']['output']>;
  charterName?: Maybe<Scalars['String']['output']>;
  commentsLabel?: Maybe<Scalars['String']['output']>;
  couponName?: Maybe<Scalars['String']['output']>;
  creditCardCancelLabel?: Maybe<Scalars['String']['output']>;
  creditCardChangeLabel?: Maybe<Scalars['String']['output']>;
  creditCardExpLabel?: Maybe<Scalars['String']['output']>;
  creditCardNameLabel?: Maybe<Scalars['String']['output']>;
  creditCardNumLabel?: Maybe<Scalars['String']['output']>;
  creditCardSecCodeLabel?: Maybe<Scalars['String']['output']>;
  creditCardZipLabel?: Maybe<Scalars['String']['output']>;
  customTip?: Maybe<Scalars['String']['output']>;
  customTipPlaceholder?: Maybe<Scalars['String']['output']>;
  daContinueButton?: Maybe<Scalars['String']['output']>;
  daDriverDetailEmpty?: Maybe<Scalars['String']['output']>;
  daDriverShiftDetailEmpty?: Maybe<Scalars['String']['output']>;
  daErrFieldRequired?: Maybe<Scalars['String']['output']>;
  daErrSessionExpired?: Maybe<Scalars['String']['output']>;
  daErrSystemError?: Maybe<Scalars['String']['output']>;
  daErrorDialogOkBtn?: Maybe<Scalars['String']['output']>;
  daExternalAppClose?: Maybe<Scalars['String']['output']>;
  daExternalAppTitle?: Maybe<Scalars['String']['output']>;
  daGridClearAllFilters?: Maybe<Scalars['String']['output']>;
  daGridCurrentPage?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsBreakLabel?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsConfirmed?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsDriverFallback?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsNotConfirmed?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsOdometerEndLabel?: Maybe<Scalars['String']['output']>;
  daGridDriverShiftsOdometerStartLabel?: Maybe<Scalars['String']['output']>;
  daGridDriversIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridFilterColumns?: Maybe<Scalars['String']['output']>;
  daGridFilterColumnsActive?: Maybe<Scalars['String']['output']>;
  daGridFilteredCount?: Maybe<Scalars['String']['output']>;
  daGridLoadError?: Maybe<Scalars['String']['output']>;
  daGridNextPage?: Maybe<Scalars['String']['output']>;
  daGridNoFilterResults?: Maybe<Scalars['String']['output']>;
  daGridPage?: Maybe<Scalars['String']['output']>;
  daGridPageRange?: Maybe<Scalars['String']['output']>;
  daGridPaginationNav?: Maybe<Scalars['String']['output']>;
  daGridPrevPage?: Maybe<Scalars['String']['output']>;
  daGridQuickFilterDefault?: Maybe<Scalars['String']['output']>;
  daGridQuickfactActual?: Maybe<Scalars['String']['output']>;
  daGridQuickfactActualend?: Maybe<Scalars['String']['output']>;
  daGridQuickfactActualstart?: Maybe<Scalars['String']['output']>;
  daGridQuickfactBagcount?: Maybe<Scalars['String']['output']>;
  daGridQuickfactColor?: Maybe<Scalars['String']['output']>;
  daGridQuickfactDistance?: Maybe<Scalars['String']['output']>;
  daGridQuickfactDriver?: Maybe<Scalars['String']['output']>;
  daGridQuickfactEmail?: Maybe<Scalars['String']['output']>;
  daGridQuickfactEmployeeid?: Maybe<Scalars['String']['output']>;
  daGridQuickfactExtras?: Maybe<Scalars['String']['output']>;
  daGridQuickfactExtrastops?: Maybe<Scalars['String']['output']>;
  daGridQuickfactFare?: Maybe<Scalars['String']['output']>;
  daGridQuickfactFlight?: Maybe<Scalars['String']['output']>;
  daGridQuickfactFueltype?: Maybe<Scalars['String']['output']>;
  daGridQuickfactLayout?: Maybe<Scalars['String']['output']>;
  daGridQuickfactMakemodel?: Maybe<Scalars['String']['output']>;
  daGridQuickfactMaxpass?: Maybe<Scalars['String']['output']>;
  daGridQuickfactPax?: Maybe<Scalars['String']['output']>;
  daGridQuickfactReporttime?: Maybe<Scalars['String']['output']>;
  daGridQuickfactStartlocation?: Maybe<Scalars['String']['output']>;
  daGridQuickfactStatus?: Maybe<Scalars['String']['output']>;
  daGridQuickfactStops?: Maybe<Scalars['String']['output']>;
  daGridQuickfactTelephone?: Maybe<Scalars['String']['output']>;
  daGridQuickfactTelephone2?: Maybe<Scalars['String']['output']>;
  daGridQuickfactVehicle?: Maybe<Scalars['String']['output']>;
  daGridQuickfactVehicletype?: Maybe<Scalars['String']['output']>;
  daGridRefreshLabel?: Maybe<Scalars['String']['output']>;
  daGridRefreshingLabel?: Maybe<Scalars['String']['output']>;
  daGridReservationsIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridRouteDropoffLabel?: Maybe<Scalars['String']['output']>;
  daGridRoutePickupLabel?: Maybe<Scalars['String']['output']>;
  daGridStaleAt?: Maybe<Scalars['String']['output']>;
  daGridTripsIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daGridUpdatedAt?: Maybe<Scalars['String']['output']>;
  daGridVehiclesIdentifierKicker?: Maybe<Scalars['String']['output']>;
  daHotkeyErrGeneric?: Maybe<Scalars['String']['output']>;
  daHotkeyErrInvalidProtocol?: Maybe<Scalars['String']['output']>;
  daHotkeyErrNoUrl?: Maybe<Scalars['String']['output']>;
  daLoginSubmitButton?: Maybe<Scalars['String']['output']>;
  daLoginTitle?: Maybe<Scalars['String']['output']>;
  daMessagesComposerPlaceholder?: Maybe<Scalars['String']['output']>;
  daMessagesComposerSendError?: Maybe<Scalars['String']['output']>;
  daMessagesEmpty?: Maybe<Scalars['String']['output']>;
  daMessagesLoadOlder?: Maybe<Scalars['String']['output']>;
  daMessagesOlderCount?: Maybe<Scalars['String']['output']>;
  daMsgMarkRead?: Maybe<Scalars['String']['output']>;
  daPasswordLabel?: Maybe<Scalars['String']['output']>;
  daRefreshErrorFallback?: Maybe<Scalars['String']['output']>;
  daRequiredPlaceholder?: Maybe<Scalars['String']['output']>;
  daResCancelledBadge?: Maybe<Scalars['String']['output']>;
  daResDetailEmpty?: Maybe<Scalars['String']['output']>;
  daResFlightArrivesLabel?: Maybe<Scalars['String']['output']>;
  daResFlightCityLabel?: Maybe<Scalars['String']['output']>;
  daResFlightDepartsLabel?: Maybe<Scalars['String']['output']>;
  daResFlightNumberLabel?: Maybe<Scalars['String']['output']>;
  daResFlightTerminalLabel?: Maybe<Scalars['String']['output']>;
  daResFlightTimeLabel?: Maybe<Scalars['String']['output']>;
  daResFlightTypeDomestic?: Maybe<Scalars['String']['output']>;
  daResFlightTypeInternational?: Maybe<Scalars['String']['output']>;
  daResFlightTypeLabel?: Maybe<Scalars['String']['output']>;
  daResPaymentTypeLabel?: Maybe<Scalars['String']['output']>;
  daSidebarCollapseBtn?: Maybe<Scalars['String']['output']>;
  daSidebarExpandBtn?: Maybe<Scalars['String']['output']>;
  daSidebarLogoutBtn?: Maybe<Scalars['String']['output']>;
  daSidebarUserMenuBtn?: Maybe<Scalars['String']['output']>;
  daTripDetailEmpty?: Maybe<Scalars['String']['output']>;
  daUsernameLabel?: Maybe<Scalars['String']['output']>;
  daVehicleDetailEmpty?: Maybe<Scalars['String']['output']>;
  daVehiclePaxLabel?: Maybe<Scalars['String']['output']>;
  defaultTipsLabel?: Maybe<Scalars['String']['output']>;
  genericSubmitError?: Maybe<Scalars['String']['output']>;
  gratuityAddTipLabel?: Maybe<Scalars['String']['output']>;
  gratuityInvalidError?: Maybe<Scalars['String']['output']>;
  gratuityMaxError?: Maybe<Scalars['String']['output']>;
  gratuityMessage?: Maybe<Scalars['String']['output']>;
  gratuityNegativeError?: Maybe<Scalars['String']['output']>;
  gratuityNoTip?: Maybe<Scalars['String']['output']>;
  gratuityRequiredError?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  headerMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invalidCardNumberError?: Maybe<Scalars['String']['output']>;
  invalidExpirationError?: Maybe<Scalars['String']['output']>;
  invalidUrl?: Maybe<Scalars['String']['output']>;
  landingMessage?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logo2?: Maybe<Scalars['String']['output']>;
  ratingRangeError?: Maybe<Scalars['String']['output']>;
  requiredError?: Maybe<Scalars['String']['output']>;
  reviewRideTitle?: Maybe<Scalars['String']['output']>;
  routeSeparator?: Maybe<Scalars['String']['output']>;
  serviceAreaName?: Maybe<Scalars['String']['output']>;
  submitButtonLabel?: Maybe<Scalars['String']['output']>;
  successfulSubmitMessage?: Maybe<Scalars['String']['output']>;
  templateErrorFallback?: Maybe<Scalars['String']['output']>;
  templateInputNumericError?: Maybe<Scalars['String']['output']>;
  templateInputRequiredError?: Maybe<Scalars['String']['output']>;
  templateLoadErrorBody?: Maybe<Scalars['String']['output']>;
  templateLoadErrorTitle?: Maybe<Scalars['String']['output']>;
  templateSelectPlaceholder?: Maybe<Scalars['String']['output']>;
  templateSuccessFallback?: Maybe<Scalars['String']['output']>;
};

/** Response type for tokenize mutation */
export type TokenizePayload = MutationResponse & {
  __typename?: 'TokenizePayload';
  /** Credit card expiration date */
  ccExpiration?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of credit card */
  ccLast4?: Maybe<Scalars['String']['output']>;
  /** Encrypted credit card token */
  ccToken?: Maybe<Scalars['String']['output']>;
  /** General error message */
  error?: Maybe<Scalars['String']['output']>;
  /** Type of error if any */
  errorType?: Maybe<Scalars['String']['output']>;
  /** Human-readable message */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type TokenizedCreditCard = {
  __typename?: 'TokenizedCreditCard';
  expiration?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numberLast4?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  refId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  typeCode?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export enum TopLocationsMode {
  Hide = 'hide',
  Show = 'show'
}

/** A single (id, name) reference-data row inside a translation list. */
export type TranslationEntry = {
  __typename?: 'TranslationEntry';
  /** Raw id verbatim from Bridge (numeric-shaped strings, single-letter codes, etc. — not coerced). */
  id: Scalars['String']['output'];
  /** Human-readable label for the id. */
  name: Scalars['String']['output'];
};

/** A named reference-data list returned by the Bridge translations command. */
export type TranslationList = {
  __typename?: 'TranslationList';
  /** Entries in source order. Empty arrays are legitimate; duplicates are not deduped. */
  entries: Array<TranslationEntry>;
  /** List name as Bridge emits it (camelCase preserved; lowercasing is a client-layer concern). */
  name: Scalars['String']['output'];
};

export type UpdateDriverShiftInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  comments2?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['Int']['input'];
  endMilage?: InputMaybe<Scalars['Float']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  scheduledEndTime: Scalars['String']['input'];
  scheduledStartTime: Scalars['String']['input'];
  startLocation?: InputMaybe<Scalars['String']['input']>;
  startMilage?: InputMaybe<Scalars['Float']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  vehicleId: Scalars['Int']['input'];
  vehicleName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDriverShiftPayload = MutationResponse & {
  __typename?: 'UpdateDriverShiftPayload';
  driverShift?: Maybe<DriverShift>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserProfilePayload = MutationResponse & {
  __typename?: 'UpdateUserProfilePayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum UserApp {
  /** The driver mobile application */
  DriverApp = 'DriverApp',
  /** The administration web application */
  Hub = 'Hub'
}

export type UserProfileAddCcPayload = MutationResponse & {
  __typename?: 'UserProfileAddCcPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileAddPudResponse = MutationResponse & {
  __typename?: 'UserProfileAddPudResponse';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileAddValpayCcPayload = MutationResponse & {
  __typename?: 'UserProfileAddValpayCcPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileDeleteCcPayload = MutationResponse & {
  __typename?: 'UserProfileDeleteCcPayload';
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UserProfileDeletePudCcPayload = MutationResponse & {
  __typename?: 'UserProfileDeletePudCcPayload';
  /** Error message if the deletion failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Type of error that occurred */
  errorType?: Maybe<Scalars['String']['output']>;
  /** General message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the credit card deletion from PUD was successful */
  success: Scalars['Boolean']['output'];
};

export type UserProfileDeletePudPayload = MutationResponse & {
  __typename?: 'UserProfileDeletePudPayload';
  /** Error message if the deletion failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Type of error that occurred */
  errorType?: Maybe<Scalars['String']['output']>;
  /** General message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the PUD deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type UserProfileExists = {
  __typename?: 'UserProfileExists';
  /** Whether a profile exists for this email */
  exists: Scalars['Boolean']['output'];
  /**
   * Whether the profile has a password set
   * Only meaningful when exists is true
   */
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Composite ID in format "siteId:email" */
  id: Scalars['ID']['output'];
  /** The profile ID if found */
  profileId?: Maybe<Scalars['Int']['output']>;
};

export type UserProfileLinkGroupPayload = MutationResponse & {
  __typename?: 'UserProfileLinkGroupPayload';
  /** Error message if the link operation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Type of error that occurred */
  errorType?: Maybe<Scalars['String']['output']>;
  /** General message about the operation result */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the profile link to group was successful */
  success: Scalars['Boolean']['output'];
};

export type UserProfileUpdatePudResponse = MutationResponse & {
  __typename?: 'UserProfileUpdatePudResponse';
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ValidateUserPayload = MutationResponse & {
  __typename?: 'ValidateUserPayload';
  auth?: Maybe<Auth>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<ValidatedUser>;
};

export type ValidatedUser = {
  __typename?: 'ValidatedUser';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ValpayConfig = {
  __typename?: 'ValpayConfig';
  /** Client key for frontend Adyen integration */
  clientKey?: Maybe<Scalars['String']['output']>;
  /** Whether Valpay is enabled for the current site/processor combination */
  enabled: Scalars['Boolean']['output'];
  /** Adyen environment: 'test' or 'live' */
  environment?: Maybe<Scalars['String']['output']>;
  /** Error message if configuration or API call failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Composite ID in format: {processor_id}-{shopper_reference}-{response_id} */
  id?: Maybe<Scalars['ID']['output']>;
  /** JSON string containing available payment methods from Adyen */
  paymentMethods?: Maybe<Scalars['String']['output']>;
};

/** Vehicle information */
export type Vehicle = {
  __typename?: 'Vehicle';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/**
 * Response payload for verifyResForCheckIn mutation.
 * Returns reservation details and check-in options for the user to select from.
 */
export type VerifyResForCheckInPayload = MutationResponse & {
  __typename?: 'VerifyResForCheckInPayload';
  auth?: Maybe<Auth>;
  /** Check-in options including summary for the user to select from */
  checkIn?: Maybe<CheckInOptions>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** The verified reservation ID */
  resId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type VerifyResPayload = MutationResponse & {
  __typename?: 'VerifyResPayload';
  auth?: Maybe<Auth>;
  /** Check-in options including summary (returned when appName supports check-in) */
  checkIn?: Maybe<CheckInOptions>;
  errorType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  resId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/** GPS waypoint data for vehicles and drivers */
export type Waypoint = {
  __typename?: 'Waypoint';
  driver?: Maybe<Driver>;
  heading?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  position?: Maybe<LatLng>;
  recordedTime?: Maybe<Scalars['String']['output']>;
  speed?: Maybe<Scalars['Int']['output']>;
  vehicle?: Maybe<Vehicle>;
};

/** Filter for waypoint queries */
export type WaypointFilterInput = {
  field: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AirlineFragment = { __typename?: 'Airline', id: string, name: string, code: string, terminal?: { __typename?: 'AirlineTerminal', domesticArrival?: string | null, domesticDeparture?: string | null, internationalArrival?: string | null, internationalDeparture?: string | null } | null };

export type AirlinesQueryVariables = Exact<{
  airportCode: Scalars['String']['input'];
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenGroup: Scalars['String']['input'];
}>;


export type AirlinesQuery = { __typename?: 'Query', airlines: Array<{ __typename?: 'Airline', id: string, name: string, code: string, terminal?: { __typename?: 'AirlineTerminal', domesticArrival?: string | null, domesticDeparture?: string | null, internationalArrival?: string | null, internationalDeparture?: string | null } | null } | null>, content?: { __typename?: 'TokenContent', id: string, beErrFieldRequired?: string | null, beErrAirline?: string | null, beAirlineLabel?: string | null, beSelectNoOptions?: string | null } | null };

export type AttachCouponMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
  legs?: InputMaybe<Array<ServicesInput> | ServicesInput>;
}>;


export type AttachCouponMutation = { __typename?: 'Mutation', attachCoupon?: { __typename?: 'AttachCouponResponse', errorType?: string | null, success: boolean, message?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type AttachGroupProfileMutationVariables = Exact<{
  id: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
}>;


export type AttachGroupProfileMutation = { __typename?: 'Mutation', attachGroupProfile?: { __typename?: 'AttachGroupProfileResponse', errorType?: string | null, success: boolean, message?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type AutocompleteLocationFragment = { __typename?: 'Location', id: string, displayAddress?: string | null, displayName: string, code: string, type: string, typeString: string };

export type AutocompleteLocationUniversalFragment = { __typename?: 'Location', id: string, displayAddress?: string | null, displayName: string, code: string, city?: string | null, fullState?: string | null, metadata: string, serviceAreas: Array<number>, state?: string | null, string?: string | null, type: string, typeString: string, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null };

export type BookMutationVariables = Exact<{
  booking: BookBookingType;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BookMutation = { __typename?: 'Mutation', book: { __typename?: 'BookPayload', error?: string | null, itineraryId?: string | null, resErrors?: Array<string | null> | null, resIds?: Array<string | null> | null } };

export type CancelResMutationVariables = Exact<{
  resId: Scalars['Int']['input'];
}>;


export type CancelResMutation = { __typename?: 'Mutation', cancelRes: { __typename?: 'CancelResPayload', errorType?: string | null, success: boolean, message?: string | null } };

export type ColorsFragment = { __typename?: 'Colors', id: string, primaryColor: string, primaryHover: string, primaryText: string };

export type ColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ColorsQuery = { __typename?: 'Query', colors?: { __typename?: 'Colors', id: string, primaryColor: string, primaryHover: string, primaryText: string } | null };

export type ConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigQuery = { __typename?: 'Query', config: { __typename?: 'Configuration', currency: string, defaultServiceArea: number, googleAnalyticsId: string, googleApiKey: string, gtmId?: string | null, requireLoginForBooking: boolean } };

export type ConvertResMutationVariables = Exact<{
  resId: Scalars['Int']['input'];
}>;


export type ConvertResMutation = { __typename?: 'Mutation', convertRes: { __typename?: 'ConvertResPayload', errorType?: string | null, success: boolean, message?: string | null } };

export type DefaultsFragmentFragment = { __typename?: 'Defaults', id: string, email?: string | null, faxNumber?: string | null, gratuityPercents?: Array<number> | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, name?: string | null, telephone?: string | null, telephone2?: string | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null }> | null };

export type DefaultsQueryVariables = Exact<{
  pudId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DefaultsQuery = { __typename?: 'Query', defaults: { __typename?: 'Defaults', id: string, email?: string | null, faxNumber?: string | null, gratuityPercents?: Array<number> | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, name?: string | null, telephone?: string | null, telephone2?: string | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null }> | null } };

export type DetachAllProfilesMutationVariables = Exact<{ [key: string]: never; }>;


export type DetachAllProfilesMutation = { __typename?: 'Mutation', detachAllProfiles?: { __typename?: 'DetachAllProfilesResponse', success: boolean, message?: string | null, errorType?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type DetachCharterProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type DetachCharterProfileMutation = { __typename?: 'Mutation', detachCharterProfile?: { __typename?: 'DetachCharterProfileResponse', success: boolean, message?: string | null, errorType?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type DetachCouponMutationVariables = Exact<{ [key: string]: never; }>;


export type DetachCouponMutation = { __typename?: 'Mutation', detachCoupon?: { __typename?: 'DetachCouponResponse', success: boolean, message?: string | null, errorType?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type DetachGroupProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type DetachGroupProfileMutation = { __typename?: 'Mutation', detachGroupProfile?: { __typename?: 'DetachGroupProfileResponse', success: boolean, message?: string | null, errorType?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type DetachSalesProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type DetachSalesProfileMutation = { __typename?: 'Mutation', detachSalesProfile?: { __typename?: 'DetachSalesProfileResponse', success: boolean, message?: string | null, errorType?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type EpicPassValidateQueryVariables = Exact<{
  passId: Scalars['String']['input'];
}>;


export type EpicPassValidateQuery = { __typename?: 'Query', epicPassValidate: { __typename?: 'EpicPassReturn', valid: boolean } };

export type EpicPassValidateDateQueryVariables = Exact<{
  passId: Scalars['String']['input'];
  pickupDate: Scalars['String']['input'];
}>;


export type EpicPassValidateDateQuery = { __typename?: 'Query', epicPassValidateDate: { __typename?: 'EpicPassReturn', valid: boolean } };

export type FareKeyLookupFragment = { __typename?: 'FareKeyLookupReturn', error?: boolean | null, errorMessage?: string | null, fklRequest?: string | null, fklResponse?: string | null, lookupType?: number | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null, nearbyLocations?: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> | null };

export type FareKeyLookupQueryVariables = Exact<{
  displayAddress?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  googleObject?: InputMaybe<Scalars['String']['input']>;
  typeString?: InputMaybe<Scalars['String']['input']>;
  fareCode?: InputMaybe<Scalars['String']['input']>;
  serviceAreaIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  sourceType: Scalars['Int']['input'];
}>;


export type FareKeyLookupQuery = { __typename?: 'Query', fareKeyLookup: { __typename?: 'FareKeyLookupReturn', error?: boolean | null, errorMessage?: string | null, fklRequest?: string | null, fklResponse?: string | null, lookupType?: number | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null, nearbyLocations?: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> | null } };

export type FixedLocationTypeFragment = { __typename?: 'FixedLocationType', id: string, label: string, locationCount: number, type: string, typeString: string, locations: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> };

export type FixedLocationTypesQueryVariables = Exact<{
  hidePuds?: InputMaybe<Scalars['Boolean']['input']>;
  pudId?: InputMaybe<Scalars['Int']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FixedLocationTypesQuery = { __typename?: 'Query', fixedLocationTypes: Array<{ __typename?: 'FixedLocationType', id: string, label: string, locationCount: number, type: string, typeString: string, locations: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> }> };

export type FrequentRiderPointsFragment = { __typename?: 'FrequentRiderPoints', availablePoints?: number | null, id: string, programId?: number | null, totalCredits?: number | null, totalDebits?: number | null, transactions?: Array<{ __typename?: 'FrequentRiderPointsTransaction', comments?: string | null, debitCredit?: string | null, description?: string | null, endDate?: string | null, expirationTod?: string | null, id: string, name?: string | null, points?: number | null, programId?: number | null, redemptionType?: string | null, resId?: number | null, status?: string | null, transactionDate?: string | null }> | null };

export type FrequentRiderPointsQueryVariables = Exact<{ [key: string]: never; }>;


export type FrequentRiderPointsQuery = { __typename?: 'Query', frequentRiderPoints: Array<{ __typename?: 'FrequentRiderPoints', availablePoints?: number | null, id: string, programId?: number | null, totalCredits?: number | null, totalDebits?: number | null, transactions?: Array<{ __typename?: 'FrequentRiderPointsTransaction', comments?: string | null, debitCredit?: string | null, description?: string | null, endDate?: string | null, expirationTod?: string | null, id: string, name?: string | null, points?: number | null, programId?: number | null, redemptionType?: string | null, resId?: number | null, status?: string | null, transactionDate?: string | null }> | null }> };

export type FrequentRiderProgramFragmentFragment = { __typename?: 'FrequentRiderProgram', id: string, cost: number, name: string, redemptionType: string, description?: string | null, redemptionDuration?: string | null, redemptionDefaultDate?: string | null, redemptionMaxUsage?: number | null, raw?: string | null, sellFarePer?: number | null, sellMinQuantity?: number | null, sellMaxQuantity?: number | null, sellType?: ProgramSellType | null, redemptionThreshold?: number | null, paymentPointsPerFareUnit?: number | null };

export type FrequentRiderProgramPurchaseMutationVariables = Exact<{
  booking: FrequentRiderProgramPurchaseType;
  frpProgramId: Scalars['Int']['input'];
  frpProgramCost?: InputMaybe<Scalars['Float']['input']>;
  frpProgramQuantity?: InputMaybe<Scalars['Int']['input']>;
  frpProgramStartDate?: InputMaybe<Scalars['String']['input']>;
  frpProgramEndDate?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FrequentRiderProgramPurchaseMutation = { __typename?: 'Mutation', frequentRiderProgramPurchase?: { __typename?: 'FrequentRiderProgramPurchasePayload', success: boolean, errorType?: string | null, message?: string | null, resId?: string | null } | null };

export type FrequentRiderProgramsQueryVariables = Exact<{
  redeemableForDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type FrequentRiderProgramsQuery = { __typename?: 'Query', frequentRiderPrograms: Array<{ __typename?: 'FrequentRiderProgram', id: string, cost: number, name: string, redemptionType: string, description?: string | null, redemptionDuration?: string | null, redemptionDefaultDate?: string | null, redemptionMaxUsage?: number | null, raw?: string | null, sellFarePer?: number | null, sellMinQuantity?: number | null, sellMaxQuantity?: number | null, sellType?: ProgramSellType | null, redemptionThreshold?: number | null, paymentPointsPerFareUnit?: number | null }> };

export type LocationFragment = { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null };

export type LocationQueryVariables = Exact<{
  fareCode: Scalars['String']['input'];
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationQuery = { __typename?: 'Query', location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null };

export type LocationListQueryVariables = Exact<{
  locationType: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationListQuery = { __typename?: 'Query', locationList: { __typename?: 'LocationList', pages: number, totalItems: number, locations: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> } };

export type LocationsForAutocompleteQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationsForAutocompleteQuery = { __typename?: 'Query', locationsForAutocomplete: Array<{ __typename?: 'Location', id: string, displayAddress?: string | null, displayName: string, code: string, type: string, typeString: string }> };

export type LocationsForAutocompleteUniversalQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsForAutocompleteUniversalQuery = { __typename?: 'Query', locationsForAutocomplete: Array<{ __typename?: 'Location', id: string, displayAddress?: string | null, displayName: string, code: string, city?: string | null, fullState?: string | null, metadata: string, serviceAreas: Array<number>, state?: string | null, string?: string | null, type: string, typeString: string, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }> };

export type LoginUserProfileMutationVariables = Exact<{
  emailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginUserProfileMutation = { __typename?: 'Mutation', loginUserProfile?: { __typename?: 'LoginUserProfileResponse', errorType?: string | null, success: boolean, message?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type LogoutUserProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserProfileMutation = { __typename?: 'Mutation', logoutUserProfile?: { __typename?: 'LogoutUserProfileResponse', success: boolean, message?: string | null, errorType?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type PassengerFragment = { __typename?: 'PassengerType', id: string, fieldName: string, label: string, maxPassengers: number, popup?: string | null, raw?: string | null };

export type PassengerTypesQueryVariables = Exact<{
  passengerTypesAlias?: InputMaybe<Scalars['String']['input']>;
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PassengerTypesQuery = { __typename?: 'Query', passengerTypes: Array<{ __typename?: 'PassengerType', id: string, fieldName: string, label: string, maxPassengers: number, popup?: string | null, raw?: string | null }> };

export type ProcessPidMutationVariables = Exact<{
  pid?: InputMaybe<Scalars['String']['input']>;
  forceGroup?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessPidMutation = { __typename?: 'Mutation', processPid: { __typename?: 'ProcessPidPayload', success: boolean, message?: string | null, mode?: string | null, decryptedParams?: string | null, auth?: { __typename?: 'Auth', token?: string | null } | null } };

export type ProfileAddMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  webId?: InputMaybe<Scalars['String']['input']>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProfileAddMutation = { __typename?: 'Mutation', profileAdd?: { __typename?: 'ProfileAddPayload', errorType?: string | null, message?: string | null, profileId?: number | null, success: boolean, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export type ProfilePreferredLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfilePreferredLocationsQuery = { __typename?: 'Query', profilePreferredLocations: Array<{ __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null> };

export type ProfileReservationsQueryVariables = Exact<{
  dateRange?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProfileReservationsQuery = { __typename?: 'Query', profileReservations: Array<{ __typename?: 'Reservation', id: string, resId?: string | null, resIdInternal: number, cancelled: boolean, bagCount: number, pickup: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, dropoff: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, service?: { __typename?: 'Service', selectedTime?: { __typename?: 'SelectedTime', pickupTime?: string | null } | null } | null, passengers: Array<{ __typename?: 'ResFieldValue', field: string, value: number }> } | null> };

export type PudFragmentFragment = { __typename?: 'ProfileLocation', id: string, address?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, directions?: string | null, displayName?: string | null, name?: string | null, sector?: string | null, state?: string | null, zip?: string | null, pudName?: string | null, locationType?: string | null, email?: string | null, telephone?: string | null, telephone2?: string | null, faxNumber?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null, creditCard?: { __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null };

export type PudPeopleQueryVariables = Exact<{
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  showToken?: InputMaybe<Scalars['Boolean']['input']>;
  tokenGroup: Scalars['String']['input'];
}>;


export type PudPeopleQuery = { __typename?: 'Query', pudPeople: Array<{ __typename?: 'PudPerson', id: string, name?: string | null, address?: string | null }>, config: { __typename?: 'Configuration', pudsAsPeople: boolean }, content?: { __typename?: 'TokenContent', id: string, bePudPersonLabel?: string | null, beSelectNoOptions?: string | null } | null };

export type ReferralLinkFragment = { __typename?: 'ReferralLink', id: string, priority: number, enabled: boolean, alias: string, title?: string | null, description?: string | null, popup?: string | null, imageUrl?: string | null, linkText?: string | null, linkUrl?: string | null, boldText?: string | null, webItems?: Array<string> | null };

export type ReferralLinksQueryVariables = Exact<{
  flightCity?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReferralLinksQuery = { __typename?: 'Query', referralLinks: Array<{ __typename?: 'ReferralLink', id: string, priority: number, enabled: boolean, alias: string, title?: string | null, description?: string | null, popup?: string | null, imageUrl?: string | null, linkText?: string | null, linkUrl?: string | null, boldText?: string | null, webItems?: Array<string> | null }> };

export type RepriceServiceMutationVariables = Exact<{
  recalcEntireFare?: InputMaybe<Scalars['Boolean']['input']>;
  res: ServicesInput;
  sourceType?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RepriceServiceMutation = { __typename?: 'Mutation', repriceService?: { __typename?: 'RepriceServicePayload', success: boolean, message?: string | null, errorType?: string | null, reprice?: { __typename?: 'Reprice', bagCountMax?: number | null, fareDisplay?: number | null, gratuityFare?: number | null, originalFare?: number | null, fareComponents?: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> | null, payments?: { __typename?: 'RepricePayment', totalPaymentAmount?: number | null, amountDue?: number | null, items?: Array<{ __typename?: 'RepricePaymentItem', paymentAmount?: number | null, points?: number | null, programId?: number | null, type?: string | null }> | null } | null, times?: Array<{ __typename?: 'ServiceTime', id?: string | null, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, connLineRun?: number | null, suggested: boolean, travelTime?: number | null, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }> | null, webSubfares?: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> | null } | null } | null };

export type ResFlightFragment = { __typename?: 'ResFlight', airline?: string | null, flightCity?: string | null, flightNumber?: string | null, flightTime?: string | null, flightType?: string | null, terminal?: string | null };

export type ReservationFragmentFragment = { __typename?: 'Reservation', bagCount: number, cancellable: boolean, cancelled: boolean, compId: number, editable: boolean, epicPassId?: string | null, epicPassValidated?: boolean | null, flags: string, id: string, itineraryId?: string | null, jobNumber?: string | null, jobType: number, open: boolean, purchaseMethod?: string | null, resId?: string | null, resIdInternal: number, returnTripStatus: string, serviceArea: number, sourceType: number, totalOriginal?: number | null, userGratuityOverride?: boolean | null, userGratuityPercentage?: number | null, contactInfo: { __typename?: 'ResContact', altPhone?: string | null, faxNumber?: string | null, email?: string | null, name?: string | null, phone?: string | null }, dropoff: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, flight?: { __typename?: 'ResFlight', airline?: string | null, flightCity?: string | null, flightNumber?: string | null, flightTime?: string | null, flightType?: string | null, terminal?: string | null } | null, options?: { __typename?: 'ResOptions', allowOpenResConversion: boolean } | null, other?: { __typename?: 'ResOther', idNumber?: string | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, specialInstructions?: string | null, specialInstructions2?: string | null, madeBy?: { __typename?: 'ResMadeBy', email?: string | null, name?: string | null, phoneNumber?: string | null } | null } | null, passengers: Array<{ __typename?: 'ResFieldValue', field: string, value: number }>, payment?: { __typename?: 'ResPayment', chargeTo?: string | null, shopperReference?: string | null, typeId?: string | null, variance?: number | null, creditCard?: { __typename?: 'ResCreditCard', expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null } | null, pickup: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, profiles?: { __typename?: 'ResProfiles', charter?: number | null, coupon?: number | null, group?: number | null, sales?: number | null, user?: number | null } | null, service?: { __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, checkoutPickuptimeMode?: CheckoutPickupTimeMode | null, defaultBaggage: number, defaultGratuityPercent?: number | null, fareCalculationMode?: string | null, discountDisplayMode?: number | null, fare?: number | null, fareDisplay?: number | null, fareDisplayMode: string, originalFare?: number | null, gratuityFare?: number | null, hideBaggage: boolean, hideFareMode: string, hideFlightInfo: boolean, hideMaximumPassengers: boolean, hideRoundtrip?: boolean | null, hideSubfareMode: string, image?: string | null, includedGratuity: number, items: Array<string>, madeByMode: string, maxPassengers: number, mileage?: number | null, name?: string | null, originalIncludedGratuityPercent?: number | null, passengerTypesAlias?: string | null, processorId?: number | null, raw: string, roundtripPricingMode: string, serviceExtrasAlias?: string | null, serviceTimeNotes: string, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, showTravelTime?: boolean | null, totalGratuity: number, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }>, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'SelectedTime', id?: string | null, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id?: string | null, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, connLineRun?: number | null, suggested: boolean, travelTime?: number | null, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> } | null, serviceExtras: Array<{ __typename?: 'ResFieldValue', field: string, value: number }>, stops?: Array<{ __typename?: 'ResStop', name?: string | null, comments?: string | null, directions?: string | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null }> | null, userDefined?: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> | null };

export type ReservationQueryVariables = Exact<{
  reservationId?: InputMaybe<Scalars['Int']['input']>;
  pid?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReservationQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', bagCount: number, cancellable: boolean, cancelled: boolean, compId: number, editable: boolean, epicPassId?: string | null, epicPassValidated?: boolean | null, flags: string, id: string, itineraryId?: string | null, jobNumber?: string | null, jobType: number, open: boolean, purchaseMethod?: string | null, resId?: string | null, resIdInternal: number, returnTripStatus: string, serviceArea: number, sourceType: number, totalOriginal?: number | null, userGratuityOverride?: boolean | null, userGratuityPercentage?: number | null, auth?: { __typename?: 'Auth', token?: string | null } | null, contactInfo: { __typename?: 'ResContact', altPhone?: string | null, faxNumber?: string | null, email?: string | null, name?: string | null, phone?: string | null }, dropoff: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, flight?: { __typename?: 'ResFlight', airline?: string | null, flightCity?: string | null, flightNumber?: string | null, flightTime?: string | null, flightType?: string | null, terminal?: string | null } | null, options?: { __typename?: 'ResOptions', allowOpenResConversion: boolean } | null, other?: { __typename?: 'ResOther', idNumber?: string | null, marketingCode?: string | null, marketingCode2?: string | null, marketingCode3?: string | null, specialInstructions?: string | null, specialInstructions2?: string | null, madeBy?: { __typename?: 'ResMadeBy', email?: string | null, name?: string | null, phoneNumber?: string | null } | null } | null, passengers: Array<{ __typename?: 'ResFieldValue', field: string, value: number }>, payment?: { __typename?: 'ResPayment', chargeTo?: string | null, shopperReference?: string | null, typeId?: string | null, variance?: number | null, creditCard?: { __typename?: 'ResCreditCard', expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null } | null, pickup: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null }, profiles?: { __typename?: 'ResProfiles', charter?: number | null, coupon?: number | null, group?: number | null, sales?: number | null, user?: number | null } | null, service?: { __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, checkoutPickuptimeMode?: CheckoutPickupTimeMode | null, defaultBaggage: number, defaultGratuityPercent?: number | null, fareCalculationMode?: string | null, discountDisplayMode?: number | null, fare?: number | null, fareDisplay?: number | null, fareDisplayMode: string, originalFare?: number | null, gratuityFare?: number | null, hideBaggage: boolean, hideFareMode: string, hideFlightInfo: boolean, hideMaximumPassengers: boolean, hideRoundtrip?: boolean | null, hideSubfareMode: string, image?: string | null, includedGratuity: number, items: Array<string>, madeByMode: string, maxPassengers: number, mileage?: number | null, name?: string | null, originalIncludedGratuityPercent?: number | null, passengerTypesAlias?: string | null, processorId?: number | null, raw: string, roundtripPricingMode: string, serviceExtrasAlias?: string | null, serviceTimeNotes: string, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, showTravelTime?: boolean | null, totalGratuity: number, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }>, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'SelectedTime', id?: string | null, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id?: string | null, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, connLineRun?: number | null, suggested: boolean, travelTime?: number | null, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> } | null, serviceExtras: Array<{ __typename?: 'ResFieldValue', field: string, value: number }>, stops?: Array<{ __typename?: 'ResStop', name?: string | null, comments?: string | null, directions?: string | null, location?: { __typename?: 'Location', id: string, address?: string | null, addressDetails?: string | null, city?: string | null, code: string, country?: string | null, county?: string | null, crossStreet?: string | null, description?: string | null, directions?: string | null, displayAddress?: string | null, displayName: string, distance?: number | null, fklRequest?: string | null, fklResponse?: string | null, googlePlaceId?: string | null, icons?: Array<string> | null, metadata: string, name: string, raw?: string | null, requireCrossStreet?: boolean | null, sector?: string | null, serviceAreas: Array<number>, showAddressDetails?: boolean | null, showCrossStreet?: boolean | null, showFlightDate: boolean, showFlightNumber: boolean, showFlightType: boolean, state?: string | null, string?: string | null, telephone?: string | null, transportationHub: boolean, type: string, typeString: string, zip?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null } | null }> | null, userDefined?: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> | null } | null };

export type SavePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type SavePasswordMutation = { __typename?: 'Mutation', savePassword?: { __typename?: 'SavePasswordPayload', success: boolean, errorMessage?: string | null, message?: string | null, errorType?: string | null } | null };

export type SavePasswordWithPidMutationVariables = Exact<{
  password: Scalars['String']['input'];
  pid: Scalars['String']['input'];
}>;


export type SavePasswordWithPidMutation = { __typename?: 'Mutation', savePasswordWithPid?: { __typename?: 'SavePasswordWithPidPayload', errorMessage?: string | null, success: boolean } | null };

export type SendPasswordResetMutationVariables = Exact<{
  username: Scalars['String']['input'];
  resetPasswordUrl: Scalars['String']['input'];
}>;


export type SendPasswordResetMutation = { __typename?: 'Mutation', sendPasswordReset: { __typename?: 'SendPasswordResetPayload', errorType?: string | null, success: boolean, message?: string | null } };

export type ServiceFragmentFragment = { __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, checkoutPickuptimeMode?: CheckoutPickupTimeMode | null, defaultBaggage: number, defaultGratuityPercent?: number | null, fareCalculationMode?: string | null, discountDisplayMode?: number | null, fare?: number | null, fareDisplay?: number | null, fareDisplayMode: string, originalFare?: number | null, gratuityFare?: number | null, hideBaggage: boolean, hideFareMode: string, hideFlightInfo: boolean, hideMaximumPassengers: boolean, hideRoundtrip?: boolean | null, hideSubfareMode: string, image?: string | null, includedGratuity: number, items: Array<string>, madeByMode: string, maxPassengers: number, mileage?: number | null, name?: string | null, originalIncludedGratuityPercent?: number | null, passengerTypesAlias?: string | null, processorId?: number | null, raw: string, roundtripPricingMode: string, serviceExtrasAlias?: string | null, serviceTimeNotes: string, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, showTravelTime?: boolean | null, totalGratuity: number, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }>, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'SelectedTime', id?: string | null, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id?: string | null, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, connLineRun?: number | null, suggested: boolean, travelTime?: number | null, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> };

export type ServiceExtraFragment = { __typename?: 'ServiceExtra', id: string, defaultToBlank?: boolean | null, defaultValue?: number | null, description?: string | null, enabled?: boolean | null, fieldName: string, fixedAmount: boolean, image?: string | null, label?: string | null, maximum?: number | null, popup?: string | null, raw?: string | null, returnDefaultToBlank?: boolean | null, returnDefaultToFirstLeg?: boolean | null, returnDefaultValue?: number | null, surcharge?: number | null };

export type ExtrasQueryVariables = Exact<{
  serviceAreaId?: InputMaybe<Scalars['Int']['input']>;
  serviceExtrasAlias?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExtrasQuery = { __typename?: 'Query', serviceExtras: Array<{ __typename?: 'ServiceExtra', id: string, defaultToBlank?: boolean | null, defaultValue?: number | null, description?: string | null, enabled?: boolean | null, fieldName: string, fixedAmount: boolean, image?: string | null, label?: string | null, maximum?: number | null, popup?: string | null, raw?: string | null, returnDefaultToBlank?: boolean | null, returnDefaultToFirstLeg?: boolean | null, returnDefaultValue?: number | null, surcharge?: number | null }> };

export type ServiceTimeFragment = { __typename?: 'ServiceTime', id?: string | null, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, connLineRun?: number | null, suggested: boolean, travelTime?: number | null, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> };

export type ServicesQueryVariables = Exact<{
  res: ServicesInput;
  sourceType: Scalars['Int']['input'];
}>;


export type ServicesQuery = { __typename?: 'Query', services: Array<{ __typename?: 'Service', perPassengerRates?: string | null, bagCountMax?: number | null, checkoutPickuptimeMode?: CheckoutPickupTimeMode | null, defaultBaggage: number, defaultGratuityPercent?: number | null, fareCalculationMode?: string | null, discountDisplayMode?: number | null, fare?: number | null, fareDisplay?: number | null, fareDisplayMode: string, originalFare?: number | null, gratuityFare?: number | null, hideBaggage: boolean, hideFareMode: string, hideFlightInfo: boolean, hideMaximumPassengers: boolean, hideRoundtrip?: boolean | null, hideSubfareMode: string, image?: string | null, includedGratuity: number, items: Array<string>, madeByMode: string, maxPassengers: number, mileage?: number | null, name?: string | null, originalIncludedGratuityPercent?: number | null, passengerTypesAlias?: string | null, processorId?: number | null, raw: string, roundtripPricingMode: string, serviceExtrasAlias?: string | null, serviceTimeNotes: string, serviceType: number, showExtraStops?: boolean | null, showGratuity?: boolean | null, showTravelTime?: boolean | null, totalGratuity: number, travelTime?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }>, pickupExtras: Array<{ __typename?: 'PickupExtra', charge?: number | null, default?: boolean | null, name?: string | null, value?: string | null }>, selectedPickupExtra?: { __typename?: 'PickupExtra', default?: boolean | null, charge?: number | null, name?: string | null, value?: string | null } | null, selectedTime?: { __typename?: 'SelectedTime', id?: string | null, dropoffTime?: string | null, pickupTime?: string | null } | null, times: Array<{ __typename?: 'ServiceTime', id?: string | null, availableSeats?: number | null, dropoffTime?: string | null, hasAdditionalCharges: boolean, offpeak: boolean, offPeakCharge?: number | null, pickupTime?: string | null, raw?: string | null, shortNoticeCharge?: number | null, showAvailablePassengers: boolean, skedRun?: number | null, connLineRun?: number | null, suggested: boolean, travelTime?: number | null, unavailable: boolean, yieldAdjustment?: number | null, fareComponents: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }>, webSubfares: Array<{ __typename?: 'FieldValue', field: string, value?: string | null }> }> };

export type SetPasswordForProfileMutationVariables = Exact<{
  email: Scalars['String']['input'];
  profileId: Scalars['Int']['input'];
  password: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SetPasswordForProfileMutation = { __typename?: 'Mutation', setPasswordForProfile?: { __typename?: 'SetPasswordForProfilePayload', success: boolean, message?: string | null, errorMessage?: string | null, errorType?: string | null, profileId?: string | null } | null };

export type SpecialInfoQueryVariables = Exact<{
  siAlias?: InputMaybe<Scalars['String']['input']>;
}>;


export type SpecialInfoQuery = { __typename?: 'Query', specialInfo: Array<{ __typename?: 'SpecialInfoField', id: number, defaultValue: string, description: string, fieldName: string, fieldType: SpecialInfoFieldType, label: string, maxLength: number, minLength: number, raw: string, required: boolean }> };

export type TokenFragment = { __typename?: 'Token', id: string, name: string, description: string, defaultToken: boolean, value: string };

export type TokenizeMutationVariables = Exact<{
  ccNumber: Scalars['String']['input'];
  ccExpiration: Scalars['String']['input'];
  ccName?: InputMaybe<Scalars['String']['input']>;
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  ccAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type TokenizeMutation = { __typename?: 'Mutation', tokenize: { __typename?: 'TokenizePayload', error?: string | null, ccToken?: string | null, ccLast4?: string | null, ccExpiration?: string | null } };

export type TokensQueryVariables = Exact<{ [key: string]: never; }>;


export type TokensQuery = { __typename?: 'Query', tokens: Array<{ __typename?: 'Token', id: string, name: string, description: string, defaultToken: boolean, value: string }> };

export type ProfileFragmentFragment = { __typename?: 'Profile', linkedGroupName?: string | null, contactInfo?: { __typename?: 'ProfileContact', altPhone?: string | null, email?: string | null, faxNumber?: string | null, name?: string | null, phone?: string | null } | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null } | null> | null, locations?: Array<{ __typename?: 'ProfileLocation', id: string, address?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, directions?: string | null, displayName?: string | null, name?: string | null, sector?: string | null, state?: string | null, zip?: string | null, pudName?: string | null, locationType?: string | null, email?: string | null, telephone?: string | null, telephone2?: string | null, faxNumber?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null, creditCard?: { __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null } | null> | null };

export type UserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileQuery = { __typename?: 'Query', userProfile?: { __typename?: 'Profile', linkedGroupName?: string | null, contactInfo?: { __typename?: 'ProfileContact', altPhone?: string | null, email?: string | null, faxNumber?: string | null, name?: string | null, phone?: string | null } | null, creditCards?: Array<{ __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, localId?: string | null, name?: string | null, numberLast4?: string | null, refId?: string | null, token?: string | null, tokenType?: string | null, typeCode?: string | null, uniqueId?: string | null } | null> | null, locations?: Array<{ __typename?: 'ProfileLocation', id: string, address?: string | null, city?: string | null, code?: string | null, country?: string | null, county?: string | null, crossStreet?: string | null, directions?: string | null, displayName?: string | null, name?: string | null, sector?: string | null, state?: string | null, zip?: string | null, pudName?: string | null, locationType?: string | null, email?: string | null, telephone?: string | null, telephone2?: string | null, faxNumber?: string | null, latLng?: { __typename?: 'LatLng', lat: number, lng: number } | null, creditCard?: { __typename?: 'TokenizedCreditCard', id?: string | null, expiration?: string | null, name?: string | null, numberLast4?: string | null, postalCode?: string | null, token?: string | null, typeCode?: string | null } | null } | null> | null } | null };

export type UserProfileAddCcMutationVariables = Exact<{
  ccNumber: Scalars['String']['input'];
  ccExpiration: Scalars['String']['input'];
  ccName: Scalars['String']['input'];
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
  ccAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileAddCcMutation = { __typename?: 'Mutation', userProfileAddCc: { __typename?: 'UserProfileAddCcPayload', success: boolean, errorMessage?: string | null } };

export type UserProfileAddPudMutationVariables = Exact<{
  location: ProfilePudInput;
}>;


export type UserProfileAddPudMutation = { __typename?: 'Mutation', userProfileAddPud?: { __typename?: 'UserProfileAddPudResponse', success: boolean, errorType?: string | null, message?: string | null } | null };

export type UserProfileAddValpayCcMutationVariables = Exact<{
  encryptedCardNumber: Scalars['String']['input'];
  encryptedExpiryMonth: Scalars['String']['input'];
  encryptedExpiryYear: Scalars['String']['input'];
  encryptedSecurityCode: Scalars['String']['input'];
  ccCardHolderName?: InputMaybe<Scalars['String']['input']>;
  ccPostalCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileAddValpayCcMutation = { __typename?: 'Mutation', userProfileAddValpayCc: { __typename?: 'UserProfileAddValpayCcPayload', success: boolean, errorMessage?: string | null, errorType?: string | null, message?: string | null } };

export type UserProfileDeleteCcMutationVariables = Exact<{
  ccId?: InputMaybe<Scalars['Int']['input']>;
  ccRefId?: InputMaybe<Scalars['String']['input']>;
  ccToken?: InputMaybe<Scalars['String']['input']>;
  ccLast4?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileDeleteCcMutation = { __typename?: 'Mutation', userProfileDeleteCc: { __typename?: 'UserProfileDeleteCcPayload', success: boolean, message?: string | null, errorMessage?: string | null, errorType?: string | null } };

export type UserProfileDeletePudMutationVariables = Exact<{
  locationId: Scalars['Int']['input'];
}>;


export type UserProfileDeletePudMutation = { __typename?: 'Mutation', userProfileDeletePud: { __typename?: 'UserProfileDeletePudPayload', success: boolean, errorMessage?: string | null } };

export type UserProfileDeletePudCcMutationVariables = Exact<{
  pudId: Scalars['Int']['input'];
  ccId: Scalars['Int']['input'];
}>;


export type UserProfileDeletePudCcMutation = { __typename?: 'Mutation', userProfileDeletePudCc: { __typename?: 'UserProfileDeletePudCcPayload', success: boolean, errorMessage?: string | null } };

export type UserProfileExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserProfileExistsQuery = { __typename?: 'Query', userProfileExists: { __typename?: 'UserProfileExists', id: string, exists: boolean, hasPassword?: boolean | null, profileId?: number | null } };

export type UserProfileLinkGroupMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  webId?: InputMaybe<Scalars['String']['input']>;
  data1?: InputMaybe<Scalars['String']['input']>;
  data2?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserProfileLinkGroupMutation = { __typename?: 'Mutation', userProfileLinkGroup: { __typename?: 'UserProfileLinkGroupPayload', success: boolean, message?: string | null, errorMessage?: string | null, errorType?: string | null } };

export type UserProfileUpdateMutationVariables = Exact<{
  contact?: InputMaybe<ContactUpdateInput>;
  linkedReservations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UserProfileUpdateMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'UpdateUserProfilePayload', success: boolean, message?: string | null, errorMessage?: string | null } | null };

export type UserProfileUpdatePudMutationVariables = Exact<{
  pudId: Scalars['Int']['input'];
  location: ProfilePudInput;
}>;


export type UserProfileUpdatePudMutation = { __typename?: 'Mutation', userProfileUpdatePud?: { __typename?: 'UserProfileUpdatePudResponse', success: boolean, errorType?: string | null, message?: string | null } | null };

export type ValpayConfigQueryVariables = Exact<{
  processorId?: InputMaybe<Scalars['Int']['input']>;
  shopperReference?: InputMaybe<Scalars['String']['input']>;
}>;


export type ValpayConfigQuery = { __typename?: 'Query', valpayConfig: { __typename?: 'ValpayConfig', id?: string | null, clientKey?: string | null, enabled: boolean, environment?: string | null, error?: string | null, paymentMethods?: string | null } };

export type VerifyResMutationVariables = Exact<{
  resId: Scalars['String']['input'];
  validationMode: Scalars['String']['input'];
  validationValue: Scalars['String']['input'];
}>;


export type VerifyResMutation = { __typename?: 'Mutation', verifyRes?: { __typename?: 'VerifyResPayload', errorType?: string | null, success: boolean, message?: string | null, resId?: number | null, auth?: { __typename?: 'Auth', token?: string | null } | null } | null };

export const AirlineFragmentDoc = gql`
    fragment Airline on Airline {
  id
  name
  code
  terminal {
    domesticArrival
    domesticDeparture
    internationalArrival
    internationalDeparture
  }
}
    `;
export const AutocompleteLocationFragmentDoc = gql`
    fragment AutocompleteLocation on Location {
  id
  displayAddress
  displayName
  code
  type
  typeString
}
    `;
export const AutocompleteLocationUniversalFragmentDoc = gql`
    fragment AutocompleteLocationUniversal on Location {
  id
  displayAddress
  displayName
  code
  city
  fullState
  latLng {
    lat
    lng
  }
  metadata
  serviceAreas
  state
  string
  type
  typeString
}
    `;
export const ColorsFragmentDoc = gql`
    fragment Colors on Colors {
  id
  primaryColor
  primaryHover
  primaryText
}
    `;
export const DefaultsFragmentFragmentDoc = gql`
    fragment DefaultsFragment on Defaults {
  id
  creditCards {
    id
    expiration
    localId
    name
    numberLast4
    postalCode
    refId
    token
    tokenType
    typeCode
    uniqueId
  }
  email
  faxNumber
  gratuityPercents
  marketingCode
  marketingCode2
  marketingCode3
  name
  telephone
  telephone2
  name
}
    `;
export const LocationFragmentDoc = gql`
    fragment Location on Location {
  id
  address
  addressDetails
  city
  code
  country
  county
  crossStreet
  description
  directions
  displayAddress
  displayName
  distance
  fklRequest
  fklResponse
  googlePlaceId
  icons
  latLng {
    lat
    lng
  }
  metadata
  name
  raw
  requireCrossStreet
  sector
  serviceAreas
  showAddressDetails
  showCrossStreet
  showFlightDate
  showFlightNumber
  showFlightType
  state
  string
  telephone
  transportationHub
  type
  typeString
  zip
}
    `;
export const FareKeyLookupFragmentDoc = gql`
    fragment FareKeyLookup on FareKeyLookupReturn {
  error
  errorMessage
  fklRequest
  fklResponse
  location {
    ...Location
  }
  lookupType
  nearbyLocations {
    ...Location
  }
}
    ${LocationFragmentDoc}`;
export const FixedLocationTypeFragmentDoc = gql`
    fragment FixedLocationType on FixedLocationType {
  id
  label
  locationCount
  locations {
    ...Location
  }
  type
  typeString
}
    ${LocationFragmentDoc}`;
export const FrequentRiderPointsFragmentDoc = gql`
    fragment FrequentRiderPoints on FrequentRiderPoints {
  availablePoints
  id
  programId
  totalCredits
  totalDebits
  transactions {
    comments
    debitCredit
    description
    endDate
    expirationTod
    id
    name
    points
    programId
    redemptionType
    resId
    status
    transactionDate
  }
}
    `;
export const FrequentRiderProgramFragmentFragmentDoc = gql`
    fragment FrequentRiderProgramFragment on FrequentRiderProgram {
  id
  cost
  name
  redemptionType
  description
  redemptionDuration
  redemptionDefaultDate
  redemptionMaxUsage
  raw
  sellFarePer
  sellMinQuantity
  sellMaxQuantity
  sellType
  redemptionThreshold
  paymentPointsPerFareUnit
}
    `;
export const PassengerFragmentDoc = gql`
    fragment Passenger on PassengerType {
  id
  fieldName
  label
  maxPassengers
  popup
  raw
}
    `;
export const ReferralLinkFragmentDoc = gql`
    fragment ReferralLink on ReferralLink {
  id
  priority
  enabled
  alias
  title
  description
  popup
  imageUrl
  linkText
  linkUrl
  boldText
  webItems
}
    `;
export const ResFlightFragmentDoc = gql`
    fragment ResFlight on ResFlight {
  airline
  flightCity
  flightNumber
  flightTime
  flightType
  terminal
}
    `;
export const ServiceTimeFragmentDoc = gql`
    fragment ServiceTime on ServiceTime {
  id
  availableSeats
  dropoffTime
  fareComponents {
    field
    value
  }
  hasAdditionalCharges
  offpeak
  offPeakCharge
  pickupTime
  raw
  shortNoticeCharge
  showAvailablePassengers
  skedRun
  connLineRun
  suggested
  travelTime
  unavailable
  yieldAdjustment
}
    `;
export const ServiceFragmentFragmentDoc = gql`
    fragment ServiceFragment on Service {
  perPassengerRates
  bagCountMax
  checkoutPickuptimeMode
  defaultBaggage
  defaultGratuityPercent
  fareCalculationMode
  fareComponents {
    field
    value
  }
  discountDisplayMode
  fare
  fareDisplay
  fareDisplayMode
  originalFare
  gratuityFare
  hideBaggage
  hideFareMode
  hideFlightInfo
  hideMaximumPassengers
  hideRoundtrip
  hideSubfareMode
  image
  includedGratuity
  items
  madeByMode
  maxPassengers
  mileage
  name
  originalIncludedGratuityPercent
  passengerTypesAlias
  pickupExtras {
    charge
    default
    name
    value
  }
  processorId
  raw
  roundtripPricingMode
  selectedPickupExtra {
    default
    charge
    name
    value
  }
  selectedTime {
    id
    dropoffTime
    pickupTime
  }
  serviceExtrasAlias
  serviceTimeNotes
  serviceType
  showExtraStops
  showGratuity
  showTravelTime
  times {
    ...ServiceTime
  }
  totalGratuity
  travelTime
  webSubfares {
    field
    value
  }
}
    ${ServiceTimeFragmentDoc}`;
export const ReservationFragmentFragmentDoc = gql`
    fragment ReservationFragment on Reservation {
  bagCount
  cancellable
  cancelled
  compId
  contactInfo {
    altPhone
    faxNumber
    email
    name
    phone
  }
  dropoff {
    ...Location
  }
  editable
  epicPassId
  epicPassValidated
  flags
  flight {
    ...ResFlight
  }
  id
  itineraryId
  jobNumber
  jobType
  open
  options {
    allowOpenResConversion
  }
  other {
    idNumber
    madeBy {
      email
      name
      phoneNumber
    }
    marketingCode
    marketingCode2
    marketingCode3
    specialInstructions
    specialInstructions2
  }
  passengers {
    field
    value
  }
  payment {
    chargeTo
    creditCard {
      expiration
      name
      numberLast4
      postalCode
      token
      typeCode
    }
    shopperReference
    typeId
    variance
  }
  purchaseMethod
  pickup {
    ...Location
  }
  profiles {
    charter
    coupon
    group
    sales
    user
  }
  resId
  resIdInternal
  returnTripStatus
  service {
    ...ServiceFragment
  }
  serviceArea
  serviceExtras {
    field
    value
  }
  stops {
    location {
      ...Location
    }
    name
    comments
    directions
  }
  sourceType
  totalOriginal
  userDefined {
    field
    value
  }
  userGratuityOverride
  userGratuityPercentage
}
    ${LocationFragmentDoc}
${ResFlightFragmentDoc}
${ServiceFragmentFragmentDoc}`;
export const ServiceExtraFragmentDoc = gql`
    fragment ServiceExtra on ServiceExtra {
  id
  defaultToBlank
  defaultValue
  description
  enabled
  fieldName
  fixedAmount
  image
  label
  maximum
  popup
  raw
  returnDefaultToBlank
  returnDefaultToFirstLeg
  returnDefaultValue
  surcharge
}
    `;
export const TokenFragmentDoc = gql`
    fragment Token on Token {
  id
  name
  description
  defaultToken
  value
}
    `;
export const PudFragmentFragmentDoc = gql`
    fragment PudFragment on ProfileLocation {
  id
  address
  city
  code
  country
  county
  crossStreet
  directions
  displayName
  latLng {
    lat
    lng
  }
  name
  sector
  state
  zip
  pudName
  locationType
  email
  telephone
  telephone2
  faxNumber
  creditCard {
    id
    expiration
    name
    numberLast4
    postalCode
    token
    typeCode
  }
}
    `;
export const ProfileFragmentFragmentDoc = gql`
    fragment ProfileFragment on Profile {
  contactInfo {
    altPhone
    email
    faxNumber
    name
    phone
  }
  creditCards {
    id
    expiration
    localId
    name
    numberLast4
    refId
    token
    tokenType
    typeCode
    uniqueId
  }
  linkedGroupName
  locations {
    ...PudFragment
  }
}
    ${PudFragmentFragmentDoc}`;
export const AirlinesDocument = gql`
    query airlines($airportCode: String!, $serviceAreaId: Int, $showToken: Boolean, $tokenGroup: String!) {
  airlines(airportCode: $airportCode, serviceAreaId: $serviceAreaId) {
    ...Airline
  }
  content(
    serviceAreaId: $serviceAreaId
    showToken: $showToken
    tokenGroup: $tokenGroup
  ) {
    id
    beErrFieldRequired
    beErrAirline
    beAirlineLabel
    beSelectNoOptions
  }
}
    ${AirlineFragmentDoc}`;

/**
 * __useAirlinesQuery__
 *
 * To run a query within a React component, call `useAirlinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirlinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirlinesQuery({
 *   variables: {
 *      airportCode: // value for 'airportCode'
 *      serviceAreaId: // value for 'serviceAreaId'
 *      showToken: // value for 'showToken'
 *      tokenGroup: // value for 'tokenGroup'
 *   },
 * });
 */
export function useAirlinesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AirlinesQuery, AirlinesQueryVariables> & ({ variables: AirlinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
      }
export function useAirlinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AirlinesQuery, AirlinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
        }
export function useAirlinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AirlinesQuery, AirlinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
        }
export type AirlinesQueryHookResult = ReturnType<typeof useAirlinesQuery>;
export type AirlinesLazyQueryHookResult = ReturnType<typeof useAirlinesLazyQuery>;
export type AirlinesSuspenseQueryHookResult = ReturnType<typeof useAirlinesSuspenseQuery>;
export type AirlinesQueryResult = Apollo.QueryResult<AirlinesQuery, AirlinesQueryVariables>;
export const AttachCouponDocument = gql`
    mutation AttachCoupon($couponCode: String!, $legs: [ServicesInput!]) {
  attachCoupon(couponCode: $couponCode, legs: $legs) {
    errorType
    success
    message
    auth {
      token
    }
  }
}
    `;
export type AttachCouponMutationFn = Apollo.MutationFunction<AttachCouponMutation, AttachCouponMutationVariables>;

/**
 * __useAttachCouponMutation__
 *
 * To run a mutation, you first call `useAttachCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachCouponMutation, { data, loading, error }] = useAttachCouponMutation({
 *   variables: {
 *      couponCode: // value for 'couponCode'
 *      legs: // value for 'legs'
 *   },
 * });
 */
export function useAttachCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AttachCouponMutation, AttachCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttachCouponMutation, AttachCouponMutationVariables>(AttachCouponDocument, options);
      }
export type AttachCouponMutationHookResult = ReturnType<typeof useAttachCouponMutation>;
export type AttachCouponMutationResult = Apollo.MutationResult<AttachCouponMutation>;
export type AttachCouponMutationOptions = Apollo.BaseMutationOptions<AttachCouponMutation, AttachCouponMutationVariables>;
export const AttachGroupProfileDocument = gql`
    mutation AttachGroupProfile($id: String!, $password: String) {
  attachGroupProfile(id: $id, password: $password) {
    errorType
    success
    message
    auth {
      token
    }
  }
}
    `;
export type AttachGroupProfileMutationFn = Apollo.MutationFunction<AttachGroupProfileMutation, AttachGroupProfileMutationVariables>;

/**
 * __useAttachGroupProfileMutation__
 *
 * To run a mutation, you first call `useAttachGroupProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachGroupProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachGroupProfileMutation, { data, loading, error }] = useAttachGroupProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAttachGroupProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AttachGroupProfileMutation, AttachGroupProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AttachGroupProfileMutation, AttachGroupProfileMutationVariables>(AttachGroupProfileDocument, options);
      }
export type AttachGroupProfileMutationHookResult = ReturnType<typeof useAttachGroupProfileMutation>;
export type AttachGroupProfileMutationResult = Apollo.MutationResult<AttachGroupProfileMutation>;
export type AttachGroupProfileMutationOptions = Apollo.BaseMutationOptions<AttachGroupProfileMutation, AttachGroupProfileMutationVariables>;
export const BookDocument = gql`
    mutation Book($booking: BookBookingType!, $sourceType: Int) {
  book(booking: $booking, sourceType: $sourceType) {
    error
    itineraryId
    resErrors
    resIds
  }
}
    `;
export type BookMutationFn = Apollo.MutationFunction<BookMutation, BookMutationVariables>;

/**
 * __useBookMutation__
 *
 * To run a mutation, you first call `useBookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookMutation, { data, loading, error }] = useBookMutation({
 *   variables: {
 *      booking: // value for 'booking'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useBookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BookMutation, BookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BookMutation, BookMutationVariables>(BookDocument, options);
      }
export type BookMutationHookResult = ReturnType<typeof useBookMutation>;
export type BookMutationResult = Apollo.MutationResult<BookMutation>;
export type BookMutationOptions = Apollo.BaseMutationOptions<BookMutation, BookMutationVariables>;
export const CancelResDocument = gql`
    mutation CancelRes($resId: Int!) {
  cancelRes(resId: $resId) {
    errorType
    success
    message
  }
}
    `;
export type CancelResMutationFn = Apollo.MutationFunction<CancelResMutation, CancelResMutationVariables>;

/**
 * __useCancelResMutation__
 *
 * To run a mutation, you first call `useCancelResMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelResMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelResMutation, { data, loading, error }] = useCancelResMutation({
 *   variables: {
 *      resId: // value for 'resId'
 *   },
 * });
 */
export function useCancelResMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelResMutation, CancelResMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelResMutation, CancelResMutationVariables>(CancelResDocument, options);
      }
export type CancelResMutationHookResult = ReturnType<typeof useCancelResMutation>;
export type CancelResMutationResult = Apollo.MutationResult<CancelResMutation>;
export type CancelResMutationOptions = Apollo.BaseMutationOptions<CancelResMutation, CancelResMutationVariables>;
export const ColorsDocument = gql`
    query colors {
  colors {
    ...Colors
  }
}
    ${ColorsFragmentDoc}`;

/**
 * __useColorsQuery__
 *
 * To run a query within a React component, call `useColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useColorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
      }
export function useColorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export function useColorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export type ColorsQueryHookResult = ReturnType<typeof useColorsQuery>;
export type ColorsLazyQueryHookResult = ReturnType<typeof useColorsLazyQuery>;
export type ColorsSuspenseQueryHookResult = ReturnType<typeof useColorsSuspenseQuery>;
export type ColorsQueryResult = Apollo.QueryResult<ColorsQuery, ColorsQueryVariables>;
export const ConfigDocument = gql`
    query Config {
  config {
    currency
    defaultServiceArea
    googleAnalyticsId
    googleApiKey
    gtmId
    requireLoginForBooking
  }
}
    `;

/**
 * __useConfigQuery__
 *
 * To run a query within a React component, call `useConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
      }
export function useConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
        }
export function useConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ConfigQuery, ConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ConfigQuery, ConfigQueryVariables>(ConfigDocument, options);
        }
export type ConfigQueryHookResult = ReturnType<typeof useConfigQuery>;
export type ConfigLazyQueryHookResult = ReturnType<typeof useConfigLazyQuery>;
export type ConfigSuspenseQueryHookResult = ReturnType<typeof useConfigSuspenseQuery>;
export type ConfigQueryResult = Apollo.QueryResult<ConfigQuery, ConfigQueryVariables>;
export const ConvertResDocument = gql`
    mutation ConvertRes($resId: Int!) {
  convertRes(resId: $resId) {
    errorType
    success
    message
  }
}
    `;
export type ConvertResMutationFn = Apollo.MutationFunction<ConvertResMutation, ConvertResMutationVariables>;

/**
 * __useConvertResMutation__
 *
 * To run a mutation, you first call `useConvertResMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertResMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertResMutation, { data, loading, error }] = useConvertResMutation({
 *   variables: {
 *      resId: // value for 'resId'
 *   },
 * });
 */
export function useConvertResMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertResMutation, ConvertResMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConvertResMutation, ConvertResMutationVariables>(ConvertResDocument, options);
      }
export type ConvertResMutationHookResult = ReturnType<typeof useConvertResMutation>;
export type ConvertResMutationResult = Apollo.MutationResult<ConvertResMutation>;
export type ConvertResMutationOptions = Apollo.BaseMutationOptions<ConvertResMutation, ConvertResMutationVariables>;
export const DefaultsDocument = gql`
    query defaults($pudId: Int) {
  defaults(pudId: $pudId) {
    ...DefaultsFragment
  }
}
    ${DefaultsFragmentFragmentDoc}`;

/**
 * __useDefaultsQuery__
 *
 * To run a query within a React component, call `useDefaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultsQuery({
 *   variables: {
 *      pudId: // value for 'pudId'
 *   },
 * });
 */
export function useDefaultsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DefaultsQuery, DefaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefaultsQuery, DefaultsQueryVariables>(DefaultsDocument, options);
      }
export function useDefaultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefaultsQuery, DefaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefaultsQuery, DefaultsQueryVariables>(DefaultsDocument, options);
        }
export function useDefaultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefaultsQuery, DefaultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefaultsQuery, DefaultsQueryVariables>(DefaultsDocument, options);
        }
export type DefaultsQueryHookResult = ReturnType<typeof useDefaultsQuery>;
export type DefaultsLazyQueryHookResult = ReturnType<typeof useDefaultsLazyQuery>;
export type DefaultsSuspenseQueryHookResult = ReturnType<typeof useDefaultsSuspenseQuery>;
export type DefaultsQueryResult = Apollo.QueryResult<DefaultsQuery, DefaultsQueryVariables>;
export const DetachAllProfilesDocument = gql`
    mutation DetachAllProfiles {
  detachAllProfiles {
    success
    message
    errorType
    auth {
      token
    }
  }
}
    `;
export type DetachAllProfilesMutationFn = Apollo.MutationFunction<DetachAllProfilesMutation, DetachAllProfilesMutationVariables>;

/**
 * __useDetachAllProfilesMutation__
 *
 * To run a mutation, you first call `useDetachAllProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachAllProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachAllProfilesMutation, { data, loading, error }] = useDetachAllProfilesMutation({
 *   variables: {
 *   },
 * });
 */
export function useDetachAllProfilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DetachAllProfilesMutation, DetachAllProfilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachAllProfilesMutation, DetachAllProfilesMutationVariables>(DetachAllProfilesDocument, options);
      }
export type DetachAllProfilesMutationHookResult = ReturnType<typeof useDetachAllProfilesMutation>;
export type DetachAllProfilesMutationResult = Apollo.MutationResult<DetachAllProfilesMutation>;
export type DetachAllProfilesMutationOptions = Apollo.BaseMutationOptions<DetachAllProfilesMutation, DetachAllProfilesMutationVariables>;
export const DetachCharterProfileDocument = gql`
    mutation DetachCharterProfile {
  detachCharterProfile {
    success
    message
    errorType
    auth {
      token
    }
  }
}
    `;
export type DetachCharterProfileMutationFn = Apollo.MutationFunction<DetachCharterProfileMutation, DetachCharterProfileMutationVariables>;

/**
 * __useDetachCharterProfileMutation__
 *
 * To run a mutation, you first call `useDetachCharterProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachCharterProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachCharterProfileMutation, { data, loading, error }] = useDetachCharterProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useDetachCharterProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DetachCharterProfileMutation, DetachCharterProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachCharterProfileMutation, DetachCharterProfileMutationVariables>(DetachCharterProfileDocument, options);
      }
export type DetachCharterProfileMutationHookResult = ReturnType<typeof useDetachCharterProfileMutation>;
export type DetachCharterProfileMutationResult = Apollo.MutationResult<DetachCharterProfileMutation>;
export type DetachCharterProfileMutationOptions = Apollo.BaseMutationOptions<DetachCharterProfileMutation, DetachCharterProfileMutationVariables>;
export const DetachCouponDocument = gql`
    mutation DetachCoupon {
  detachCoupon {
    success
    message
    errorType
    auth {
      token
    }
  }
}
    `;
export type DetachCouponMutationFn = Apollo.MutationFunction<DetachCouponMutation, DetachCouponMutationVariables>;

/**
 * __useDetachCouponMutation__
 *
 * To run a mutation, you first call `useDetachCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachCouponMutation, { data, loading, error }] = useDetachCouponMutation({
 *   variables: {
 *   },
 * });
 */
export function useDetachCouponMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DetachCouponMutation, DetachCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachCouponMutation, DetachCouponMutationVariables>(DetachCouponDocument, options);
      }
export type DetachCouponMutationHookResult = ReturnType<typeof useDetachCouponMutation>;
export type DetachCouponMutationResult = Apollo.MutationResult<DetachCouponMutation>;
export type DetachCouponMutationOptions = Apollo.BaseMutationOptions<DetachCouponMutation, DetachCouponMutationVariables>;
export const DetachGroupProfileDocument = gql`
    mutation DetachGroupProfile {
  detachGroupProfile {
    success
    message
    errorType
    auth {
      token
    }
  }
}
    `;
export type DetachGroupProfileMutationFn = Apollo.MutationFunction<DetachGroupProfileMutation, DetachGroupProfileMutationVariables>;

/**
 * __useDetachGroupProfileMutation__
 *
 * To run a mutation, you first call `useDetachGroupProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachGroupProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachGroupProfileMutation, { data, loading, error }] = useDetachGroupProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useDetachGroupProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DetachGroupProfileMutation, DetachGroupProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachGroupProfileMutation, DetachGroupProfileMutationVariables>(DetachGroupProfileDocument, options);
      }
export type DetachGroupProfileMutationHookResult = ReturnType<typeof useDetachGroupProfileMutation>;
export type DetachGroupProfileMutationResult = Apollo.MutationResult<DetachGroupProfileMutation>;
export type DetachGroupProfileMutationOptions = Apollo.BaseMutationOptions<DetachGroupProfileMutation, DetachGroupProfileMutationVariables>;
export const DetachSalesProfileDocument = gql`
    mutation DetachSalesProfile {
  detachSalesProfile {
    success
    message
    errorType
    auth {
      token
    }
  }
}
    `;
export type DetachSalesProfileMutationFn = Apollo.MutationFunction<DetachSalesProfileMutation, DetachSalesProfileMutationVariables>;

/**
 * __useDetachSalesProfileMutation__
 *
 * To run a mutation, you first call `useDetachSalesProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachSalesProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachSalesProfileMutation, { data, loading, error }] = useDetachSalesProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useDetachSalesProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DetachSalesProfileMutation, DetachSalesProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DetachSalesProfileMutation, DetachSalesProfileMutationVariables>(DetachSalesProfileDocument, options);
      }
export type DetachSalesProfileMutationHookResult = ReturnType<typeof useDetachSalesProfileMutation>;
export type DetachSalesProfileMutationResult = Apollo.MutationResult<DetachSalesProfileMutation>;
export type DetachSalesProfileMutationOptions = Apollo.BaseMutationOptions<DetachSalesProfileMutation, DetachSalesProfileMutationVariables>;
export const EpicPassValidateDocument = gql`
    query epicPassValidate($passId: String!) {
  epicPassValidate(passId: $passId) {
    valid
  }
}
    `;

/**
 * __useEpicPassValidateQuery__
 *
 * To run a query within a React component, call `useEpicPassValidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpicPassValidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpicPassValidateQuery({
 *   variables: {
 *      passId: // value for 'passId'
 *   },
 * });
 */
export function useEpicPassValidateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EpicPassValidateQuery, EpicPassValidateQueryVariables> & ({ variables: EpicPassValidateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EpicPassValidateQuery, EpicPassValidateQueryVariables>(EpicPassValidateDocument, options);
      }
export function useEpicPassValidateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EpicPassValidateQuery, EpicPassValidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EpicPassValidateQuery, EpicPassValidateQueryVariables>(EpicPassValidateDocument, options);
        }
export function useEpicPassValidateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EpicPassValidateQuery, EpicPassValidateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EpicPassValidateQuery, EpicPassValidateQueryVariables>(EpicPassValidateDocument, options);
        }
export type EpicPassValidateQueryHookResult = ReturnType<typeof useEpicPassValidateQuery>;
export type EpicPassValidateLazyQueryHookResult = ReturnType<typeof useEpicPassValidateLazyQuery>;
export type EpicPassValidateSuspenseQueryHookResult = ReturnType<typeof useEpicPassValidateSuspenseQuery>;
export type EpicPassValidateQueryResult = Apollo.QueryResult<EpicPassValidateQuery, EpicPassValidateQueryVariables>;
export const EpicPassValidateDateDocument = gql`
    query epicPassValidateDate($passId: String!, $pickupDate: String!) {
  epicPassValidateDate(passId: $passId, pickupDate: $pickupDate) {
    valid
  }
}
    `;

/**
 * __useEpicPassValidateDateQuery__
 *
 * To run a query within a React component, call `useEpicPassValidateDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpicPassValidateDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpicPassValidateDateQuery({
 *   variables: {
 *      passId: // value for 'passId'
 *      pickupDate: // value for 'pickupDate'
 *   },
 * });
 */
export function useEpicPassValidateDateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables> & ({ variables: EpicPassValidateDateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>(EpicPassValidateDateDocument, options);
      }
export function useEpicPassValidateDateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>(EpicPassValidateDateDocument, options);
        }
export function useEpicPassValidateDateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>(EpicPassValidateDateDocument, options);
        }
export type EpicPassValidateDateQueryHookResult = ReturnType<typeof useEpicPassValidateDateQuery>;
export type EpicPassValidateDateLazyQueryHookResult = ReturnType<typeof useEpicPassValidateDateLazyQuery>;
export type EpicPassValidateDateSuspenseQueryHookResult = ReturnType<typeof useEpicPassValidateDateSuspenseQuery>;
export type EpicPassValidateDateQueryResult = Apollo.QueryResult<EpicPassValidateDateQuery, EpicPassValidateDateQueryVariables>;
export const FareKeyLookupDocument = gql`
    query fareKeyLookup($displayAddress: String, $displayName: String, $googleObject: String, $typeString: String, $fareCode: String, $serviceAreaIds: [Int!], $sourceType: Int!) {
  fareKeyLookup(
    displayAddress: $displayAddress
    displayName: $displayName
    googleObject: $googleObject
    typeString: $typeString
    fareCode: $fareCode
    serviceAreaIds: $serviceAreaIds
    sourceType: $sourceType
  ) {
    ...FareKeyLookup
  }
}
    ${FareKeyLookupFragmentDoc}`;

/**
 * __useFareKeyLookupQuery__
 *
 * To run a query within a React component, call `useFareKeyLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useFareKeyLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFareKeyLookupQuery({
 *   variables: {
 *      displayAddress: // value for 'displayAddress'
 *      displayName: // value for 'displayName'
 *      googleObject: // value for 'googleObject'
 *      typeString: // value for 'typeString'
 *      fareCode: // value for 'fareCode'
 *      serviceAreaIds: // value for 'serviceAreaIds'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useFareKeyLookupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FareKeyLookupQuery, FareKeyLookupQueryVariables> & ({ variables: FareKeyLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FareKeyLookupQuery, FareKeyLookupQueryVariables>(FareKeyLookupDocument, options);
      }
export function useFareKeyLookupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FareKeyLookupQuery, FareKeyLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FareKeyLookupQuery, FareKeyLookupQueryVariables>(FareKeyLookupDocument, options);
        }
export function useFareKeyLookupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FareKeyLookupQuery, FareKeyLookupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FareKeyLookupQuery, FareKeyLookupQueryVariables>(FareKeyLookupDocument, options);
        }
export type FareKeyLookupQueryHookResult = ReturnType<typeof useFareKeyLookupQuery>;
export type FareKeyLookupLazyQueryHookResult = ReturnType<typeof useFareKeyLookupLazyQuery>;
export type FareKeyLookupSuspenseQueryHookResult = ReturnType<typeof useFareKeyLookupSuspenseQuery>;
export type FareKeyLookupQueryResult = Apollo.QueryResult<FareKeyLookupQuery, FareKeyLookupQueryVariables>;
export const FixedLocationTypesDocument = gql`
    query fixedLocationTypes($hidePuds: Boolean, $pudId: Int, $serviceAreaId: Int) {
  fixedLocationTypes(
    hidePuds: $hidePuds
    pudId: $pudId
    serviceAreaId: $serviceAreaId
  ) {
    ...FixedLocationType
  }
}
    ${FixedLocationTypeFragmentDoc}`;

/**
 * __useFixedLocationTypesQuery__
 *
 * To run a query within a React component, call `useFixedLocationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFixedLocationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFixedLocationTypesQuery({
 *   variables: {
 *      hidePuds: // value for 'hidePuds'
 *      pudId: // value for 'pudId'
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useFixedLocationTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>(FixedLocationTypesDocument, options);
      }
export function useFixedLocationTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>(FixedLocationTypesDocument, options);
        }
export function useFixedLocationTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>(FixedLocationTypesDocument, options);
        }
export type FixedLocationTypesQueryHookResult = ReturnType<typeof useFixedLocationTypesQuery>;
export type FixedLocationTypesLazyQueryHookResult = ReturnType<typeof useFixedLocationTypesLazyQuery>;
export type FixedLocationTypesSuspenseQueryHookResult = ReturnType<typeof useFixedLocationTypesSuspenseQuery>;
export type FixedLocationTypesQueryResult = Apollo.QueryResult<FixedLocationTypesQuery, FixedLocationTypesQueryVariables>;
export const FrequentRiderPointsDocument = gql`
    query frequentRiderPoints {
  frequentRiderPoints {
    ...FrequentRiderPoints
  }
}
    ${FrequentRiderPointsFragmentDoc}`;

/**
 * __useFrequentRiderPointsQuery__
 *
 * To run a query within a React component, call `useFrequentRiderPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrequentRiderPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrequentRiderPointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrequentRiderPointsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>(FrequentRiderPointsDocument, options);
      }
export function useFrequentRiderPointsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>(FrequentRiderPointsDocument, options);
        }
export function useFrequentRiderPointsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>(FrequentRiderPointsDocument, options);
        }
export type FrequentRiderPointsQueryHookResult = ReturnType<typeof useFrequentRiderPointsQuery>;
export type FrequentRiderPointsLazyQueryHookResult = ReturnType<typeof useFrequentRiderPointsLazyQuery>;
export type FrequentRiderPointsSuspenseQueryHookResult = ReturnType<typeof useFrequentRiderPointsSuspenseQuery>;
export type FrequentRiderPointsQueryResult = Apollo.QueryResult<FrequentRiderPointsQuery, FrequentRiderPointsQueryVariables>;
export const FrequentRiderProgramPurchaseDocument = gql`
    mutation FrequentRiderProgramPurchase($booking: FrequentRiderProgramPurchaseType!, $frpProgramId: Int!, $frpProgramCost: Float, $frpProgramQuantity: Int, $frpProgramStartDate: String, $frpProgramEndDate: String, $sourceType: Int) {
  frequentRiderProgramPurchase(
    booking: $booking
    frpProgramId: $frpProgramId
    frpProgramCost: $frpProgramCost
    frpProgramQuantity: $frpProgramQuantity
    frpProgramStartDate: $frpProgramStartDate
    frpProgramEndDate: $frpProgramEndDate
    sourceType: $sourceType
  ) {
    success
    errorType
    message
    resId
  }
}
    `;
export type FrequentRiderProgramPurchaseMutationFn = Apollo.MutationFunction<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>;

/**
 * __useFrequentRiderProgramPurchaseMutation__
 *
 * To run a mutation, you first call `useFrequentRiderProgramPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFrequentRiderProgramPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [frequentRiderProgramPurchaseMutation, { data, loading, error }] = useFrequentRiderProgramPurchaseMutation({
 *   variables: {
 *      booking: // value for 'booking'
 *      frpProgramId: // value for 'frpProgramId'
 *      frpProgramCost: // value for 'frpProgramCost'
 *      frpProgramQuantity: // value for 'frpProgramQuantity'
 *      frpProgramStartDate: // value for 'frpProgramStartDate'
 *      frpProgramEndDate: // value for 'frpProgramEndDate'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useFrequentRiderProgramPurchaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>(FrequentRiderProgramPurchaseDocument, options);
      }
export type FrequentRiderProgramPurchaseMutationHookResult = ReturnType<typeof useFrequentRiderProgramPurchaseMutation>;
export type FrequentRiderProgramPurchaseMutationResult = Apollo.MutationResult<FrequentRiderProgramPurchaseMutation>;
export type FrequentRiderProgramPurchaseMutationOptions = Apollo.BaseMutationOptions<FrequentRiderProgramPurchaseMutation, FrequentRiderProgramPurchaseMutationVariables>;
export const FrequentRiderProgramsDocument = gql`
    query frequentRiderPrograms($redeemableForDate: String) {
  frequentRiderPrograms(redeemableForDate: $redeemableForDate) {
    ...FrequentRiderProgramFragment
  }
}
    ${FrequentRiderProgramFragmentFragmentDoc}`;

/**
 * __useFrequentRiderProgramsQuery__
 *
 * To run a query within a React component, call `useFrequentRiderProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrequentRiderProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrequentRiderProgramsQuery({
 *   variables: {
 *      redeemableForDate: // value for 'redeemableForDate'
 *   },
 * });
 */
export function useFrequentRiderProgramsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>(FrequentRiderProgramsDocument, options);
      }
export function useFrequentRiderProgramsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>(FrequentRiderProgramsDocument, options);
        }
export function useFrequentRiderProgramsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>(FrequentRiderProgramsDocument, options);
        }
export type FrequentRiderProgramsQueryHookResult = ReturnType<typeof useFrequentRiderProgramsQuery>;
export type FrequentRiderProgramsLazyQueryHookResult = ReturnType<typeof useFrequentRiderProgramsLazyQuery>;
export type FrequentRiderProgramsSuspenseQueryHookResult = ReturnType<typeof useFrequentRiderProgramsSuspenseQuery>;
export type FrequentRiderProgramsQueryResult = Apollo.QueryResult<FrequentRiderProgramsQuery, FrequentRiderProgramsQueryVariables>;
export const LocationDocument = gql`
    query location($fareCode: String!, $serviceAreaId: Int) {
  location(fareCode: $fareCode, serviceAreaId: $serviceAreaId) {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useLocationQuery__
 *
 * To run a query within a React component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationQuery({
 *   variables: {
 *      fareCode: // value for 'fareCode'
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useLocationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocationQuery, LocationQueryVariables> & ({ variables: LocationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
      }
export function useLocationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export function useLocationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationQuery, LocationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationQuery, LocationQueryVariables>(LocationDocument, options);
        }
export type LocationQueryHookResult = ReturnType<typeof useLocationQuery>;
export type LocationLazyQueryHookResult = ReturnType<typeof useLocationLazyQuery>;
export type LocationSuspenseQueryHookResult = ReturnType<typeof useLocationSuspenseQuery>;
export type LocationQueryResult = Apollo.QueryResult<LocationQuery, LocationQueryVariables>;
export const LocationListDocument = gql`
    query locationList($locationType: String!, $page: Int, $count: Int, $search: String, $serviceAreaId: Int) {
  locationList(
    locationType: $locationType
    page: $page
    count: $count
    search: $search
    serviceAreaId: $serviceAreaId
  ) {
    locations {
      ...Location
    }
    pages
    totalItems
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useLocationListQuery__
 *
 * To run a query within a React component, call `useLocationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationListQuery({
 *   variables: {
 *      locationType: // value for 'locationType'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      search: // value for 'search'
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useLocationListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LocationListQuery, LocationListQueryVariables> & ({ variables: LocationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
      }
export function useLocationListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
        }
export function useLocationListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationListQuery, LocationListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationListQuery, LocationListQueryVariables>(LocationListDocument, options);
        }
export type LocationListQueryHookResult = ReturnType<typeof useLocationListQuery>;
export type LocationListLazyQueryHookResult = ReturnType<typeof useLocationListLazyQuery>;
export type LocationListSuspenseQueryHookResult = ReturnType<typeof useLocationListSuspenseQuery>;
export type LocationListQueryResult = Apollo.QueryResult<LocationListQuery, LocationListQueryVariables>;
export const LocationsForAutocompleteDocument = gql`
    query locationsForAutocomplete($search: String, $serviceAreaId: Int) {
  locationsForAutocomplete(search: $search, serviceAreaId: $serviceAreaId) {
    ...AutocompleteLocation
  }
}
    ${AutocompleteLocationFragmentDoc}`;

/**
 * __useLocationsForAutocompleteQuery__
 *
 * To run a query within a React component, call `useLocationsForAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsForAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsForAutocompleteQuery({
 *   variables: {
 *      search: // value for 'search'
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function useLocationsForAutocompleteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>(LocationsForAutocompleteDocument, options);
      }
export function useLocationsForAutocompleteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>(LocationsForAutocompleteDocument, options);
        }
export function useLocationsForAutocompleteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>(LocationsForAutocompleteDocument, options);
        }
export type LocationsForAutocompleteQueryHookResult = ReturnType<typeof useLocationsForAutocompleteQuery>;
export type LocationsForAutocompleteLazyQueryHookResult = ReturnType<typeof useLocationsForAutocompleteLazyQuery>;
export type LocationsForAutocompleteSuspenseQueryHookResult = ReturnType<typeof useLocationsForAutocompleteSuspenseQuery>;
export type LocationsForAutocompleteQueryResult = Apollo.QueryResult<LocationsForAutocompleteQuery, LocationsForAutocompleteQueryVariables>;
export const LocationsForAutocompleteUniversalDocument = gql`
    query locationsForAutocompleteUniversal {
  locationsForAutocomplete(returnAll: true) {
    ...AutocompleteLocationUniversal
  }
}
    ${AutocompleteLocationUniversalFragmentDoc}`;

/**
 * __useLocationsForAutocompleteUniversalQuery__
 *
 * To run a query within a React component, call `useLocationsForAutocompleteUniversalQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsForAutocompleteUniversalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsForAutocompleteUniversalQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsForAutocompleteUniversalQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>(LocationsForAutocompleteUniversalDocument, options);
      }
export function useLocationsForAutocompleteUniversalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>(LocationsForAutocompleteUniversalDocument, options);
        }
export function useLocationsForAutocompleteUniversalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>(LocationsForAutocompleteUniversalDocument, options);
        }
export type LocationsForAutocompleteUniversalQueryHookResult = ReturnType<typeof useLocationsForAutocompleteUniversalQuery>;
export type LocationsForAutocompleteUniversalLazyQueryHookResult = ReturnType<typeof useLocationsForAutocompleteUniversalLazyQuery>;
export type LocationsForAutocompleteUniversalSuspenseQueryHookResult = ReturnType<typeof useLocationsForAutocompleteUniversalSuspenseQuery>;
export type LocationsForAutocompleteUniversalQueryResult = Apollo.QueryResult<LocationsForAutocompleteUniversalQuery, LocationsForAutocompleteUniversalQueryVariables>;
export const LoginUserProfileDocument = gql`
    mutation LoginUserProfile($emailAddress: String!, $password: String!) {
  loginUserProfile(emailAddress: $emailAddress, password: $password) {
    errorType
    success
    message
    auth {
      token
    }
  }
}
    `;
export type LoginUserProfileMutationFn = Apollo.MutationFunction<LoginUserProfileMutation, LoginUserProfileMutationVariables>;

/**
 * __useLoginUserProfileMutation__
 *
 * To run a mutation, you first call `useLoginUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginUserProfileMutation, { data, loading, error }] = useLoginUserProfileMutation({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginUserProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LoginUserProfileMutation, LoginUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LoginUserProfileMutation, LoginUserProfileMutationVariables>(LoginUserProfileDocument, options);
      }
export type LoginUserProfileMutationHookResult = ReturnType<typeof useLoginUserProfileMutation>;
export type LoginUserProfileMutationResult = Apollo.MutationResult<LoginUserProfileMutation>;
export type LoginUserProfileMutationOptions = Apollo.BaseMutationOptions<LoginUserProfileMutation, LoginUserProfileMutationVariables>;
export const LogoutUserProfileDocument = gql`
    mutation LogoutUserProfile {
  logoutUserProfile {
    success
    message
    errorType
    auth {
      token
    }
  }
}
    `;
export type LogoutUserProfileMutationFn = Apollo.MutationFunction<LogoutUserProfileMutation, LogoutUserProfileMutationVariables>;

/**
 * __useLogoutUserProfileMutation__
 *
 * To run a mutation, you first call `useLogoutUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutUserProfileMutation, { data, loading, error }] = useLogoutUserProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutUserProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LogoutUserProfileMutation, LogoutUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LogoutUserProfileMutation, LogoutUserProfileMutationVariables>(LogoutUserProfileDocument, options);
      }
export type LogoutUserProfileMutationHookResult = ReturnType<typeof useLogoutUserProfileMutation>;
export type LogoutUserProfileMutationResult = Apollo.MutationResult<LogoutUserProfileMutation>;
export type LogoutUserProfileMutationOptions = Apollo.BaseMutationOptions<LogoutUserProfileMutation, LogoutUserProfileMutationVariables>;
export const PassengerTypesDocument = gql`
    query passengerTypes($passengerTypesAlias: String, $serviceAreaId: Int) {
  passengerTypes(
    passengerTypesAlias: $passengerTypesAlias
    serviceAreaId: $serviceAreaId
  ) {
    ...Passenger
  }
}
    ${PassengerFragmentDoc}`;

/**
 * __usePassengerTypesQuery__
 *
 * To run a query within a React component, call `usePassengerTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePassengerTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePassengerTypesQuery({
 *   variables: {
 *      passengerTypesAlias: // value for 'passengerTypesAlias'
 *      serviceAreaId: // value for 'serviceAreaId'
 *   },
 * });
 */
export function usePassengerTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PassengerTypesQuery, PassengerTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PassengerTypesQuery, PassengerTypesQueryVariables>(PassengerTypesDocument, options);
      }
export function usePassengerTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PassengerTypesQuery, PassengerTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PassengerTypesQuery, PassengerTypesQueryVariables>(PassengerTypesDocument, options);
        }
export function usePassengerTypesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PassengerTypesQuery, PassengerTypesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PassengerTypesQuery, PassengerTypesQueryVariables>(PassengerTypesDocument, options);
        }
export type PassengerTypesQueryHookResult = ReturnType<typeof usePassengerTypesQuery>;
export type PassengerTypesLazyQueryHookResult = ReturnType<typeof usePassengerTypesLazyQuery>;
export type PassengerTypesSuspenseQueryHookResult = ReturnType<typeof usePassengerTypesSuspenseQuery>;
export type PassengerTypesQueryResult = Apollo.QueryResult<PassengerTypesQuery, PassengerTypesQueryVariables>;
export const ProcessPidDocument = gql`
    mutation processPid($pid: String, $forceGroup: Boolean) {
  processPid(pid: $pid, forceGroup: $forceGroup) {
    success
    message
    mode
    decryptedParams
    auth {
      token
    }
  }
}
    `;
export type ProcessPidMutationFn = Apollo.MutationFunction<ProcessPidMutation, ProcessPidMutationVariables>;

/**
 * __useProcessPidMutation__
 *
 * To run a mutation, you first call `useProcessPidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessPidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processPidMutation, { data, loading, error }] = useProcessPidMutation({
 *   variables: {
 *      pid: // value for 'pid'
 *      forceGroup: // value for 'forceGroup'
 *   },
 * });
 */
export function useProcessPidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProcessPidMutation, ProcessPidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProcessPidMutation, ProcessPidMutationVariables>(ProcessPidDocument, options);
      }
export type ProcessPidMutationHookResult = ReturnType<typeof useProcessPidMutation>;
export type ProcessPidMutationResult = Apollo.MutationResult<ProcessPidMutation>;
export type ProcessPidMutationOptions = Apollo.BaseMutationOptions<ProcessPidMutation, ProcessPidMutationVariables>;
export const ProfileAddDocument = gql`
    mutation profileAdd($email: String, $webId: String, $linkedReservations: [String!], $name: String, $password: String, $telephone: String, $groupId: Int) {
  profileAdd(
    input: {email: $email, webId: $webId, linkedReservations: $linkedReservations, name: $name, password: $password, telephone: $telephone, groupId: $groupId}
  ) {
    errorType
    message
    profileId
    success
    auth {
      token
    }
  }
}
    `;
export type ProfileAddMutationFn = Apollo.MutationFunction<ProfileAddMutation, ProfileAddMutationVariables>;

/**
 * __useProfileAddMutation__
 *
 * To run a mutation, you first call `useProfileAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileAddMutation, { data, loading, error }] = useProfileAddMutation({
 *   variables: {
 *      email: // value for 'email'
 *      webId: // value for 'webId'
 *      linkedReservations: // value for 'linkedReservations'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *      telephone: // value for 'telephone'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useProfileAddMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProfileAddMutation, ProfileAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProfileAddMutation, ProfileAddMutationVariables>(ProfileAddDocument, options);
      }
export type ProfileAddMutationHookResult = ReturnType<typeof useProfileAddMutation>;
export type ProfileAddMutationResult = Apollo.MutationResult<ProfileAddMutation>;
export type ProfileAddMutationOptions = Apollo.BaseMutationOptions<ProfileAddMutation, ProfileAddMutationVariables>;
export const ProfilePreferredLocationsDocument = gql`
    query profilePreferredLocations {
  profilePreferredLocations {
    ...Location
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useProfilePreferredLocationsQuery__
 *
 * To run a query within a React component, call `useProfilePreferredLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePreferredLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePreferredLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfilePreferredLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>(ProfilePreferredLocationsDocument, options);
      }
export function useProfilePreferredLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>(ProfilePreferredLocationsDocument, options);
        }
export function useProfilePreferredLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>(ProfilePreferredLocationsDocument, options);
        }
export type ProfilePreferredLocationsQueryHookResult = ReturnType<typeof useProfilePreferredLocationsQuery>;
export type ProfilePreferredLocationsLazyQueryHookResult = ReturnType<typeof useProfilePreferredLocationsLazyQuery>;
export type ProfilePreferredLocationsSuspenseQueryHookResult = ReturnType<typeof useProfilePreferredLocationsSuspenseQuery>;
export type ProfilePreferredLocationsQueryResult = Apollo.QueryResult<ProfilePreferredLocationsQuery, ProfilePreferredLocationsQueryVariables>;
export const ProfileReservationsDocument = gql`
    query profileReservations($dateRange: String) {
  profileReservations(dateRange: $dateRange) {
    id
    resId
    resIdInternal
    cancelled
    bagCount
    pickup {
      ...Location
    }
    dropoff {
      ...Location
    }
    service {
      selectedTime {
        pickupTime
      }
    }
    passengers {
      field
      value
    }
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useProfileReservationsQuery__
 *
 * To run a query within a React component, call `useProfileReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileReservationsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useProfileReservationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileReservationsQuery, ProfileReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProfileReservationsQuery, ProfileReservationsQueryVariables>(ProfileReservationsDocument, options);
      }
export function useProfileReservationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileReservationsQuery, ProfileReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProfileReservationsQuery, ProfileReservationsQueryVariables>(ProfileReservationsDocument, options);
        }
export function useProfileReservationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProfileReservationsQuery, ProfileReservationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProfileReservationsQuery, ProfileReservationsQueryVariables>(ProfileReservationsDocument, options);
        }
export type ProfileReservationsQueryHookResult = ReturnType<typeof useProfileReservationsQuery>;
export type ProfileReservationsLazyQueryHookResult = ReturnType<typeof useProfileReservationsLazyQuery>;
export type ProfileReservationsSuspenseQueryHookResult = ReturnType<typeof useProfileReservationsSuspenseQuery>;
export type ProfileReservationsQueryResult = Apollo.QueryResult<ProfileReservationsQuery, ProfileReservationsQueryVariables>;
export const PudPeopleDocument = gql`
    query pudPeople($serviceAreaId: Int, $showToken: Boolean, $tokenGroup: String!) {
  pudPeople {
    id
    name
    address
  }
  config {
    pudsAsPeople
  }
  content(
    serviceAreaId: $serviceAreaId
    showToken: $showToken
    tokenGroup: $tokenGroup
  ) {
    id
    bePudPersonLabel
    beSelectNoOptions
  }
}
    `;

/**
 * __usePudPeopleQuery__
 *
 * To run a query within a React component, call `usePudPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `usePudPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePudPeopleQuery({
 *   variables: {
 *      serviceAreaId: // value for 'serviceAreaId'
 *      showToken: // value for 'showToken'
 *      tokenGroup: // value for 'tokenGroup'
 *   },
 * });
 */
export function usePudPeopleQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PudPeopleQuery, PudPeopleQueryVariables> & ({ variables: PudPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PudPeopleQuery, PudPeopleQueryVariables>(PudPeopleDocument, options);
      }
export function usePudPeopleLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PudPeopleQuery, PudPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PudPeopleQuery, PudPeopleQueryVariables>(PudPeopleDocument, options);
        }
export function usePudPeopleSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PudPeopleQuery, PudPeopleQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PudPeopleQuery, PudPeopleQueryVariables>(PudPeopleDocument, options);
        }
export type PudPeopleQueryHookResult = ReturnType<typeof usePudPeopleQuery>;
export type PudPeopleLazyQueryHookResult = ReturnType<typeof usePudPeopleLazyQuery>;
export type PudPeopleSuspenseQueryHookResult = ReturnType<typeof usePudPeopleSuspenseQuery>;
export type PudPeopleQueryResult = Apollo.QueryResult<PudPeopleQuery, PudPeopleQueryVariables>;
export const ReferralLinksDocument = gql`
    query referralLinks($flightCity: String) {
  referralLinks(flightCity: $flightCity) {
    ...ReferralLink
  }
}
    ${ReferralLinkFragmentDoc}`;

/**
 * __useReferralLinksQuery__
 *
 * To run a query within a React component, call `useReferralLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralLinksQuery({
 *   variables: {
 *      flightCity: // value for 'flightCity'
 *   },
 * });
 */
export function useReferralLinksQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReferralLinksQuery, ReferralLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, options);
      }
export function useReferralLinksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReferralLinksQuery, ReferralLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, options);
        }
export function useReferralLinksSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferralLinksQuery, ReferralLinksQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReferralLinksQuery, ReferralLinksQueryVariables>(ReferralLinksDocument, options);
        }
export type ReferralLinksQueryHookResult = ReturnType<typeof useReferralLinksQuery>;
export type ReferralLinksLazyQueryHookResult = ReturnType<typeof useReferralLinksLazyQuery>;
export type ReferralLinksSuspenseQueryHookResult = ReturnType<typeof useReferralLinksSuspenseQuery>;
export type ReferralLinksQueryResult = Apollo.QueryResult<ReferralLinksQuery, ReferralLinksQueryVariables>;
export const RepriceServiceDocument = gql`
    mutation RepriceService($recalcEntireFare: Boolean, $res: ServicesInput!, $sourceType: Int) {
  repriceService(
    res: $res
    recalcEntireFare: $recalcEntireFare
    sourceType: $sourceType
  ) {
    success
    message
    errorType
    reprice {
      bagCountMax
      fareDisplay
      gratuityFare
      originalFare
      fareComponents {
        field
        value
      }
      payments {
        items {
          paymentAmount
          points
          programId
          type
        }
        totalPaymentAmount
        amountDue
      }
      times {
        ...ServiceTime
      }
      webSubfares {
        field
        value
      }
    }
  }
}
    ${ServiceTimeFragmentDoc}`;
export type RepriceServiceMutationFn = Apollo.MutationFunction<RepriceServiceMutation, RepriceServiceMutationVariables>;

/**
 * __useRepriceServiceMutation__
 *
 * To run a mutation, you first call `useRepriceServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRepriceServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [repriceServiceMutation, { data, loading, error }] = useRepriceServiceMutation({
 *   variables: {
 *      recalcEntireFare: // value for 'recalcEntireFare'
 *      res: // value for 'res'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useRepriceServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RepriceServiceMutation, RepriceServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RepriceServiceMutation, RepriceServiceMutationVariables>(RepriceServiceDocument, options);
      }
export type RepriceServiceMutationHookResult = ReturnType<typeof useRepriceServiceMutation>;
export type RepriceServiceMutationResult = Apollo.MutationResult<RepriceServiceMutation>;
export type RepriceServiceMutationOptions = Apollo.BaseMutationOptions<RepriceServiceMutation, RepriceServiceMutationVariables>;
export const ReservationDocument = gql`
    query reservation($reservationId: Int, $pid: String) {
  reservation(reservationId: $reservationId, pid: $pid) {
    auth {
      token
    }
    ...ReservationFragment
  }
}
    ${ReservationFragmentFragmentDoc}`;

/**
 * __useReservationQuery__
 *
 * To run a query within a React component, call `useReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationQuery({
 *   variables: {
 *      reservationId: // value for 'reservationId'
 *      pid: // value for 'pid'
 *   },
 * });
 */
export function useReservationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
      }
export function useReservationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
        }
export function useReservationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReservationQuery, ReservationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReservationQuery, ReservationQueryVariables>(ReservationDocument, options);
        }
export type ReservationQueryHookResult = ReturnType<typeof useReservationQuery>;
export type ReservationLazyQueryHookResult = ReturnType<typeof useReservationLazyQuery>;
export type ReservationSuspenseQueryHookResult = ReturnType<typeof useReservationSuspenseQuery>;
export type ReservationQueryResult = Apollo.QueryResult<ReservationQuery, ReservationQueryVariables>;
export const SavePasswordDocument = gql`
    mutation SavePassword($currentPassword: String!, $newPassword: String!) {
  savePassword(currentPassword: $currentPassword, newPassword: $newPassword) {
    success
    errorMessage
    message
    errorType
  }
}
    `;
export type SavePasswordMutationFn = Apollo.MutationFunction<SavePasswordMutation, SavePasswordMutationVariables>;

/**
 * __useSavePasswordMutation__
 *
 * To run a mutation, you first call `useSavePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePasswordMutation, { data, loading, error }] = useSavePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useSavePasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePasswordMutation, SavePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePasswordMutation, SavePasswordMutationVariables>(SavePasswordDocument, options);
      }
export type SavePasswordMutationHookResult = ReturnType<typeof useSavePasswordMutation>;
export type SavePasswordMutationResult = Apollo.MutationResult<SavePasswordMutation>;
export type SavePasswordMutationOptions = Apollo.BaseMutationOptions<SavePasswordMutation, SavePasswordMutationVariables>;
export const SavePasswordWithPidDocument = gql`
    mutation savePasswordWithPid($password: String!, $pid: String!) {
  savePasswordWithPid(password: $password, pid: $pid) {
    errorMessage
    success
  }
}
    `;
export type SavePasswordWithPidMutationFn = Apollo.MutationFunction<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>;

/**
 * __useSavePasswordWithPidMutation__
 *
 * To run a mutation, you first call `useSavePasswordWithPidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePasswordWithPidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePasswordWithPidMutation, { data, loading, error }] = useSavePasswordWithPidMutation({
 *   variables: {
 *      password: // value for 'password'
 *      pid: // value for 'pid'
 *   },
 * });
 */
export function useSavePasswordWithPidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>(SavePasswordWithPidDocument, options);
      }
export type SavePasswordWithPidMutationHookResult = ReturnType<typeof useSavePasswordWithPidMutation>;
export type SavePasswordWithPidMutationResult = Apollo.MutationResult<SavePasswordWithPidMutation>;
export type SavePasswordWithPidMutationOptions = Apollo.BaseMutationOptions<SavePasswordWithPidMutation, SavePasswordWithPidMutationVariables>;
export const SendPasswordResetDocument = gql`
    mutation SendPasswordReset($username: String!, $resetPasswordUrl: String!) {
  sendPasswordReset(username: $username, resetPasswordUrl: $resetPasswordUrl) {
    errorType
    success
    message
  }
}
    `;
export type SendPasswordResetMutationFn = Apollo.MutationFunction<SendPasswordResetMutation, SendPasswordResetMutationVariables>;

/**
 * __useSendPasswordResetMutation__
 *
 * To run a mutation, you first call `useSendPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordResetMutation, { data, loading, error }] = useSendPasswordResetMutation({
 *   variables: {
 *      username: // value for 'username'
 *      resetPasswordUrl: // value for 'resetPasswordUrl'
 *   },
 * });
 */
export function useSendPasswordResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPasswordResetMutation, SendPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendPasswordResetMutation, SendPasswordResetMutationVariables>(SendPasswordResetDocument, options);
      }
export type SendPasswordResetMutationHookResult = ReturnType<typeof useSendPasswordResetMutation>;
export type SendPasswordResetMutationResult = Apollo.MutationResult<SendPasswordResetMutation>;
export type SendPasswordResetMutationOptions = Apollo.BaseMutationOptions<SendPasswordResetMutation, SendPasswordResetMutationVariables>;
export const ExtrasDocument = gql`
    query extras($serviceAreaId: Int, $serviceExtrasAlias: String) {
  serviceExtras(
    serviceAreaId: $serviceAreaId
    serviceExtrasAlias: $serviceExtrasAlias
  ) {
    ...ServiceExtra
  }
}
    ${ServiceExtraFragmentDoc}`;

/**
 * __useExtrasQuery__
 *
 * To run a query within a React component, call `useExtrasQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtrasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtrasQuery({
 *   variables: {
 *      serviceAreaId: // value for 'serviceAreaId'
 *      serviceExtrasAlias: // value for 'serviceExtrasAlias'
 *   },
 * });
 */
export function useExtrasQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ExtrasQuery, ExtrasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExtrasQuery, ExtrasQueryVariables>(ExtrasDocument, options);
      }
export function useExtrasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExtrasQuery, ExtrasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExtrasQuery, ExtrasQueryVariables>(ExtrasDocument, options);
        }
export function useExtrasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExtrasQuery, ExtrasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExtrasQuery, ExtrasQueryVariables>(ExtrasDocument, options);
        }
export type ExtrasQueryHookResult = ReturnType<typeof useExtrasQuery>;
export type ExtrasLazyQueryHookResult = ReturnType<typeof useExtrasLazyQuery>;
export type ExtrasSuspenseQueryHookResult = ReturnType<typeof useExtrasSuspenseQuery>;
export type ExtrasQueryResult = Apollo.QueryResult<ExtrasQuery, ExtrasQueryVariables>;
export const ServicesDocument = gql`
    query services($res: ServicesInput!, $sourceType: Int!) {
  services(res: $res, sourceType: $sourceType) {
    ...ServiceFragment
  }
}
    ${ServiceFragmentFragmentDoc}`;

/**
 * __useServicesQuery__
 *
 * To run a query within a React component, call `useServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesQuery({
 *   variables: {
 *      res: // value for 'res'
 *      sourceType: // value for 'sourceType'
 *   },
 * });
 */
export function useServicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ServicesQuery, ServicesQueryVariables> & ({ variables: ServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
      }
export function useServicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export function useServicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ServicesQuery, ServicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ServicesQuery, ServicesQueryVariables>(ServicesDocument, options);
        }
export type ServicesQueryHookResult = ReturnType<typeof useServicesQuery>;
export type ServicesLazyQueryHookResult = ReturnType<typeof useServicesLazyQuery>;
export type ServicesSuspenseQueryHookResult = ReturnType<typeof useServicesSuspenseQuery>;
export type ServicesQueryResult = Apollo.QueryResult<ServicesQuery, ServicesQueryVariables>;
export const SetPasswordForProfileDocument = gql`
    mutation SetPasswordForProfile($email: String!, $profileId: Int!, $password: String!, $name: String, $telephone: String, $linkedReservations: [String!]) {
  setPasswordForProfile(
    email: $email
    profileId: $profileId
    password: $password
    name: $name
    telephone: $telephone
    linkedReservations: $linkedReservations
  ) {
    success
    message
    errorMessage
    errorType
    profileId
  }
}
    `;
export type SetPasswordForProfileMutationFn = Apollo.MutationFunction<SetPasswordForProfileMutation, SetPasswordForProfileMutationVariables>;

/**
 * __useSetPasswordForProfileMutation__
 *
 * To run a mutation, you first call `useSetPasswordForProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordForProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordForProfileMutation, { data, loading, error }] = useSetPasswordForProfileMutation({
 *   variables: {
 *      email: // value for 'email'
 *      profileId: // value for 'profileId'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *      telephone: // value for 'telephone'
 *      linkedReservations: // value for 'linkedReservations'
 *   },
 * });
 */
export function useSetPasswordForProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPasswordForProfileMutation, SetPasswordForProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPasswordForProfileMutation, SetPasswordForProfileMutationVariables>(SetPasswordForProfileDocument, options);
      }
export type SetPasswordForProfileMutationHookResult = ReturnType<typeof useSetPasswordForProfileMutation>;
export type SetPasswordForProfileMutationResult = Apollo.MutationResult<SetPasswordForProfileMutation>;
export type SetPasswordForProfileMutationOptions = Apollo.BaseMutationOptions<SetPasswordForProfileMutation, SetPasswordForProfileMutationVariables>;
export const SpecialInfoDocument = gql`
    query specialInfo($siAlias: String) {
  specialInfo(siAlias: $siAlias) {
    id
    defaultValue
    description
    fieldName
    fieldType
    label
    maxLength
    minLength
    raw
    required
  }
}
    `;

/**
 * __useSpecialInfoQuery__
 *
 * To run a query within a React component, call `useSpecialInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialInfoQuery({
 *   variables: {
 *      siAlias: // value for 'siAlias'
 *   },
 * });
 */
export function useSpecialInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SpecialInfoQuery, SpecialInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SpecialInfoQuery, SpecialInfoQueryVariables>(SpecialInfoDocument, options);
      }
export function useSpecialInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SpecialInfoQuery, SpecialInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SpecialInfoQuery, SpecialInfoQueryVariables>(SpecialInfoDocument, options);
        }
export function useSpecialInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SpecialInfoQuery, SpecialInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SpecialInfoQuery, SpecialInfoQueryVariables>(SpecialInfoDocument, options);
        }
export type SpecialInfoQueryHookResult = ReturnType<typeof useSpecialInfoQuery>;
export type SpecialInfoLazyQueryHookResult = ReturnType<typeof useSpecialInfoLazyQuery>;
export type SpecialInfoSuspenseQueryHookResult = ReturnType<typeof useSpecialInfoSuspenseQuery>;
export type SpecialInfoQueryResult = Apollo.QueryResult<SpecialInfoQuery, SpecialInfoQueryVariables>;
export const TokenizeDocument = gql`
    mutation Tokenize($ccNumber: String!, $ccExpiration: String!, $ccName: String, $ccPostalCode: String, $ccAddress: String) {
  tokenize(
    ccNumber: $ccNumber
    ccExpiration: $ccExpiration
    ccName: $ccName
    ccPostalCode: $ccPostalCode
    ccAddress: $ccAddress
  ) {
    error
    ccToken
    ccLast4
    ccExpiration
  }
}
    `;
export type TokenizeMutationFn = Apollo.MutationFunction<TokenizeMutation, TokenizeMutationVariables>;

/**
 * __useTokenizeMutation__
 *
 * To run a mutation, you first call `useTokenizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenizeMutation, { data, loading, error }] = useTokenizeMutation({
 *   variables: {
 *      ccNumber: // value for 'ccNumber'
 *      ccExpiration: // value for 'ccExpiration'
 *      ccName: // value for 'ccName'
 *      ccPostalCode: // value for 'ccPostalCode'
 *      ccAddress: // value for 'ccAddress'
 *   },
 * });
 */
export function useTokenizeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TokenizeMutation, TokenizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TokenizeMutation, TokenizeMutationVariables>(TokenizeDocument, options);
      }
export type TokenizeMutationHookResult = ReturnType<typeof useTokenizeMutation>;
export type TokenizeMutationResult = Apollo.MutationResult<TokenizeMutation>;
export type TokenizeMutationOptions = Apollo.BaseMutationOptions<TokenizeMutation, TokenizeMutationVariables>;
export const TokensDocument = gql`
    query tokens {
  tokens {
    ...Token
  }
}
    ${TokenFragmentDoc}`;

/**
 * __useTokensQuery__
 *
 * To run a query within a React component, call `useTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useTokensQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TokensQuery, TokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TokensQuery, TokensQueryVariables>(TokensDocument, options);
      }
export function useTokensLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TokensQuery, TokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TokensQuery, TokensQueryVariables>(TokensDocument, options);
        }
export function useTokensSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TokensQuery, TokensQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TokensQuery, TokensQueryVariables>(TokensDocument, options);
        }
export type TokensQueryHookResult = ReturnType<typeof useTokensQuery>;
export type TokensLazyQueryHookResult = ReturnType<typeof useTokensLazyQuery>;
export type TokensSuspenseQueryHookResult = ReturnType<typeof useTokensSuspenseQuery>;
export type TokensQueryResult = Apollo.QueryResult<TokensQuery, TokensQueryVariables>;
export const UserProfileDocument = gql`
    query userProfile {
  userProfile {
    ...ProfileFragment
  }
}
    ${ProfileFragmentFragmentDoc}`;

/**
 * __useUserProfileQuery__
 *
 * To run a query within a React component, call `useUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
      }
export function useUserProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export function useUserProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileQuery, UserProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfileQuery, UserProfileQueryVariables>(UserProfileDocument, options);
        }
export type UserProfileQueryHookResult = ReturnType<typeof useUserProfileQuery>;
export type UserProfileLazyQueryHookResult = ReturnType<typeof useUserProfileLazyQuery>;
export type UserProfileSuspenseQueryHookResult = ReturnType<typeof useUserProfileSuspenseQuery>;
export type UserProfileQueryResult = Apollo.QueryResult<UserProfileQuery, UserProfileQueryVariables>;
export const UserProfileAddCcDocument = gql`
    mutation UserProfileAddCc($ccNumber: String!, $ccExpiration: String!, $ccName: String!, $ccPostalCode: String, $ccAddress: String) {
  userProfileAddCc(
    ccNumber: $ccNumber
    ccExpiration: $ccExpiration
    ccName: $ccName
    ccPostalCode: $ccPostalCode
    ccAddress: $ccAddress
  ) {
    success
    errorMessage
  }
}
    `;
export type UserProfileAddCcMutationFn = Apollo.MutationFunction<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>;

/**
 * __useUserProfileAddCcMutation__
 *
 * To run a mutation, you first call `useUserProfileAddCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAddCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileAddCcMutation, { data, loading, error }] = useUserProfileAddCcMutation({
 *   variables: {
 *      ccNumber: // value for 'ccNumber'
 *      ccExpiration: // value for 'ccExpiration'
 *      ccName: // value for 'ccName'
 *      ccPostalCode: // value for 'ccPostalCode'
 *      ccAddress: // value for 'ccAddress'
 *   },
 * });
 */
export function useUserProfileAddCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>(UserProfileAddCcDocument, options);
      }
export type UserProfileAddCcMutationHookResult = ReturnType<typeof useUserProfileAddCcMutation>;
export type UserProfileAddCcMutationResult = Apollo.MutationResult<UserProfileAddCcMutation>;
export type UserProfileAddCcMutationOptions = Apollo.BaseMutationOptions<UserProfileAddCcMutation, UserProfileAddCcMutationVariables>;
export const UserProfileAddPudDocument = gql`
    mutation UserProfileAddPud($location: ProfilePudInput!) {
  userProfileAddPud(location: $location) {
    success
    errorType
    message
  }
}
    `;
export type UserProfileAddPudMutationFn = Apollo.MutationFunction<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>;

/**
 * __useUserProfileAddPudMutation__
 *
 * To run a mutation, you first call `useUserProfileAddPudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAddPudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileAddPudMutation, { data, loading, error }] = useUserProfileAddPudMutation({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUserProfileAddPudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>(UserProfileAddPudDocument, options);
      }
export type UserProfileAddPudMutationHookResult = ReturnType<typeof useUserProfileAddPudMutation>;
export type UserProfileAddPudMutationResult = Apollo.MutationResult<UserProfileAddPudMutation>;
export type UserProfileAddPudMutationOptions = Apollo.BaseMutationOptions<UserProfileAddPudMutation, UserProfileAddPudMutationVariables>;
export const UserProfileAddValpayCcDocument = gql`
    mutation UserProfileAddValpayCc($encryptedCardNumber: String!, $encryptedExpiryMonth: String!, $encryptedExpiryYear: String!, $encryptedSecurityCode: String!, $ccCardHolderName: String, $ccPostalCode: String) {
  userProfileAddValpayCc(
    encryptedCardNumber: $encryptedCardNumber
    encryptedExpiryMonth: $encryptedExpiryMonth
    encryptedExpiryYear: $encryptedExpiryYear
    encryptedSecurityCode: $encryptedSecurityCode
    ccCardHolderName: $ccCardHolderName
    ccPostalCode: $ccPostalCode
  ) {
    success
    errorMessage
    errorType
    message
  }
}
    `;
export type UserProfileAddValpayCcMutationFn = Apollo.MutationFunction<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>;

/**
 * __useUserProfileAddValpayCcMutation__
 *
 * To run a mutation, you first call `useUserProfileAddValpayCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileAddValpayCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileAddValpayCcMutation, { data, loading, error }] = useUserProfileAddValpayCcMutation({
 *   variables: {
 *      encryptedCardNumber: // value for 'encryptedCardNumber'
 *      encryptedExpiryMonth: // value for 'encryptedExpiryMonth'
 *      encryptedExpiryYear: // value for 'encryptedExpiryYear'
 *      encryptedSecurityCode: // value for 'encryptedSecurityCode'
 *      ccCardHolderName: // value for 'ccCardHolderName'
 *      ccPostalCode: // value for 'ccPostalCode'
 *   },
 * });
 */
export function useUserProfileAddValpayCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>(UserProfileAddValpayCcDocument, options);
      }
export type UserProfileAddValpayCcMutationHookResult = ReturnType<typeof useUserProfileAddValpayCcMutation>;
export type UserProfileAddValpayCcMutationResult = Apollo.MutationResult<UserProfileAddValpayCcMutation>;
export type UserProfileAddValpayCcMutationOptions = Apollo.BaseMutationOptions<UserProfileAddValpayCcMutation, UserProfileAddValpayCcMutationVariables>;
export const UserProfileDeleteCcDocument = gql`
    mutation UserProfileDeleteCc($ccId: Int, $ccRefId: String, $ccToken: String, $ccLast4: String) {
  userProfileDeleteCc(
    ccId: $ccId
    ccRefId: $ccRefId
    ccToken: $ccToken
    ccLast4: $ccLast4
  ) {
    success
    message
    errorMessage
    errorType
  }
}
    `;
export type UserProfileDeleteCcMutationFn = Apollo.MutationFunction<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>;

/**
 * __useUserProfileDeleteCcMutation__
 *
 * To run a mutation, you first call `useUserProfileDeleteCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDeleteCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileDeleteCcMutation, { data, loading, error }] = useUserProfileDeleteCcMutation({
 *   variables: {
 *      ccId: // value for 'ccId'
 *      ccRefId: // value for 'ccRefId'
 *      ccToken: // value for 'ccToken'
 *      ccLast4: // value for 'ccLast4'
 *   },
 * });
 */
export function useUserProfileDeleteCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>(UserProfileDeleteCcDocument, options);
      }
export type UserProfileDeleteCcMutationHookResult = ReturnType<typeof useUserProfileDeleteCcMutation>;
export type UserProfileDeleteCcMutationResult = Apollo.MutationResult<UserProfileDeleteCcMutation>;
export type UserProfileDeleteCcMutationOptions = Apollo.BaseMutationOptions<UserProfileDeleteCcMutation, UserProfileDeleteCcMutationVariables>;
export const UserProfileDeletePudDocument = gql`
    mutation UserProfileDeletePud($locationId: Int!) {
  userProfileDeletePud(locationId: $locationId) {
    success
    errorMessage
  }
}
    `;
export type UserProfileDeletePudMutationFn = Apollo.MutationFunction<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>;

/**
 * __useUserProfileDeletePudMutation__
 *
 * To run a mutation, you first call `useUserProfileDeletePudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDeletePudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileDeletePudMutation, { data, loading, error }] = useUserProfileDeletePudMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useUserProfileDeletePudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>(UserProfileDeletePudDocument, options);
      }
export type UserProfileDeletePudMutationHookResult = ReturnType<typeof useUserProfileDeletePudMutation>;
export type UserProfileDeletePudMutationResult = Apollo.MutationResult<UserProfileDeletePudMutation>;
export type UserProfileDeletePudMutationOptions = Apollo.BaseMutationOptions<UserProfileDeletePudMutation, UserProfileDeletePudMutationVariables>;
export const UserProfileDeletePudCcDocument = gql`
    mutation UserProfileDeletePudCc($pudId: Int!, $ccId: Int!) {
  userProfileDeletePudCc(pudId: $pudId, ccId: $ccId) {
    success
    errorMessage
  }
}
    `;
export type UserProfileDeletePudCcMutationFn = Apollo.MutationFunction<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>;

/**
 * __useUserProfileDeletePudCcMutation__
 *
 * To run a mutation, you first call `useUserProfileDeletePudCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileDeletePudCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileDeletePudCcMutation, { data, loading, error }] = useUserProfileDeletePudCcMutation({
 *   variables: {
 *      pudId: // value for 'pudId'
 *      ccId: // value for 'ccId'
 *   },
 * });
 */
export function useUserProfileDeletePudCcMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>(UserProfileDeletePudCcDocument, options);
      }
export type UserProfileDeletePudCcMutationHookResult = ReturnType<typeof useUserProfileDeletePudCcMutation>;
export type UserProfileDeletePudCcMutationResult = Apollo.MutationResult<UserProfileDeletePudCcMutation>;
export type UserProfileDeletePudCcMutationOptions = Apollo.BaseMutationOptions<UserProfileDeletePudCcMutation, UserProfileDeletePudCcMutationVariables>;
export const UserProfileExistsDocument = gql`
    query userProfileExists($email: String!) {
  userProfileExists(email: $email) {
    id
    exists
    hasPassword
    profileId
  }
}
    `;

/**
 * __useUserProfileExistsQuery__
 *
 * To run a query within a React component, call `useUserProfileExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserProfileExistsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserProfileExistsQuery, UserProfileExistsQueryVariables> & ({ variables: UserProfileExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserProfileExistsQuery, UserProfileExistsQueryVariables>(UserProfileExistsDocument, options);
      }
export function useUserProfileExistsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserProfileExistsQuery, UserProfileExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserProfileExistsQuery, UserProfileExistsQueryVariables>(UserProfileExistsDocument, options);
        }
export function useUserProfileExistsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserProfileExistsQuery, UserProfileExistsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserProfileExistsQuery, UserProfileExistsQueryVariables>(UserProfileExistsDocument, options);
        }
export type UserProfileExistsQueryHookResult = ReturnType<typeof useUserProfileExistsQuery>;
export type UserProfileExistsLazyQueryHookResult = ReturnType<typeof useUserProfileExistsLazyQuery>;
export type UserProfileExistsSuspenseQueryHookResult = ReturnType<typeof useUserProfileExistsSuspenseQuery>;
export type UserProfileExistsQueryResult = Apollo.QueryResult<UserProfileExistsQuery, UserProfileExistsQueryVariables>;
export const UserProfileLinkGroupDocument = gql`
    mutation UserProfileLinkGroup($groupId: String, $clientId: String, $webId: String, $data1: String, $data2: String) {
  userProfileLinkGroup(
    groupId: $groupId
    clientId: $clientId
    webId: $webId
    data1: $data1
    data2: $data2
  ) {
    success
    message
    errorMessage
    errorType
  }
}
    `;
export type UserProfileLinkGroupMutationFn = Apollo.MutationFunction<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>;

/**
 * __useUserProfileLinkGroupMutation__
 *
 * To run a mutation, you first call `useUserProfileLinkGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileLinkGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileLinkGroupMutation, { data, loading, error }] = useUserProfileLinkGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      clientId: // value for 'clientId'
 *      webId: // value for 'webId'
 *      data1: // value for 'data1'
 *      data2: // value for 'data2'
 *   },
 * });
 */
export function useUserProfileLinkGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>(UserProfileLinkGroupDocument, options);
      }
export type UserProfileLinkGroupMutationHookResult = ReturnType<typeof useUserProfileLinkGroupMutation>;
export type UserProfileLinkGroupMutationResult = Apollo.MutationResult<UserProfileLinkGroupMutation>;
export type UserProfileLinkGroupMutationOptions = Apollo.BaseMutationOptions<UserProfileLinkGroupMutation, UserProfileLinkGroupMutationVariables>;
export const UserProfileUpdateDocument = gql`
    mutation UserProfileUpdate($contact: ContactUpdateInput, $linkedReservations: [String!]) {
  updateUserProfile(contact: $contact, linkedReservations: $linkedReservations) {
    success
    message
    errorMessage
  }
}
    `;
export type UserProfileUpdateMutationFn = Apollo.MutationFunction<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>;

/**
 * __useUserProfileUpdateMutation__
 *
 * To run a mutation, you first call `useUserProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileUpdateMutation, { data, loading, error }] = useUserProfileUpdateMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *      linkedReservations: // value for 'linkedReservations'
 *   },
 * });
 */
export function useUserProfileUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>(UserProfileUpdateDocument, options);
      }
export type UserProfileUpdateMutationHookResult = ReturnType<typeof useUserProfileUpdateMutation>;
export type UserProfileUpdateMutationResult = Apollo.MutationResult<UserProfileUpdateMutation>;
export type UserProfileUpdateMutationOptions = Apollo.BaseMutationOptions<UserProfileUpdateMutation, UserProfileUpdateMutationVariables>;
export const UserProfileUpdatePudDocument = gql`
    mutation UserProfileUpdatePud($pudId: Int!, $location: ProfilePudInput!) {
  userProfileUpdatePud(pudId: $pudId, location: $location) {
    success
    errorType
    message
  }
}
    `;
export type UserProfileUpdatePudMutationFn = Apollo.MutationFunction<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>;

/**
 * __useUserProfileUpdatePudMutation__
 *
 * To run a mutation, you first call `useUserProfileUpdatePudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileUpdatePudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileUpdatePudMutation, { data, loading, error }] = useUserProfileUpdatePudMutation({
 *   variables: {
 *      pudId: // value for 'pudId'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUserProfileUpdatePudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>(UserProfileUpdatePudDocument, options);
      }
export type UserProfileUpdatePudMutationHookResult = ReturnType<typeof useUserProfileUpdatePudMutation>;
export type UserProfileUpdatePudMutationResult = Apollo.MutationResult<UserProfileUpdatePudMutation>;
export type UserProfileUpdatePudMutationOptions = Apollo.BaseMutationOptions<UserProfileUpdatePudMutation, UserProfileUpdatePudMutationVariables>;
export const ValpayConfigDocument = gql`
    query valpayConfig($processorId: Int, $shopperReference: String) {
  valpayConfig(processorId: $processorId, shopperReference: $shopperReference) {
    id
    clientKey
    enabled
    environment
    error
    paymentMethods
  }
}
    `;

/**
 * __useValpayConfigQuery__
 *
 * To run a query within a React component, call `useValpayConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useValpayConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValpayConfigQuery({
 *   variables: {
 *      processorId: // value for 'processorId'
 *      shopperReference: // value for 'shopperReference'
 *   },
 * });
 */
export function useValpayConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
      }
export function useValpayConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
        }
export function useValpayConfigSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ValpayConfigQuery, ValpayConfigQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ValpayConfigQuery, ValpayConfigQueryVariables>(ValpayConfigDocument, options);
        }
export type ValpayConfigQueryHookResult = ReturnType<typeof useValpayConfigQuery>;
export type ValpayConfigLazyQueryHookResult = ReturnType<typeof useValpayConfigLazyQuery>;
export type ValpayConfigSuspenseQueryHookResult = ReturnType<typeof useValpayConfigSuspenseQuery>;
export type ValpayConfigQueryResult = Apollo.QueryResult<ValpayConfigQuery, ValpayConfigQueryVariables>;
export const VerifyResDocument = gql`
    mutation VerifyRes($resId: String!, $validationMode: String!, $validationValue: String!) {
  verifyRes(
    resId: $resId
    validationMode: $validationMode
    validationValue: $validationValue
  ) {
    errorType
    success
    message
    auth {
      token
    }
    resId
  }
}
    `;
export type VerifyResMutationFn = Apollo.MutationFunction<VerifyResMutation, VerifyResMutationVariables>;

/**
 * __useVerifyResMutation__
 *
 * To run a mutation, you first call `useVerifyResMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyResMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyResMutation, { data, loading, error }] = useVerifyResMutation({
 *   variables: {
 *      resId: // value for 'resId'
 *      validationMode: // value for 'validationMode'
 *      validationValue: // value for 'validationValue'
 *   },
 * });
 */
export function useVerifyResMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyResMutation, VerifyResMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyResMutation, VerifyResMutationVariables>(VerifyResDocument, options);
      }
export type VerifyResMutationHookResult = ReturnType<typeof useVerifyResMutation>;
export type VerifyResMutationResult = Apollo.MutationResult<VerifyResMutation>;
export type VerifyResMutationOptions = Apollo.BaseMutationOptions<VerifyResMutation, VerifyResMutationVariables>;